(() => {
  document.querySelectorAll('[data-agfx]').forEach((root) => {
    if (root.dataset.ready === '1') return;
    root.dataset.ready = '1';

    /* ========================================================
       UI INTELIGENTE — MODO TALHER / LASER
       ======================================================== */

    if (!document.getElementById('agfx-laser-mode-styles')) {
      const style =
        document.createElement('style');

      style.id =
        'agfx-laser-mode-styles';

      style.textContent = `
        .agfx.agfx--laser-product [data-curve] {
          display: none !important;
        }

        .agfx.agfx--laser-product [data-curve]
          + * {
          display: none !important;
        }

        .agfx.agfx--laser-product
        .agfx__control:has([data-curve]) {
          display: none !important;
        }

        .agfx__technique-card {
          margin-top: 10px;
          padding: 12px 13px;

          display: none;

          border:
            1px solid rgba(22,54,47,.10);

          border-radius: 12px;

          background:
            linear-gradient(
              135deg,
              #f7faf8 0%,
              #eef5f1 100%
            );
        }

        .agfx.agfx--laser-product
        .agfx__technique-card {
          display: block;
        }

        .agfx__technique-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 10px;
        }

        .agfx__technique-label {
          display: flex;
          align-items: center;
          gap: 7px;

          color: #16362f;

          font-size: 8px;
          font-weight: 900;

          letter-spacing: .09em;
          text-transform: uppercase;
        }

        .agfx__technique-dot {
          width: 7px;
          height: 7px;

          border-radius: 50%;

          background: #2a8b61;

          box-shadow:
            0 0 0 4px
            rgba(42,139,97,.10);
        }

        .agfx__technique-badge {
          padding: 4px 7px;

          border-radius: 999px;

          color: #fff;
          background: #16362f;

          font-size: 7px;
          font-weight: 900;

          letter-spacing: .06em;
          text-transform: uppercase;
        }

        .agfx__technique-title {
          margin: 9px 0 0;

          color: #1d2b26;

          font-size: 12px;
          line-height: 1.3;
          font-weight: 800;
        }

        .agfx__technique-copy {
          margin: 5px 0 0;

          color: #6f7974;

          font-size: 8.5px;
          line-height: 1.5;
        }

        .agfx__technique-hint {
          margin-top: 9px;
          padding-top: 9px;

          display: flex;
          gap: 7px;
          align-items: flex-start;

          border-top:
            1px solid rgba(22,54,47,.08);

          color: #52605a;

          font-size: 8px;
          line-height: 1.45;
        }

        .agfx__technique-hint strong {
          color: #26362f;
          font-weight: 800;
        }

        .agfx.agfx--laser-product
        .agfx__laser-button {
          color: #fff !important;

          background:
            linear-gradient(
              135deg,
              #16362f,
              #245448
            ) !important;

          border-color:
            #16362f !important;

          box-shadow:
            0 6px 16px
            rgba(22,54,47,.14);
        }

        .agfx.agfx--laser-product
        .agfx__laser-button::before {
          content: "✓";
          margin-right: 5px;
          font-size: 8px;
          font-weight: 900;
        }

        .agfx.agfx--laser-product
        .agfx__laser-button {
          cursor: default !important;
          opacity: 1 !important;
          pointer-events: none !important;
        }

        .agfx__technique-benefits {
          margin-top: 9px;

          display: flex;
          flex-wrap: wrap;
          gap: 5px;
        }

        .agfx__technique-benefit {
          padding: 4px 7px;

          border:
            1px solid rgba(22,54,47,.09);

          border-radius: 999px;

          color: #4e5d57;
          background: rgba(255,255,255,.72);

          font-size: 7px;
          font-weight: 800;
        }

        .agfx__adjust-handle {
          width: 100%;
          min-height: 36px;

          margin-top: 10px;

          display: flex;
          align-items: center;
          justify-content: center;
          gap: 6px;

          border:
            1px solid rgba(22,54,47,.16);

          border-radius: 9px;

          color: #16362f;
          background: #fff;

          font-size: 8px;
          font-weight: 900;

          letter-spacing: .035em;
          text-transform: uppercase;

          cursor: pointer;

          transition:
            transform .2s ease,
            background .2s ease,
            border-color .2s ease,
            box-shadow .2s ease;
        }

        .agfx__adjust-handle:hover {
          transform: translateY(-1px);

          border-color:
            rgba(22,54,47,.28);

          background: #f8faf8;

          box-shadow:
            0 7px 16px
            rgba(22,54,47,.07);
        }

        .agfx.agfx--laser-product
        .agfx__laser-preset-hidden {
          display: none !important;
        }

        .agfx.agfx--laser-product
        .agfx__quick {
          grid-template-columns:
            repeat(3, minmax(0,1fr))
            !important;
        }

        @media(max-width:650px) {
          .agfx.agfx--laser-product
          .agfx__quick {
            grid-template-columns:
              repeat(2,minmax(0,1fr))
              !important;
          }
        }
      `;

      document.head.appendChild(
        style
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.19 — TALHERES SOMENTE LASER
       ======================================================== */

    if (!document.getElementById('agfx-v519-laser-only')) {
      const laserOnlyStyle =
        document.createElement('style');

      laserOnlyStyle.id =
        'agfx-v519-laser-only';

      laserOnlyStyle.textContent = `
        .agfx.agfx--laser-only
        [data-visual-card] {
          display:
            none
            !important;
        }

        .agfx.agfx--laser-only
        [data-blend] {
          display:
            none
            !important;
        }

        .agfx.agfx--laser-only
        .agfx__laser-button {
          min-height:
            36px
            !important;

          color:
            #fff
            !important;

          background:
            linear-gradient(
              135deg,
              #16362f,
              #235247
            )
            !important;

          border-color:
            #16362f
            !important;

          box-shadow:
            0 8px 20px
            rgba(22,54,47,.16)
            !important;
        }

        .agfx.agfx--laser-only
        .agfx__technique-card {
          display:
            block
            !important;

          border:
            1px solid
            rgba(22,54,47,.12)
            !important;

          background:
            linear-gradient(
              145deg,
              #f7faf8,
              #edf5f1
            )
            !important;

          box-shadow:
            0 10px 24px
            rgba(22,54,47,.06);
        }

        .agfx.agfx--laser-only
        .agfx__technique-badge {
          background:
            #16362f
            !important;
        }

        .agfx.agfx--laser-only
        .agfx__technique-title {
          color:
            #16362f
            !important;

          font-size:
            12.5px
            !important;
        }

        .agfx.agfx--laser-only
        .agfx__technique-copy {
          color:
            #64716b
            !important;
        }

        .agfx.agfx--laser-only
        .agfx__technique-benefit {
          color:
            #315248
            !important;

          background:
            rgba(255,255,255,.86)
            !important;
        }

        .agfx.agfx--laser-only
        .agfx__adjust-handle {
          border-color:
            rgba(22,54,47,.16)
            !important;

          background:
            #fff
            !important;
        }

        /*
         * O controle de cor do texto não faz sentido para laser.
         * Ele também é ocultado via JS para compatibilidade.
         */
        .agfx.agfx--laser-only
        [data-text-color] {
          pointer-events:
            none
            !important;
        }
      `;

      document.head.appendChild(
        laserOnlyStyle
      );
    }

    /* ========================================================
       A GOURMET STUDIO PRO V5 — ESTILOS
       ======================================================== */

    if (!document.getElementById('agfx-pro-v5-styles')) {
      const proStyle =
        document.createElement('style');

      proStyle.id =
        'agfx-pro-v5-styles';

      proStyle.textContent = `
        .agfx__pro-tools {
          margin-top: 10px;

          border:
            1px solid rgba(22,54,47,.09);

          border-radius: 12px;

          background: #fbfcfb;

          overflow: hidden;
        }

        .agfx__pro-tools > summary {
          min-height: 38px;

          padding: 0 12px;

          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;

          color: #33423c;

          font-size: 8px;
          font-weight: 900;

          letter-spacing: .07em;
          text-transform: uppercase;

          cursor: pointer;

          list-style: none;
        }

        .agfx__pro-tools > summary::-webkit-details-marker {
          display: none;
        }

        .agfx__pro-tools > summary::after {
          content: "+";

          color: #81908a;

          font-size: 14px;
          line-height: 1;
        }

        .agfx__pro-tools[open] > summary::after {
          content: "−";
        }

        .agfx__pro-tools-body {
          padding: 11px;

          border-top:
            1px solid rgba(22,54,47,.07);
        }

        .agfx__pro-section + .agfx__pro-section {
          margin-top: 12px;
          padding-top: 12px;

          border-top:
            1px solid rgba(22,54,47,.07);
        }

        .agfx__pro-label {
          display: block;

          margin-bottom: 6px;

          color: #65716b;

          font-size: 7px;
          font-weight: 900;

          letter-spacing: .07em;
          text-transform: uppercase;
        }

        .agfx__pro-input,
        .agfx__pro-select {
          width: 100%;
          min-height: 36px;

          padding: 0 10px;

          border:
            1px solid rgba(22,54,47,.11);

          border-radius: 8px;

          outline: none;

          color: #26342e;
          background: #fff;

          font-size: 9px;
        }

        .agfx__pro-input:focus,
        .agfx__pro-select:focus {
          border-color:
            rgba(22,54,47,.30);

          box-shadow:
            0 0 0 3px
            rgba(22,54,47,.05);
        }

        .agfx__pro-grid {
          margin-top: 7px;

          display: grid;
          grid-template-columns:
            repeat(2,minmax(0,1fr));
          gap: 7px;
        }

        .agfx__pro-row {
          display: flex;
          align-items: center;
          gap: 7px;
        }

        .agfx__pro-range {
          width: 100%;
          accent-color: #16362f;
        }

        .agfx__pro-button {
          min-height: 34px;
          padding: 0 9px;

          display: inline-flex;
          align-items: center;
          justify-content: center;
          gap: 5px;

          border:
            1px solid rgba(22,54,47,.11);

          border-radius: 8px;

          color: #42514b;
          background: #fff;

          font-size: 7.5px;
          font-weight: 900;

          cursor: pointer;

          transition:
            transform .18s ease,
            background .18s ease,
            border-color .18s ease;
        }

        .agfx__pro-button:hover {
          transform: translateY(-1px);
          background: #f5f8f6;
          border-color: rgba(22,54,47,.24);
        }

        .agfx__pro-button.is-active {
          color: #176f4c;
          background: #edf8f2;
          border-color: rgba(42,139,97,.28);
        }

        .agfx__quality {
          margin-top: 8px;
          padding: 8px 9px;

          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;

          border-radius: 8px;

          background: #f5f7f5;

          color: #65716b;

          font-size: 8px;
          line-height: 1.35;
        }

        .agfx__quality strong {
          color: #25342e;
          font-size: 8px;
        }

        .agfx__quality[data-level="good"] {
          background: #edf8f2;
        }

        .agfx__quality[data-level="medium"] {
          background: #fff8e8;
        }

        .agfx__quality[data-level="low"] {
          background: #fff0ed;
        }

        .agfx__text-layer {
          position: absolute;
          z-index: 6;

          left: 50%;
          top: 50%;

          transform-origin: center;

          white-space: nowrap;

          user-select: none;
          touch-action: none;

          cursor: grab;

          text-shadow:
            0 1px 1px rgba(255,255,255,.10);
        }

        .agfx__text-layer.is-hidden {
          display: none;
        }

        .agfx__text-layer.is-dragging {
          cursor: grabbing;
        }

        .agfx__summary-extra {
          display: contents;
        }

        .agfx__project-toast {
          position: fixed;
          z-index: 99999;

          left: 50%;
          bottom: 24px;

          transform:
            translate(-50%, 14px);

          padding: 10px 14px;

          border-radius: 999px;

          color: #fff;
          background: #16362f;

          box-shadow:
            0 12px 34px
            rgba(22,54,47,.22);

          font-size: 10px;
          font-weight: 800;

          opacity: 0;
          pointer-events: none;

          transition:
            opacity .2s ease,
            transform .2s ease;
        }

        .agfx__project-toast.is-visible {
          opacity: 1;
          transform: translate(-50%,0);
        }

        @media(max-width:650px) {
          .agfx__pro-tools {
            margin-top: 12px;
          }

          .agfx__pro-grid {
            grid-template-columns: 1fr;
          }

          .agfx__panel {
            padding-bottom: 120px !important;
          }

          .agfx__footer {
            position: sticky !important;
            bottom: 0 !important;
          }
        }
      `;

      document.head.appendChild(
        proStyle
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.1 — FAVORITOS / COMPARAÇÃO / ZOOM
       ======================================================== */

    if (!document.getElementById('agfx-v51-styles')) {
      const v51Style =
        document.createElement('style');

      v51Style.id =
        'agfx-v51-styles';

      v51Style.textContent = `
        .agfx__category {
          position: relative;
          gap: 5px;
        }

        .agfx__category-label {
          min-width: 0;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .agfx__category-count {
          min-width: 18px;
          height: 18px;
          padding: 0 5px;

          display: inline-flex;
          align-items: center;
          justify-content: center;

          border-radius: 999px;

          color: #718079;
          background: rgba(22,54,47,.055);

          font-size: 7px;
          font-weight: 900;
          line-height: 1;
        }

        .agfx__category.is-active
        .agfx__category-count {
          color: #16362f;
          background: rgba(255,255,255,.88);
        }

        .agfx__product-actions {
          position: absolute;

          right: 9px;
          top: 50%;

          transform: translateY(-50%);

          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 7px;

          z-index: 5;
        }

        .agfx__product-action {
          width: 30px;
          height: 30px;

          display: grid;
          place-items: center;

          border:
            1px solid rgba(22,54,47,.10);

          border-radius: 9px;

          color: #66736d;
          background: rgba(255,255,255,.98);

          box-shadow:
            0 5px 14px rgba(22,54,47,.07);

          cursor: pointer;
          user-select: none;

          transition:
            transform .18s ease,
            color .18s ease,
            background .18s ease,
            border-color .18s ease,
            box-shadow .18s ease;
        }

        .agfx__product-action svg {
          width: 15px;
          height: 15px;

          display: block;

          stroke: currentColor;
          fill: none;

          stroke-width: 1.8;
          stroke-linecap: round;
          stroke-linejoin: round;
        }

        .agfx__product-action:hover {
          transform: translateY(-1px);

          color: #16362f;
          background: #f5f8f6;

          border-color:
            rgba(22,54,47,.22);

          box-shadow:
            0 8px 18px rgba(22,54,47,.11);
        }

        .agfx__product-action.is-active {
          color: #fff;
          background: #16362f;
          border-color: #16362f;
        }

        .agfx__product-action[data-favorite-toggle].is-active {
          color: #fff;
          background: #c89b59;
          border-color: #c89b59;
        }

        .agfx__product-action[data-compare-toggle].is-active {
          color: #fff;
          background: #16362f;
          border-color: #16362f;
        }

        .agfx__product-action[data-favorite-toggle].is-active svg {
          fill: currentColor;
          stroke: currentColor;
        }

        .agfx__zoom {
          position: absolute;
          z-index: 12;

          left: 50%;
          bottom: 18px;

          transform: translateX(-50%);

          display: flex;
          align-items: center;
          gap: 5px;

          padding: 5px;

          border:
            1px solid rgba(22,54,47,.10);

          border-radius: 999px;

          background: rgba(255,255,255,.90);

          box-shadow:
            0 10px 30px rgba(22,54,47,.10);

          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
        }

        .agfx__zoom-button {
          width: 30px;
          height: 30px;

          display: grid;
          place-items: center;

          border: 0;
          border-radius: 50%;

          color: #33423c;
          background: transparent;

          font-size: 15px;
          font-weight: 800;

          cursor: pointer;
        }

        .agfx__zoom-button:hover {
          background: #f0f4f1;
        }

        .agfx__zoom-value {
          min-width: 47px;

          color: #41504a;

          font-size: 8px;
          font-weight: 900;

          text-align: center;
        }

        .agfx__compare-tray {
          position: fixed;
          z-index: 9996;

          left: 50%;
          bottom: 18px;

          width:
            min(
              calc(100% - 32px),
              620px
            );

          transform:
            translate(-50%, 18px);

          padding: 10px 12px;

          display: none;
          align-items: center;
          justify-content: space-between;
          gap: 12px;

          border:
            1px solid rgba(22,54,47,.10);

          border-radius: 14px;

          color: #fff;
          background:
            rgba(17,45,38,.96);

          box-shadow:
            0 18px 50px rgba(9,31,25,.22);

          backdrop-filter: blur(14px);
          -webkit-backdrop-filter: blur(14px);

          opacity: 0;

          transition:
            opacity .2s ease,
            transform .2s ease;
        }

        .agfx__compare-tray.is-visible {
          display: flex;
          opacity: 1;
          transform: translate(-50%,0);
        }

        .agfx__compare-tray-info {
          min-width: 0;
        }

        .agfx__compare-tray-info strong {
          display: block;

          font-size: 10px;
          line-height: 1.3;
        }

        .agfx__compare-tray-info span {
          display: block;

          margin-top: 2px;

          color: rgba(255,255,255,.68);

          font-size: 8px;
        }

        .agfx__compare-tray-actions {
          display: flex;
          gap: 6px;
        }

        .agfx__compare-tray button {
          min-height: 34px;
          padding: 0 11px;

          border:
            1px solid rgba(255,255,255,.18);

          border-radius: 8px;

          color: #fff;
          background: rgba(255,255,255,.08);

          font-size: 8px;
          font-weight: 900;

          cursor: pointer;
        }

        .agfx__compare-tray button[data-open-compare] {
          color: #16362f;
          background: #fff;
        }

        .agfx__compare-modal {
          position: fixed;
          z-index: 9998;

          inset: 0;

          padding: 28px;

          display: none;
          align-items: center;
          justify-content: center;

          background: rgba(8,25,21,.56);

          backdrop-filter: blur(7px);
          -webkit-backdrop-filter: blur(7px);
        }

        .agfx__compare-modal.is-visible {
          display: flex;
        }

        .agfx__compare-dialog {
          width:
            min(
              1040px,
              100%
            );

          max-height:
            calc(100vh - 56px);

          overflow: auto;

          border-radius: 20px;

          background: #f8faf8;

          box-shadow:
            0 28px 90px rgba(0,0,0,.25);
        }

        .agfx__compare-head {
          position: sticky;
          z-index: 3;

          top: 0;

          padding: 17px 20px;

          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 16px;

          border-bottom:
            1px solid rgba(22,54,47,.08);

          background: rgba(255,255,255,.96);

          backdrop-filter: blur(10px);
        }

        .agfx__compare-head h3 {
          margin: 0;

          color: #1d2b26;

          font-size: 18px;
        }

        .agfx__compare-close {
          width: 34px;
          height: 34px;

          display: grid;
          place-items: center;

          border:
            1px solid rgba(22,54,47,.10);

          border-radius: 50%;

          color: #33423c;
          background: #fff;

          cursor: pointer;
        }

        .agfx__compare-grid {
          padding: 18px;

          display: grid;
          grid-template-columns:
            repeat(3,minmax(0,1fr));
          gap: 12px;
        }

        .agfx__compare-card {
          padding: 14px;

          border:
            1px solid rgba(22,54,47,.09);

          border-radius: 14px;

          background: #fff;
        }

        .agfx__compare-image {
          height: 190px;

          display: grid;
          place-items: center;

          border-radius: 11px;

          background: #f5f7f5;
        }

        .agfx__compare-image img {
          width: 88%;
          height: 88%;
          object-fit: contain;
        }

        .agfx__compare-card h4 {
          margin: 12px 0 0;

          color: #1d2b26;

          font-size: 13px;
          line-height: 1.35;
        }

        .agfx__compare-meta {
          margin-top: 4px;

          color: #7c8781;

          font-size: 8px;
        }

        .agfx__compare-table {
          margin-top: 12px;
        }

        .agfx__compare-row {
          padding: 7px 0;

          display: flex;
          justify-content: space-between;
          gap: 14px;

          border-bottom:
            1px solid rgba(22,54,47,.06);

          color: #727e78;

          font-size: 8px;
        }

        .agfx__compare-row strong {
          color: #26352f;
          text-align: right;
        }

        .agfx__compare-use {
          width: 100%;
          min-height: 36px;

          margin-top: 12px;

          border: 0;
          border-radius: 9px;

          color: #fff;
          background: #16362f;

          font-size: 8px;
          font-weight: 900;

          cursor: pointer;
        }

        @media(max-width:780px) {
          .agfx__compare-grid {
            grid-template-columns: 1fr;
          }

          .agfx__zoom {
            bottom: 12px;
          }
        }
      `;

      document.head.appendChild(
        v51Style
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.2 — ACABAMENTO DA BIBLIOTECA
       ======================================================== */

    if (!document.getElementById('agfx-v52-styles')) {
      const v52Style =
        document.createElement('style');

      v52Style.id =
        'agfx-v52-styles';

      v52Style.textContent = `
        .agfx__library-count {
          width: auto !important;
          min-width: 0 !important;
          height: 28px !important;

          padding: 0 9px !important;

          white-space: nowrap;

          font-size: 8px !important;
          letter-spacing: .01em;
        }

        .agfx__studio-status {
          margin:
            0 0 12px;

          padding:
            9px 10px;

          display:
            grid;

          grid-template-columns:
            repeat(2,minmax(0,1fr));

          gap:
            7px;

          border:
            1px solid rgba(22,54,47,.08);

          border-radius:
            10px;

          background:
            linear-gradient(
              135deg,
              #f8faf8,
              #f3f7f4
            );
        }

        .agfx__studio-status-item {
          min-width: 0;

          display:
            flex;

          align-items:
            center;

          gap:
            7px;

          color:
            #5f6c66;

          font-size:
            8px;

          line-height:
            1.25;
        }

        .agfx__studio-status-icon {
          width:
            24px;

          height:
            24px;

          flex:
            0 0 24px;

          display:
            grid;

          place-items:
            center;

          border-radius:
            50%;

          color:
            #16362f;

          background:
            #fff;

          box-shadow:
            0 2px 7px
            rgba(22,54,47,.06);

          font-size:
            11px;
        }

        .agfx__studio-status-copy {
          min-width: 0;
        }

        .agfx__studio-status-copy strong {
          display:
            block;

          overflow:
            hidden;

          color:
            #27352f;

          font-size:
            8.5px;

          font-weight:
            900;

          text-overflow:
            ellipsis;

          white-space:
            nowrap;
        }

        .agfx__studio-status-copy span {
          display:
            block;

          margin-top:
            1px;

          overflow:
            hidden;

          color:
            #87908b;

          font-size:
            7px;

          text-overflow:
            ellipsis;

          white-space:
            nowrap;
        }

        .agfx__compare-tray-info strong::after {
          content:
            " no Studio";
        }

        .agfx__category[data-category="favoritos"] {
          border-color:
            rgba(200,155,89,.18) !important;
        }

        .agfx__category[data-category="favoritos"].is-active {
          color:
            #fff !important;

          background:
            #a87934 !important;

          border-color:
            #a87934 !important;
        }

        .agfx__category[data-category="favoritos"].is-active
        .agfx__category-count {
          color:
            #7a541f;

          background:
            #fff;
        }

        @media(max-width:980px) {
          .agfx__studio-status {
            grid-template-columns:
              repeat(2,minmax(135px,1fr));

            overflow-x:
              auto;
          }
        }
      `;

      document.head.appendChild(
        v52Style
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.3 — VISUALIZAÇÃO + MODO VIDRO
       ======================================================== */

    if (!document.getElementById('agfx-v53-styles')) {
      const v53Style =
        document.createElement('style');

      v53Style.id =
        'agfx-v53-styles';

      v53Style.textContent = `
        .agfx:not(.agfx--laser-product)
        .agfx__quick [data-blend] {
          grid-column: 1 / -1;
        }

        .agfx__visual-card {
          margin-top: 9px;
          padding: 10px;

          border:
            1px solid rgba(22,54,47,.09);

          border-radius: 11px;

          background:
            linear-gradient(
              135deg,
              #fbfcfb,
              #f5f8f6
            );
        }

        .agfx__visual-head {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 8px;
        }

        .agfx__visual-title {
          display: flex;
          align-items: center;
          gap: 6px;

          color: #52615a;

          font-size: 7px;
          font-weight: 900;

          letter-spacing: .08em;
          text-transform: uppercase;
        }

        .agfx__visual-title::before {
          content: "";

          width: 6px;
          height: 6px;

          border-radius: 50%;

          background: #8e9a94;

          box-shadow:
            0 0 0 3px
            rgba(22,54,47,.05);
        }

        .agfx.agfx--glass-product
        .agfx__visual-title::before {
          background: #4d9ea6;
        }

        .agfx__glass-badge {
          display: none;

          padding: 4px 7px;

          border-radius: 999px;

          color: #286770;
          background: #e9f6f7;

          font-size: 7px;
          font-weight: 900;

          letter-spacing: .04em;
          text-transform: uppercase;
        }

        .agfx.agfx--glass-product
        .agfx__glass-badge {
          display: inline-flex;
        }

        .agfx__visual-group {
          margin-top: 9px;
        }

        .agfx__visual-label {
          display: block;

          margin-bottom: 5px;

          color: #7a8580;

          font-size: 6.7px;
          font-weight: 900;

          letter-spacing: .07em;
          text-transform: uppercase;
        }

        .agfx__segmented {
          display: grid;
          grid-template-columns:
            repeat(3,minmax(0,1fr));

          gap: 5px;
        }

        .agfx__segmented-button {
          min-height: 31px;
          padding: 0 6px;

          border:
            1px solid rgba(22,54,47,.09);

          border-radius: 8px;

          color: #68746e;
          background: #fff;

          font-size: 7px;
          font-weight: 900;

          cursor: pointer;

          transition:
            background .18s ease,
            color .18s ease,
            border-color .18s ease,
            box-shadow .18s ease,
            transform .18s ease;
        }

        .agfx__segmented-button:hover {
          transform: translateY(-1px);

          border-color:
            rgba(22,54,47,.22);
        }

        .agfx__segmented-button.is-active {
          color: #fff;
          background: #16362f;
          border-color: #16362f;

          box-shadow:
            0 5px 12px
            rgba(22,54,47,.10);
        }

        .agfx__glass-print {
          display: none;
        }

        .agfx.agfx--glass-product:not(.agfx--laser-product)
        .agfx__glass-print {
          display: block;
        }

        .agfx__visual-note {
          margin: 7px 0 0;

          color: #8a938f;

          font-size: 6.8px;
          line-height: 1.45;
        }

        .agfx__capture[data-preview-background="light"] {
          background: #ffffff !important;
        }

        .agfx__capture[data-preview-background="neutral"] {
          background:
            linear-gradient(
              145deg,
              #eef1ef,
              #dfe5e1
            ) !important;
        }

        .agfx__capture[data-preview-background="dark"] {
          background:
            radial-gradient(
              circle at 48% 38%,
              #3d4944 0%,
              #242d29 72%,
              #1c2421 100%
            ) !important;
        }

        /*
         * Vidro com foto de fundo branco.
         * Neutral usa multiply para reduzir o branco.
         * Dark usa invert + screen para evidenciar os contornos.
         */
        .agfx.agfx--glass-product
        .agfx__capture[data-preview-background="neutral"]
        [data-base] {
          mix-blend-mode: multiply;
          filter:
            contrast(1.10)
            brightness(.99);
        }

        .agfx.agfx--glass-product
        .agfx__capture[data-preview-background="dark"]
        [data-base] {
          mix-blend-mode: screen;

          filter:
            invert(1)
            grayscale(.15)
            contrast(1.09)
            brightness(1.08);

          opacity: .94;
        }

        .agfx.agfx--glass-product
        .agfx__capture[data-preview-background="light"]
        [data-base] {
          mix-blend-mode: normal;
          filter: none;
          opacity: 1;
        }

        .agfx[data-print-ink="white"]
        .agfx__logo-render {
          filter:
            drop-shadow(
              0 1px 1px
              rgba(0,0,0,.20)
            );
        }

        .agfx[data-print-ink="white"]
        .agfx__text-layer {
          text-shadow:
            0 1px 1px
            rgba(0,0,0,.28);
        }

        .agfx__product-action {
          width: 30px !important;
          height: 30px !important;
        }

        .agfx__zoom {
          padding-right: 7px;
        }

        .agfx__zoom-fit {
          min-height: 28px;
          padding: 0 9px;

          border: 0;
          border-left:
            1px solid rgba(22,54,47,.08);

          color: #51605a;
          background: transparent;

          font-size: 7px;
          font-weight: 900;

          text-transform: uppercase;

          cursor: pointer;
        }

        .agfx__zoom-fit:hover {
          color: #16362f;
        }

        @media(max-width:650px) {
          .agfx__zoom-fit {
            display: none;
          }
        }
      `;

      document.head.appendChild(
        v53Style
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.4 — CAMADA COMERCIAL
       ======================================================== */

    if (!document.getElementById('agfx-v54-styles')) {
      const v54Style =
        document.createElement('style');

      v54Style.id =
        'agfx-v54-styles';

      v54Style.textContent = `
        .agfx__commercial {
          margin-bottom: 11px;
          padding: 10px 11px;

          border:
            1px solid rgba(22,54,47,.09);

          border-radius: 12px;

          background:
            linear-gradient(
              135deg,
              #f8faf8,
              #f2f7f4
            );
        }

        .agfx__commercial-top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 9px;
        }

        .agfx__commercial-project {
          min-width: 0;
        }

        .agfx__commercial-eyebrow {
          display: block;

          color: #82908a;

          font-size: 6.5px;
          font-weight: 900;

          letter-spacing: .08em;
          text-transform: uppercase;
        }

        .agfx__commercial-id {
          display: block;

          margin-top: 2px;

          overflow: hidden;

          color: #17362f;

          font-size: 10px;
          font-weight: 900;

          text-overflow: ellipsis;
          white-space: nowrap;
        }

        .agfx__commercial-status {
          flex: 0 0 auto;

          padding: 5px 8px;

          border-radius: 999px;

          color: #6e7b75;
          background: #fff;

          font-size: 6.7px;
          font-weight: 900;

          letter-spacing: .03em;
          text-transform: uppercase;

          box-shadow:
            0 2px 8px rgba(22,54,47,.05);
        }

        .agfx__commercial-status[data-status="ready"] {
          color: #176f4c;
          background: #eaf7f0;
        }

        .agfx__commercial-status[data-status="sent"] {
          color: #fff;
          background: #16362f;
        }

        .agfx__progress {
          margin-top: 10px;

          display: grid;
          grid-template-columns:
            repeat(4,minmax(0,1fr));

          gap: 5px;
        }

        .agfx__progress-step {
          position: relative;

          min-width: 0;

          padding: 6px 4px;

          display: flex;
          align-items: center;
          justify-content: center;
          gap: 4px;

          border:
            1px solid rgba(22,54,47,.075);

          border-radius: 8px;

          color: #89938e;
          background: rgba(255,255,255,.70);

          font-size: 6.5px;
          font-weight: 900;

          text-align: center;

          transition:
            background .18s ease,
            color .18s ease,
            border-color .18s ease;
        }

        .agfx__progress-number {
          width: 16px;
          height: 16px;

          flex: 0 0 16px;

          display: grid;
          place-items: center;

          border-radius: 50%;

          color: #7b8781;
          background: #edf1ef;

          font-size: 6.5px;
        }

        .agfx__progress-step.is-current {
          color: #16362f;

          border-color:
            rgba(22,54,47,.18);

          background: #fff;
        }

        .agfx__progress-step.is-current
        .agfx__progress-number {
          color: #fff;
          background: #c89b59;
        }

        .agfx__progress-step.is-done {
          color: #176f4c;

          border-color:
            rgba(42,139,97,.14);

          background: #eef8f2;
        }

        .agfx__progress-step.is-done
        .agfx__progress-number {
          color: #fff;
          background: #25845d;
        }

        .agfx__progress-step.is-done
        .agfx__progress-number::before {
          content: "✓";
        }

        .agfx__progress-step.is-done
        .agfx__progress-number {
          font-size: 0;
        }

        .agfx__progress-step.is-done
        .agfx__progress-number::before {
          font-size: 7px;
        }

        .agfx__commercial-hint {
          margin: 8px 0 0;

          color: #7e8984;

          font-size: 6.8px;
          line-height: 1.4;
        }

        .agfx__summary-commercial-row strong {
          color: #16362f !important;
        }

        .agfx [data-whatsapp] {
          position: relative;
        }

        .agfx [data-whatsapp]::before {
          content: "Projeto personalizado";
          display: block;

          margin-right: 5px;

          opacity: .72;

          font-size: 6px;
          font-weight: 700;

          letter-spacing: .03em;
          text-transform: uppercase;
        }

        @media(max-width:650px) {
          .agfx__progress {
            grid-template-columns:
              repeat(4,minmax(76px,1fr));

            overflow-x: auto;
          }
        }
      `;

      document.head.appendChild(
        v54Style
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.6 — SEM FUNDO DA PRÉVIA
       ======================================================== */

    if (!document.getElementById('agfx-v55-styles')) {
      const v55Style =
        document.createElement('style');

      v55Style.id =
        'agfx-v55-styles';

      v55Style.textContent = `
        [data-preview-toolbar],
        .agfx__zoom-bg {
          display: none !important;
        }

        /* Cabeçalho comercial menor */
        .agfx__commercial {
          margin-bottom: 8px !important;
          padding: 8px 9px !important;
          border-radius: 10px !important;
        }

        .agfx__commercial-top {
          min-height: 24px;
        }

        .agfx__commercial-eyebrow {
          font-size: 5.8px !important;
        }

        .agfx__commercial-id {
          margin-top: 1px !important;
          font-size: 8.5px !important;
        }

        .agfx__commercial-status {
          padding: 4px 7px !important;
          font-size: 5.8px !important;
        }

        .agfx__progress {
          margin-top: 7px !important;
          gap: 4px !important;
        }

        .agfx__progress-step {
          min-height: 28px;
          padding: 4px 3px !important;
          gap: 3px !important;
          font-size: 5.8px !important;
        }

        .agfx__progress-number {
          width: 14px !important;
          height: 14px !important;
          flex-basis: 14px !important;
          font-size: 5.8px !important;
        }

        .agfx__commercial-hint {
          display: none !important;
        }

        /* CTA sem microtexto antes do título */
        .agfx [data-whatsapp]::before {
          display: none !important;
          content: none !important;
        }

        .agfx [data-whatsapp] {
          font-size: 8.5px !important;
          letter-spacing: 0 !important;
        }

        /* Controles rápidos */
        .agfx__quick {
          gap: 6px !important;
        }

        .agfx__mini {
          min-height: 34px !important;
          border-radius: 9px !important;
          font-size: 6.5px !important;
          letter-spacing: .02em !important;
        }

        .agfx:not(.agfx--laser-product)
        .agfx__quick [data-blend] {
          grid-column: 1 / -1;
        }

        /*
         * Visualização do vidro:
         * fundo da prévia vai para o palco.
         */
        .agfx__visual-card
        .agfx__visual-group:first-of-type {
          display: none !important;
        }

        .agfx:not(.agfx--glass-product)
        .agfx__visual-card {
          display: none !important;
        }

        .agfx__visual-card {
          margin-top: 8px !important;
          padding: 9px !important;
          border-radius: 10px !important;
        }

        .agfx__visual-title {
          font-size: 6.3px !important;
        }

        .agfx__glass-badge {
          padding: 3px 6px !important;
          font-size: 5.8px !important;
        }

        .agfx__visual-group {
          margin-top: 7px !important;
        }

        .agfx__visual-label {
          margin-bottom: 4px !important;
          font-size: 5.8px !important;
        }

        .agfx__segmented-button {
          min-height: 29px !important;
          font-size: 6.3px !important;
        }

        .agfx__visual-note {
          margin-top: 5px !important;
          font-size: 5.8px !important;
        }

        /*
         * CORREÇÃO DO FUNDO ESCURO NO VIDRO.
         * O branco da foto acompanha o fundo em vez de formar
         * um retângulo branco dentro da moldura.
         */
        .agfx.agfx--glass-product
        .agfx__capture[data-preview-background="neutral"]
        [data-base] {
          mix-blend-mode: multiply !important;
          filter:
            contrast(1.12)
            brightness(.99)
            !important;
          opacity: 1 !important;
        }

        .agfx.agfx--glass-product
        .agfx__capture[data-preview-background="dark"]
        [data-base] {
          mix-blend-mode: multiply !important;
          filter:
            contrast(1.24)
            brightness(1.05)
            !important;
          opacity: 1 !important;
        }

        .agfx.agfx--glass-product
        .agfx__capture[data-preview-background="light"]
        [data-base] {
          mix-blend-mode: normal !important;
          filter: none !important;
          opacity: 1 !important;
        }

        /* Barra inferior do palco */
        .agfx__zoom {
          gap: 4px !important;
          padding: 4px 6px !important;
        }

        .agfx__zoom-value {
          min-width: 40px !important;
        }

        .agfx__zoom-fit {
          padding: 0 7px !important;
        }

        .agfx__zoom-bg {
          margin-left: 3px;
          padding-left: 7px;

          display: flex;
          align-items: center;
          gap: 5px;

          border-left:
            1px solid rgba(22,54,47,.08);
        }

        .agfx__zoom-bg-label {
          color: #77847e;
          font-size: 5.8px;
          font-weight: 900;
          letter-spacing: .04em;
          text-transform: uppercase;
        }

        .agfx__zoom-bg-button {
          width: 18px;
          height: 18px;
          padding: 0;

          border:
            2px solid transparent;

          border-radius: 50%;

          box-shadow:
            0 0 0 1px
            rgba(22,54,47,.12);

          cursor: pointer;

          transition:
            transform .15s ease,
            border-color .15s ease,
            box-shadow .15s ease;
        }

        .agfx__zoom-bg-button:hover {
          transform: scale(1.08);
        }

        .agfx__zoom-bg-button[data-preview-bg="light"] {
          background: #fff;
        }

        .agfx__zoom-bg-button[data-preview-bg="neutral"] {
          background: #dfe4e1;
        }

        .agfx__zoom-bg-button[data-preview-bg="dark"] {
          background: #27312d;
        }

        .agfx__zoom-bg-button.is-active {
          border-color: #c89b59;

          box-shadow:
            0 0 0 2px #fff,
            0 0 0 3px #c89b59;
        }

        .agfx__product-action {
          width: 30px !important;
          height: 30px !important;
        }

        @media(max-width:650px) {
          .agfx__zoom-bg-label {
            display: none;
          }

          .agfx__zoom-bg {
            padding-left: 5px;
          }

          .agfx__zoom-bg-button {
            width: 16px;
            height: 16px;
          }
        }
      `;

      document.head.appendChild(
        v55Style
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.9 — FULL WIDTH + CARDS REFINADOS
       ======================================================== */

    if (!document.getElementById('agfx-v57-styles')) {
      const v57Style =
        document.createElement('style');

      v57Style.id =
        'agfx-v57-styles';

      v57Style.textContent = `
        /*
         * Seções visuais no painel.
         */
        .agfx__section-heading {
          margin:
            12px 0 6px;

          display:
            flex;

          align-items:
            center;

          gap:
            7px;

          color:
            #65716b;

          font-size:
            6.4px;

          font-weight:
            900;

          letter-spacing:
            .10em;

          text-transform:
            uppercase;
        }

        .agfx__section-heading::after {
          content:
            "";

          height:
            1px;

          flex:
            1;

          background:
            rgba(22,54,47,.08);
        }

        .agfx__section-heading:first-of-type {
          margin-top:
            8px;
        }

        /*
         * Painel mais compacto.
         */
        .agfx__panel .agfx__box {
          margin-top:
            7px !important;

          padding:
            10px 11px !important;

          border-radius:
            10px !important;
        }

        .agfx__panel .agfx__control {
          margin-bottom:
            9px !important;
        }

        .agfx__panel .agfx__control:last-child {
          margin-bottom:
            0 !important;
        }

        /*
         * Resumo fica visualmente mais leve dentro de PEDIDO.
         */
        .agfx__panel .agfx__summary {
          margin-top:
            7px !important;

          padding:
            10px 11px !important;

          border-radius:
            10px !important;
        }

        /*
         * A moldura recebe uma pequena área de respiro visual.
         * O produto continua intacto na prévia exportada.
         */
        .agfx__stage-wrap {
          overflow:
            hidden;
        }

        .agfx__capture {
          transition:
            transform .26s ease;
        }

        /*
         * Indicador rápido do encaixe automático.
         */
        .agfx__fit-hint {
          position:
            absolute;

          z-index:
            11;

          left:
            50%;

          top:
            16px;

          transform:
            translate(-50%,-6px);

          padding:
            5px 9px;

          border:
            1px solid
            rgba(22,54,47,.08);

          border-radius:
            999px;

          color:
            #53615b;

          background:
            rgba(255,255,255,.88);

          box-shadow:
            0 6px 20px
            rgba(22,54,47,.07);

          backdrop-filter:
            blur(8px);

          font-size:
            6px;

          font-weight:
            900;

          letter-spacing:
            .04em;

          text-transform:
            uppercase;

          opacity:
            0;

          pointer-events:
            none;

          transition:
            opacity .2s ease,
            transform .2s ease;
        }

        .agfx__fit-hint.is-visible {
          opacity:
            1;

          transform:
            translate(-50%,0);
        }

        /*
         * Em pratos, travessas e bowls a prévia visual recebe
         * mais respiro no palco.
         */
        .agfx.agfx--fit-wide
        .agfx__capture {
          box-shadow:
            0 24px 60px
            rgba(22,54,47,.10);
        }

        @media(max-width:650px) {
          .agfx__section-heading {
            margin-top:
              10px;

            font-size:
              6px;
          }

          .agfx__fit-hint {
            top:
              10px;
          }
        }
      `;

      document.head.appendChild(
        v57Style
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.19 — PREMIUM + TALHERES SOMENTE LASER / WOKIEE 3.4.1
       ======================================================== */

    if (!document.getElementById('agfx-v512-wokiee-full-bleed')) {
      const fullWidthStyle =
        document.createElement('style');

      fullWidthStyle.id =
        'agfx-v512-wokiee-full-bleed';

      fullWidthStyle.textContent = `
        body.agfx-wokiee-studio-page {
          overflow-x: clip !important;
        }

        body.agfx-wokiee-studio-page
        #tt-pageContent,
        body.agfx-wokiee-studio-page
        .agfx-wokiee-unclip {
          overflow: visible !important;
        }

        @media(min-width:1100px) {
          /*
           * Mantém o wrapper da seção na largura editorial do Wokiee.
           * Quem faz o full bleed agora é o .agfx__app, que é
           * exatamente o bloco visual mostrado na tela.
           */
          body.agfx-wokiee-studio-page
          [data-agfx] {
            position: relative !important;

            width: 100% !important;
            max-width: none !important;

            margin-left: 0 !important;
            margin-right: 0 !important;

            left: auto !important;
            right: auto !important;

            transform: none !important;

            overflow: visible !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__app {
            position: relative !important;

            width:
              calc(100vw - 32px)
              !important;

            max-width:
              none
              !important;

            /*
             * 50% é calculado pela largura do wrapper editorial.
             * 50vw é metade da viewport.
             * A diferença move apenas o APP até a borda da tela.
             */
            margin-left:
              calc(
                50% - 50vw + 16px
              )
              !important;

            margin-right:
              0
              !important;

            grid-template-columns:
              300px
              minmax(0,1fr)
              390px
              !important;
          }
        }

        @media(min-width:1800px) {
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__app {
            width:
              calc(100vw - 40px)
              !important;

            margin-left:
              calc(
                50% - 50vw + 20px
              )
              !important;

            grid-template-columns:
              315px
              minmax(0,1fr)
              405px
              !important;
          }
        }

        @media(max-width:1099px) {
          body.agfx-wokiee-studio-page
          [data-agfx],
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__app {
            width: 100% !important;
            max-width: 100% !important;

            margin-left: auto !important;
            margin-right: auto !important;

            left: auto !important;
            right: auto !important;

            transform: none !important;
          }
        }
      `;

      document.head.appendChild(
        fullWidthStyle
      );
    }

    document.body.classList.add(
      'agfx-wokiee-studio-page'
    );

    /*
     * Libera o clipping somente no caminho do Studio.
     */
    let fullWidthAncestor =
      root.parentElement;

    while (
      fullWidthAncestor &&
      fullWidthAncestor !==
        document.body
    ) {
      fullWidthAncestor.classList.add(
        'agfx-wokiee-unclip'
      );

      fullWidthAncestor =
        fullWidthAncestor.parentElement;
    }

    /* ========================================================
       A GOURMET STUDIO V5.13 — PROPORÇÕES DESKTOP
       ======================================================== */

    if (!document.getElementById('agfx-v513-proportions')) {
      const proportionStyle =
        document.createElement('style');

      proportionStyle.id =
        'agfx-v513-proportions';

      proportionStyle.textContent = `
        /*
         * A V5.12 resolveu o full width.
         * Aqui ajustamos a escala interna para aproveitar
         * melhor o espaço disponível em desktop.
         */
        @media(min-width:1100px) {

          /*
           * COLUNAS
           * Um pouco mais confortáveis para leitura,
           * sem roubar espaço demais da área central.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__app {
            grid-template-columns:
              310px
              minmax(0,1fr)
              400px
              !important;
          }

          /*
           * ÁREA CENTRAL
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__stage-wrap {
            padding:
              18px
              24px
              66px
              !important;

            display:
              flex
              !important;

            align-items:
              center
              !important;

            justify-content:
              center
              !important;
          }

          /*
           * Preview maior e responsivo.
           * Mantém formato quadrado e nunca ultrapassa
           * o espaço vertical disponível.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__capture {
            width:
              min(
                680px,
                74vh,
                calc(100% - 72px)
              )
              !important;

            height:
              min(
                680px,
                74vh,
                calc(100% - 72px)
              )
              !important;

            max-width:
              none
              !important;

            max-height:
              none
              !important;

            flex:
              0 0 auto;

            border-radius:
              22px
              !important;

            box-shadow:
              0 26px 70px
              rgba(22,54,47,.12)
              !important;
          }

          /*
           * Imagem do produto acompanha o preview.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-base] {
            max-width:
              100%
              !important;

            max-height:
              100%
              !important;
          }

          /*
           * BIBLIOTECA — cards mais confortáveis.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__product {
            min-height:
              92px
              !important;

            padding:
              10px
              48px
              10px
              10px
              !important;

            border-radius:
              13px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__thumb {
            width:
              68px
              !important;

            height:
              68px
              !important;

            min-width:
              68px
              !important;

            border-radius:
              10px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__product-info strong {
            font-size:
              11px
              !important;

            line-height:
              1.22
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__product-meta {
            margin-top:
              3px
              !important;

            font-size:
              8px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__personalizable {
            margin-top:
              4px
              !important;

            font-size:
              7px
              !important;
          }

          /*
           * AÇÕES DO CARD
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__product-action {
            width:
              31px
              !important;

            height:
              31px
              !important;
          }

          /*
           * PAINEL DIREITO — legibilidade.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-title] {
            font-size:
              clamp(
                21px,
                1.45vw,
                27px
              )
              !important;

            line-height:
              1.05
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel {
            padding-left:
              18px
              !important;

            padding-right:
              18px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__section-heading {
            font-size:
              6.8px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__mini,
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__segmented-button {
            font-size:
              6.8px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__control-head {
            font-size:
              7px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__commercial-id {
            font-size:
              9px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__commercial-status {
            font-size:
              6.1px
              !important;
          }

          /*
           * CTA com presença um pouco maior.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-upload] {
            min-height:
              45px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-download],
          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-whatsapp] {
            min-height:
              43px
              !important;
          }
        }

        /*
         * Monitores grandes:
         * libera preview maior sem exagerar as laterais.
         */
        @media(min-width:1800px) {
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__app {
            grid-template-columns:
              325px
              minmax(0,1fr)
              415px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__capture {
            width:
              min(
                720px,
                76vh,
                calc(100% - 76px)
              )
              !important;

            height:
              min(
                720px,
                76vh,
                calc(100% - 76px)
              )
              !important;
          }
        }

        /*
         * Notebook menor: preserva o equilíbrio.
         */
        @media(min-width:1100px) and (max-width:1365px) {
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__app {
            grid-template-columns:
              285px
              minmax(0,1fr)
              370px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__capture {
            width:
              min(
                600px,
                70vh,
                calc(100% - 54px)
              )
              !important;

            height:
              min(
                600px,
                70vh,
                calc(100% - 54px)
              )
              !important;
          }
        }
      `;

      document.head.appendChild(
        proportionStyle
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.14 — LATERAIS + SCROLL DO PAINEL
       ======================================================== */

    if (!document.getElementById('agfx-v514-side-panels')) {
      const sidePanelStyle =
        document.createElement('style');

      sidePanelStyle.id =
        'agfx-v514-side-panels';

      sidePanelStyle.textContent = `
        /*
         * A V5.13 acertou o full width e o preview.
         * Esta versão refina apenas as duas laterais.
         */
        @media(min-width:1100px) {

          /* ==================================================
             COLUNAS
             ================================================== */

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__app {
            grid-template-columns:
              320px
              minmax(0,1fr)
              430px
              !important;
          }

          /* ==================================================
             BIBLIOTECA ESQUERDA
             ================================================== */

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__sidebar {
            min-width:
              0
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__product {
            min-height:
              96px
              !important;

            padding:
              11px
              50px
              11px
              11px
              !important;

            border-radius:
              14px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__thumb {
            width:
              72px
              !important;

            height:
              72px
              !important;

            min-width:
              72px
              !important;

            border-radius:
              11px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__product-info strong {
            font-size:
              11.5px
              !important;

            line-height:
              1.18
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__product-meta {
            font-size:
              8.2px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__personalizable {
            font-size:
              7.2px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__product-action {
            width:
              32px
              !important;

            height:
              32px
              !important;
          }

          /* ==================================================
             PAINEL DIREITO — SCROLL CORRETO
             ================================================== */

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel {
            position:
              relative
              !important;

            min-width:
              0
              !important;

            overflow-x:
              hidden
              !important;

            overflow-y:
              auto
              !important;

            overscroll-behavior:
              contain;

            scrollbar-gutter:
              stable;

            scroll-padding-bottom:
              132px;

            padding-left:
              20px
              !important;

            padding-right:
              20px
              !important;

            padding-bottom:
              0
              !important;
          }

          /*
           * Scrollbar discreta, compatível com o visual do Studio.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel::-webkit-scrollbar {
            width:
              7px;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel::-webkit-scrollbar-track {
            background:
              transparent;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel::-webkit-scrollbar-thumb {
            border:
              2px solid transparent;

            border-radius:
              999px;

            background:
              rgba(22,54,47,.16);

            background-clip:
              padding-box;
          }

          /* ==================================================
             LEITURA DO PAINEL
             ================================================== */

          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-title] {
            font-size:
              clamp(
                23px,
                1.52vw,
                29px
              )
              !important;

            line-height:
              1.04
              !important;

            letter-spacing:
              -.025em
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__section-heading {
            margin-top:
              13px
              !important;

            margin-bottom:
              7px
              !important;

            font-size:
              7.2px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel
          .agfx__box {
            padding:
              11px 12px
              !important;

            border-radius:
              11px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__control-head {
            font-size:
              7.4px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__mini {
            min-height:
              36px
              !important;

            font-size:
              7.1px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__segmented-button {
            min-height:
              32px
              !important;

            font-size:
              7px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__visual-label {
            font-size:
              6.4px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__visual-note {
            font-size:
              6.2px
              !important;

            line-height:
              1.45
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__commercial {
            padding:
              9px 10px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__commercial-id {
            font-size:
              9.5px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__commercial-status {
            font-size:
              6.3px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__progress-step {
            min-height:
              30px
              !important;

            font-size:
              6.1px
              !important;
          }

          /*
           * Campos de quantidade/posição e similares.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel input,
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel select {
            min-height:
              38px
              !important;

            font-size:
              9px
              !important;
          }

          /* ==================================================
             FOOTER / CTA STICKY
             ================================================== */

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__footer {
            position:
              sticky
              !important;

            z-index:
              30
              !important;

            left:
              0;

            right:
              0;

            bottom:
              0
              !important;

            margin:
              12px
              -20px
              0
              !important;

            padding:
              12px
              20px
              14px
              !important;

            background:
              rgba(255,255,255,.98)
              !important;

            border-top:
              1px solid
              rgba(22,54,47,.08);

            box-shadow:
              0
              -14px
              34px
              rgba(22,54,47,.08);

            backdrop-filter:
              blur(12px);

            -webkit-backdrop-filter:
              blur(12px);
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-download],
          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-whatsapp] {
            min-height:
              46px
              !important;

            border-radius:
              10px
              !important;

            font-size:
              9px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-download] {
            margin-bottom:
              7px
              !important;
          }

          /*
           * O último bloco do conteúdo pode subir completamente
           * acima dos CTAs ao chegar ao fim da rolagem.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel
          .agfx__summary {
            margin-bottom:
              18px
              !important;
          }
        }

        /*
         * Monitor grande.
         */
        @media(min-width:1800px) {
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__app {
            grid-template-columns:
              330px
              minmax(0,1fr)
              445px
              !important;
          }
        }

        /*
         * Notebook menor:
         * preserva o espaço central.
         */
        @media(min-width:1100px) and (max-width:1365px) {
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__app {
            grid-template-columns:
              295px
              minmax(0,1fr)
              390px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel {
            padding-left:
              16px
              !important;

            padding-right:
              16px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__footer {
            margin-left:
              -16px
              !important;

            margin-right:
              -16px
              !important;

            padding-left:
              16px
              !important;

            padding-right:
              16px
              !important;
          }
        }
      `;

      document.head.appendChild(
        sidePanelStyle
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.15 — PAINEL DIREITO FINAL
       ======================================================== */

    if (!document.getElementById('agfx-v515-right-panel')) {
      const rightPanelStyle =
        document.createElement('style');

      rightPanelStyle.id =
        'agfx-v515-right-panel';

      rightPanelStyle.textContent = `
        @media(min-width:1100px) {

          /* ==================================================
             PAINEL DIREITO
             O painel deixa de ser o elemento que rola.
             O conteúdo interno passa a rolar separadamente
             e o rodapé fica fixo SEM cobrir controles.
             ================================================== */

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel.agfx__panel--v515 {
            display:
              flex
              !important;

            flex-direction:
              column
              !important;

            overflow:
              hidden
              !important;

            padding:
              0
              !important;

            scrollbar-gutter:
              auto
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll {
            flex:
              1 1 auto;

            min-height:
              0;

            overflow-x:
              hidden;

            overflow-y:
              auto;

            overscroll-behavior:
              contain;

            scrollbar-gutter:
              stable;

            scroll-padding-bottom:
              28px;

            padding:
              16px
              20px
              28px;
          }

          /*
           * Scrollbar somente no conteúdo.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll::-webkit-scrollbar {
            width:
              7px;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll::-webkit-scrollbar-track {
            background:
              transparent;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll::-webkit-scrollbar-thumb {
            border:
              2px solid transparent;

            border-radius:
              999px;

            background:
              rgba(22,54,47,.18);

            background-clip:
              padding-box;
          }

          /*
           * Rodapé sempre visível, porém fora da área rolável.
           * Não existe mais sobreposição.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel.agfx__panel--v515
          .agfx__footer {
            position:
              relative
              !important;

            z-index:
              40
              !important;

            flex:
              0 0 auto;

            left:
              auto
              !important;

            right:
              auto
              !important;

            bottom:
              auto
              !important;

            margin:
              0
              !important;

            padding:
              12px
              20px
              14px
              !important;

            border-top:
              1px solid
              rgba(22,54,47,.09);

            background:
              rgba(255,255,255,.985)
              !important;

            box-shadow:
              0
              -10px
              26px
              rgba(22,54,47,.055);

            backdrop-filter:
              blur(12px);

            -webkit-backdrop-filter:
              blur(12px);
          }

          /*
           * Últimos blocos agora conseguem chegar totalmente
           * acima do rodapé.
           */
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll
          > :last-child {
            margin-bottom:
              0
              !important;
          }

          /* ==================================================
             HIERARQUIA DAS SEÇÕES
             ================================================== */

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__section-heading {
            margin-top:
              15px
              !important;

            margin-bottom:
              8px
              !important;

            color:
              #315248
              !important;

            font-size:
              7.8px
              !important;

            letter-spacing:
              .11em
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__section-heading::before {
            content:
              "";

            width:
              6px;

            height:
              6px;

            flex:
              0 0 6px;

            border-radius:
              50%;

            background:
              #c89b59;

            box-shadow:
              0
              0
              0
              3px
              rgba(200,155,89,.10);
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__section-heading::after {
            background:
              rgba(22,54,47,.11)
              !important;
          }

          /* ==================================================
             LEGIBILIDADE +8/10%
             ================================================== */

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__control-head {
            font-size:
              8px
              !important;

            letter-spacing:
              .055em
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__mini {
            min-height:
              37px
              !important;

            font-size:
              7.6px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__segmented-button {
            min-height:
              33px
              !important;

            font-size:
              7.5px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__visual-label {
            font-size:
              6.9px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__visual-note {
            font-size:
              6.7px
              !important;

            line-height:
              1.5
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__commercial-eyebrow {
            font-size:
              6.3px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__commercial-id {
            font-size:
              10px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__commercial-status {
            font-size:
              6.8px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__progress-step {
            min-height:
              31px
              !important;

            font-size:
              6.55px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll
          input,
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll
          select {
            min-height:
              39px
              !important;

            font-size:
              9.7px
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll
          .agfx__box,
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll
          .agfx__summary {
            border-color:
              rgba(22,54,47,.095)
              !important;

            box-shadow:
              0
              5px
              18px
              rgba(22,54,47,.025);
          }

          /* ==================================================
             CTA
             ================================================== */

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel.agfx__panel--v515
          [data-download],
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel.agfx__panel--v515
          [data-whatsapp] {
            min-height:
              47px
              !important;

            font-size:
              9.2px
              !important;

            border-radius:
              10px
              !important;
          }
        }

        /*
         * Notebook:
         * mesma arquitetura, com padding um pouco menor.
         */
        @media(min-width:1100px) and (max-width:1365px) {
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel-scroll {
            padding-left:
              16px;

            padding-right:
              16px;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__panel.agfx__panel--v515
          .agfx__footer {
            padding-left:
              16px
              !important;

            padding-right:
              16px
              !important;
          }
        }
      `;

      document.head.appendChild(
        rightPanelStyle
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.16 — CARDS + ORGANIZAÇÃO FINAL
       ======================================================== */

    if (!document.getElementById('agfx-v516-final-polish')) {
      const finalPolishStyle =
        document.createElement('style');

      finalPolishStyle.id =
        'agfx-v516-final-polish';

      finalPolishStyle.textContent = `
        /*
         * =====================================================
         * CARD SELECIONADO
         * =====================================================
         *
         * Remove o check dourado flutuante e usa:
         * - borda dourada
         * - fundo creme muito suave
         * - faixa dourada à esquerda
         */
        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__product {
          position:
            relative
            !important;

          overflow:
            hidden
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__product-check {
          display:
            none
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__product-selected-rail {
          position:
            absolute;

          z-index:
            4;

          left:
            0;

          top:
            12px;

          bottom:
            12px;

          width:
            3px;

          border-radius:
            0 999px 999px 0;

          background:
            transparent;

          transition:
            background .18s ease,
            top .18s ease,
            bottom .18s ease;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__product.is-active {
          border-color:
            rgba(200,155,89,.72)
            !important;

          background:
            linear-gradient(
              135deg,
              #fffdf8 0%,
              #fffaf1 100%
            )
            !important;

          box-shadow:
            0
            8px
            24px
            rgba(200,155,89,.10)
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__product.is-active
        .agfx__product-selected-rail {
          background:
            #c89b59;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__product.is-active
        .agfx__thumb {
          border-color:
            rgba(200,155,89,.18)
            !important;

          background:
            rgba(255,255,255,.92)
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__product.is-active
        .agfx__product-info strong {
          color:
            #162f29
            !important;
        }

        /*
         * Mantém Favorito / Comparar totalmente separados
         * do estado de seleção do produto.
         */
        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__product.is-active
        .agfx__product-actions {
          top:
            50%
            !important;

          right:
            9px
            !important;
        }

        /*
         * =====================================================
         * IMPRESSÃO NO VIDRO — MAIS COMPACTA
         * =====================================================
         */
        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__visual-card {
          margin-top:
            7px
            !important;

          padding:
            8px 9px
            !important;

          border-radius:
            10px
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__visual-head {
          min-height:
            19px;

          gap:
            6px;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__visual-title {
          font-size:
            6.8px
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__glass-badge {
          padding:
            3px 6px
            !important;

          font-size:
            5.9px
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__visual-group {
          margin-top:
            5px
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__visual-label {
          margin-bottom:
            4px
            !important;

          font-size:
            6.8px
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__visual-card
        .agfx__segmented {
          gap:
            6px
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__visual-card
        .agfx__segmented-button {
          min-height:
            31px
            !important;

          padding:
            0 8px
            !important;

          font-size:
            8px
            !important;

          font-weight:
            850
            !important;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__visual-note {
          margin-top:
            4px
            !important;

          font-size:
            6.2px
            !important;

          line-height:
            1.35
            !important;
        }

        /*
         * =====================================================
         * FERRAMENTAS AVANÇADAS
         * =====================================================
         *
         * O JS move o bloco para depois de Ajuste da arte.
         * Aqui apenas refinamos a aparência para ele assumir
         * papel secundário.
         */
        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__pro-tools {
          margin-top:
            10px
            !important;

          margin-bottom:
            4px
            !important;

          border:
            1px solid rgba(22,54,47,.09)
            !important;

          border-radius:
            10px
            !important;

          background:
            #fbfcfb
            !important;

          overflow:
            hidden;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__pro-tools > summary {
          min-height:
            37px;

          padding:
            0 11px
            !important;

          display:
            flex;

          align-items:
            center;

          justify-content:
            space-between;

          color:
            #4e5d56
            !important;

          font-size:
            7.2px
            !important;

          font-weight:
            900
            !important;

          letter-spacing:
            .065em
            !important;

          text-transform:
            uppercase;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__pro-tools[open] > summary {
          color:
            #16362f
            !important;

          background:
            #f5f8f6
            !important;
        }

        /*
         * O cabeçalho PEDIDO fica claramente separado
         * das ferramentas avançadas.
         */
        body.agfx-wokiee-studio-page
        [data-agfx]
        [data-section-heading="order"] {
          margin-top:
            16px
            !important;
        }

        @media(max-width:650px) {
          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__product-selected-rail {
            top:
              10px;

            bottom:
              10px;
          }
        }
      `;

      document.head.appendChild(
        finalPolishStyle
      );
    }

    /* ========================================================
       A GOURMET STUDIO V5.17 — VISUAL PRO / PRODUTO MAIOR
       ======================================================== */

    if (!document.getElementById('agfx-v517-visual-pro')) {
      const visualProStyle =
        document.createElement('style');

      visualProStyle.id =
        'agfx-v517-visual-pro';

      visualProStyle.textContent = `
        /*
         * A cena interna (produto + logo + texto + área segura)
         * cresce em conjunto. Assim a personalização continua
         * geometricamente alinhada à peça.
         */
        body.agfx-wokiee-studio-page
        [data-agfx]
        [data-stage] {
          transform-origin:
            center center;

          transition:
            transform .28s
            cubic-bezier(.2,.72,.28,1);

          will-change:
            transform;
        }

        /*
         * A moldura continua recortando a cena com segurança.
         */
        body.agfx-wokiee-studio-page
        [data-agfx]
        [data-capture] {
          overflow:
            hidden
            !important;
        }

        /*
         * Pequeno feedback enquanto uma nova peça está entrando.
         */
        body.agfx-wokiee-studio-page
        [data-agfx]
        [data-capture].is-product-switching
        [data-stage] {
          opacity:
            .82;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        [data-stage] {
          opacity:
            1;

          transition:
            transform .28s
            cubic-bezier(.2,.72,.28,1),
            opacity .16s ease;
        }

        /*
         * Etiqueta discreta no topo do preview quando o
         * enquadramento inteligente é recalculado.
         */
        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__smart-fit-badge {
          position:
            absolute;

          z-index:
            12;

          top:
            14px;

          left:
            50%;

          transform:
            translate(-50%,-5px);

          padding:
            5px 9px;

          border:
            1px solid
            rgba(22,54,47,.08);

          border-radius:
            999px;

          color:
            #456158;

          background:
            rgba(255,255,255,.91);

          box-shadow:
            0 7px 22px
            rgba(22,54,47,.07);

          backdrop-filter:
            blur(10px);

          -webkit-backdrop-filter:
            blur(10px);

          font-size:
            6.2px;

          font-weight:
            900;

          letter-spacing:
            .045em;

          text-transform:
            uppercase;

          opacity:
            0;

          pointer-events:
            none;

          transition:
            opacity .18s ease,
            transform .18s ease;
        }

        body.agfx-wokiee-studio-page
        [data-agfx]
        .agfx__smart-fit-badge.is-visible {
          opacity:
            1;

          transform:
            translate(-50%,0);
        }

        /*
         * Em telas menores não exageramos no crescimento.
         */
        @media(max-width:1099px) {
          body.agfx-wokiee-studio-page
          [data-agfx]
          [data-stage] {
            transform:
              none
              !important;
          }

          body.agfx-wokiee-studio-page
          [data-agfx]
          .agfx__smart-fit-badge {
            display:
              none;
          }
        }
      `;

      document.head.appendChild(
        visualProStyle
      );
    }

    /* ========================================================
       DADOS INICIAIS
       ======================================================== */

    let products = [];

    try {
      const productsJSON = root.querySelector('[data-products]');

      products = JSON.parse(
        productsJSON?.textContent || '[]'
      );
    } catch (error) {
      console.error(
        'A Gourmet Studio — erro ao ler produtos iniciais:',
        error
      );

      products = [];
    }

    const whatsapp =
      root.dataset.whatsapp || '';

    const shopDomain =
      root.dataset.shopDomain ||
      window.Shopify?.shop ||
      '';

    /*
     * Opcional.
     *
     * Se futuramente precisarmos usar Storefront Access Token,
     * basta adicionar no Liquid:
     *
     * data-storefront-token="SEU_TOKEN"
     *
     * Por enquanto não é obrigatório.
     */
    const storefrontToken =
      root.dataset.storefrontToken || '';

    /* ========================================================
       PREPARA CONTROLES: OPACIDADE -> CURVATURA
       ======================================================== */

    const legacyOpacityInput =
      root.querySelector('[data-op]');

    const legacyOpacityValue =
      root.querySelector('[data-vop]');

    if (legacyOpacityInput) {
      legacyOpacityInput.removeAttribute('data-op');
      legacyOpacityInput.setAttribute('data-curve', '');

      legacyOpacityInput.min = '-60';
      legacyOpacityInput.max = '60';
      legacyOpacityInput.step = '1';
      legacyOpacityInput.value = '0';

      const control =
        legacyOpacityInput.closest('.agfx__control');

      const label =
        control?.querySelector(
          '.agfx__control-head span:first-child'
        );

      if (label) {
        label.textContent = 'Curvatura';
      }
    }

    if (legacyOpacityValue) {
      legacyOpacityValue.removeAttribute('data-vop');
      legacyOpacityValue.setAttribute('data-vcurve', '');
      legacyOpacityValue.textContent = '0';
    }

    /*
     * Adiciona a categoria TALHERES automaticamente.
     * Assim não precisamos alterar o Liquid agora.
     */
    const categoriesContainer =
      root.querySelector(
        '.agfx__categories'
      );

    if (
      categoriesContainer &&
      !root.querySelector(
        '[data-category="talheres"]'
      )
    ) {
      const talheresCategory =
        document.createElement(
          'button'
        );

      talheresCategory.type =
        'button';

      talheresCategory.className =
        'agfx__category';

      talheresCategory.setAttribute(
        'data-category',
        'talheres'
      );

      talheresCategory.textContent =
        'Talheres';

      categoriesContainer.appendChild(
        talheresCategory
      );
    }

    /*
     * Favoritos ficam salvos no navegador.
     */
    if (
      categoriesContainer &&
      !root.querySelector(
        '[data-category="favoritos"]'
      )
    ) {
      const favoritesCategory =
        document.createElement(
          'button'
        );

      favoritesCategory.type =
        'button';

      favoritesCategory.className =
        'agfx__category';

      favoritesCategory.setAttribute(
        'data-category',
        'favoritos'
      );

      favoritesCategory.textContent =
        'Salvos';

      categoriesContainer.appendChild(
        favoritesCategory
      );
    }

    /* ========================================================
       ELEMENTOS
       ======================================================== */

    const els = {
      base: root.querySelector('[data-base]'),
      logo: root.querySelector('[data-logo]'),
      placeholder: root.querySelector('[data-placeholder]'),
      stage: root.querySelector('[data-stage]'),
      capture: root.querySelector('[data-capture]'),

      file: root.querySelector('[data-file]'),

      scale: root.querySelector('[data-scale]'),
      rot: root.querySelector('[data-rot]'),
      curve: root.querySelector('[data-curve]'),

      vscale: root.querySelector('[data-vscale]'),
      vrot: root.querySelector('[data-vrot]'),
      vcurve: root.querySelector('[data-vcurve]'),

      qty: root.querySelector('[data-qty]'),
      position: root.querySelector('[data-position]'),

      title: root.querySelector('[data-title]'),
      meta: root.querySelector('[data-meta]'),

      ready: root.querySelector('[data-ready]'),

      sumProduct: root.querySelector('[data-sum-product]'),
      sumQty: root.querySelector('[data-sum-qty]'),
      sumPosition: root.querySelector('[data-sum-position]'),

      search: root.querySelector('[data-product-search]'),

      categoryButtons:
        root.querySelectorAll('[data-category]'),

      productList:
        root.querySelector('[data-product-list]'),

      empty:
        root.querySelector('[data-products-empty]'),

      loading:
        root.querySelector('[data-products-loading]'),

      loadMore:
        root.querySelector('[data-load-more]'),

      count:
        root.querySelector('[data-library-count]')
    };

    /* ========================================================
       ESTADO
       ======================================================== */

    let active = null;

    let logoUrl = null;

    let previewGenerated = false;

    let currentCategory = 'all';
    let currentSearch = '';

    let searchTimer = null;

    let state = {
      x: 0,
      y: 0,
      s: 1,
      r: 0,
      c: 0,

      drag: false,
      dx: 0,
      dy: 0
    };

    const favoritesStorageKey =
      'agourmet-studio-favorites-v1';

    const compareStorageKey =
      'agourmet-studio-compare-v1';

    let favoriteRecords = [];
    let compareRecords = [];

    let viewZoom = 1;

    /*
     * V5.7:
     * chamadas são definidas aqui para a seleção do produto
     * poder usá-las antes da declaração visual do Zoom.
     */
    let autoFitProductView =
      () => {};

    let applyProductArtworkDefaults =
      () => {};

    /*
     * V5.6:
     * fundo da prévia fixo.
     * A opção de troca de fundo foi removida da interface.
     */
    let previewBackgroundMode =
      'light';

    let previewBackgroundUserChanged =
      false;

    let previewBackgroundAutoGlass =
      false;

    let printInkMode =
      'color';

    /*
     * Camada comercial.
     */
    const projectIdStorageKey =
      'agourmet-studio-current-project-id-v1';

    const buildProjectId = () => {
      const now =
        new Date();

      const date =
        [
          now.getFullYear(),
          String(
            now.getMonth() + 1
          ).padStart(2, '0'),
          String(
            now.getDate()
          ).padStart(2, '0')
        ].join('');

      let random = '';

      try {
        const values =
          new Uint32Array(1);

        crypto.getRandomValues(
          values
        );

        random =
          values[0]
            .toString(36)
            .toUpperCase()
            .slice(0, 5)
            .padStart(5, '0');

      } catch (error) {
        random =
          Math.random()
            .toString(36)
            .slice(2, 7)
            .toUpperCase()
            .padEnd(5, '0');
      }

      return `AG-${date}-${random}`;
    };

    let projectId =
      sessionStorage.getItem(
        projectIdStorageKey
      ) ||
      buildProjectId();

    sessionStorage.setItem(
      projectIdStorageKey,
      projectId
    );

    let commercialProjectTouched =
      false;

    let quoteRequested =
      false;

    const categoryTotals = {
      all: null,
      pratos: null,
      xicaras: null,
      tacas: null,
      copos: null,
      travessas: null,
      bowls: null,
      canecas: null,
      talheres: null,
      favoritos: 0
    };

    let categoryCountsSearchKey =
      null;

    const shopifyLibrary = {
      loading: false,

      cursor: null,

      hasNextPage: true,

      initialized: false,

      pageSize: 20
    };

    /* ========================================================
       CATEGORIAS
       ======================================================== */

    const categoryQueries = {
      all: '',

      pratos:
        '(title:Prato OR product_type:Prato OR product_type:Pratos)',

      xicaras:
        '(title:Xícara OR title:Xicara OR product_type:Xícara OR product_type:Xicara)',

      tacas:
        '(title:Taça OR title:Taca OR product_type:Taça OR product_type:Taca)',

      copos:
        '(title:Copo OR product_type:Copo OR product_type:Copos)',

      travessas:
        '(title:Travessa OR title:Bandeja OR product_type:Travessa OR product_type:Bandeja)',

      bowls:
        '(title:Bowl OR title:Tigela OR title:Cumbuca OR title:Saladeira OR product_type:Bowl OR product_type:Tigela OR product_type:Cumbuca OR product_type:Saladeira)',

      canecas:
        '(title:Caneca OR product_type:Caneca OR product_type:Canecas)',

      talheres:
        '(title:Garfo OR title:Faca OR title:Colher OR title:Talher OR title:Cutelo OR product_type:Talheres OR product_type:"Garfo Mesa" OR product_type:"Faca Mesa" OR product_type:"Colher Mesa")',

      favoritos: '',
      outros: ''
    };

    /* ========================================================
       HELPERS
       ======================================================== */

    const normalize = (value = '') => {
      return String(value)
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()
        .trim();
    };

    const escapeHTML = (value = '') => {
      return String(value)
        .replaceAll('&', '&amp;')
        .replaceAll('<', '&lt;')
        .replaceAll('>', '&gt;')
        .replaceAll('"', '&quot;')
        .replaceAll("'", '&#039;');
    };

    const getProductKey = (
      productOrId
    ) => {
      if (
        productOrId &&
        typeof productOrId ===
          'object'
      ) {
        return String(
          productOrId.id ||
          productOrId.shopifyId ||
          productOrId.handle ||
          ''
        );
      }

      return String(
        productOrId || ''
      );
    };

    const loadJSONStorage = (
      key,
      fallback = []
    ) => {
      try {
        const value =
          localStorage.getItem(
            key
          );

        if (!value) {
          return fallback;
        }

        const parsed =
          JSON.parse(
            value
          );

        return Array.isArray(
          parsed
        )
          ? parsed
          : fallback;

      } catch (error) {
        return fallback;
      }
    };

    const saveJSONStorage = (
      key,
      value
    ) => {
      try {
        localStorage.setItem(
          key,
          JSON.stringify(
            value
          )
        );
      } catch (error) {
        console.warn(
          'A Gourmet Studio — armazenamento local:',
          error
        );
      }
    };

    favoriteRecords =
      loadJSONStorage(
        favoritesStorageKey,
        []
      );

    compareRecords =
      loadJSONStorage(
        compareStorageKey,
        []
      )
        .slice(
          0,
          3
        );

    categoryTotals.favoritos =
      favoriteRecords.length;

    const isFavoriteId = (
      id
    ) => {
      const key =
        getProductKey(id);

      return favoriteRecords.some(
        (item) =>
          getProductKey(
            item
          ) === key
      );
    };

    const isComparedId = (
      id
    ) => {
      const key =
        getProductKey(id);

      return compareRecords.some(
        (item) =>
          getProductKey(
            item
          ) === key
      );
    };

    const productSnapshot = (
      product
    ) => ({
      id:
        product.id,

      shopifyId:
        product.shopifyId ||
        null,

      source:
        'favorite-cache',

      handle:
        product.handle ||
        '',

      name:
        product.name ||
        '',

      productType:
        product.productType ||
        '',

      category:
        product.category ||
        detectCategory(
          product.name,
          product.productType
        ),

      meta:
        product.meta ||
        '',

      minimum:
        product.minimum ||
        1,

      image:
        product.image ||
        '',

      basePrice:
        product.basePrice ||
        0,

      currency:
        product.currency ||
        'BRL',

      profile:
        product.profile ||
        buildProductProfile(
          product,
          product.metafields ||
          []
        )
    });

    const refreshProductActionUI = () => {
      getProductButtons()
        .forEach(
          (button) => {
            const id =
              button.dataset.product;

            const favorite =
              button.querySelector(
                '[data-favorite-toggle]'
              );

            const compare =
              button.querySelector(
                '[data-compare-toggle]'
              );

            if (favorite) {
              const active =
                isFavoriteId(
                  id
                );

              favorite.classList.toggle(
                'is-active',
                active
              );

              favorite.innerHTML =
                getProductActionIcon(
                  'favorite',
                  active
                );

              favorite.title =
                active
                  ? 'Remover dos favoritos'
                  : 'Adicionar aos favoritos';
            }

            if (compare) {
              const active =
                isComparedId(
                  id
                );

              compare.classList.toggle(
                'is-active',
                active
              );

              compare.title =
                active
                  ? 'Remover da comparação'
                  : 'Comparar produto';

              compare.innerHTML =
                getProductActionIcon(
                  'compare',
                  active
                );
            }
          }
        );
    };

    const updateFavoritesCount = () => {
      categoryTotals.favoritos =
        favoriteRecords.length;

      const count =
        root.querySelector(
          '[data-category="favoritos"] [data-category-count]'
        );

      if (count) {
        count.textContent =
          String(
            favoriteRecords.length
          );
      }
    };

    const toggleFavorite = (
      product
    ) => {
      const key =
        getProductKey(
          product
        );

      const index =
        favoriteRecords.findIndex(
          (item) =>
            getProductKey(
              item
            ) === key
        );

      if (index >= 0) {
        favoriteRecords.splice(
          index,
          1
        );

        track(
          'favorite_remove'
        );

      } else {
        favoriteRecords.push(
          productSnapshot(
            product
          )
        );

        track(
          'favorite_add'
        );
      }

      saveJSONStorage(
        favoritesStorageKey,
        favoriteRecords
      );

      updateFavoritesCount();
      refreshProductActionUI();
      updateStudioStatus();

      if (
        currentCategory ===
        'favoritos'
      ) {
        applyProductFilters();
      }
    };

    const toggleCompare = (
      product
    ) => {
      const key =
        getProductKey(
          product
        );

      const index =
        compareRecords.findIndex(
          (item) =>
            getProductKey(
              item
            ) === key
        );

      if (index >= 0) {
        compareRecords.splice(
          index,
          1
        );

      } else {
        if (
          compareRecords.length >=
          3
        ) {
          showToast(
            'Compare no máximo 3 produtos'
          );

          return;
        }

        compareRecords.push(
          productSnapshot(
            product
          )
        );
      }

      saveJSONStorage(
        compareStorageKey,
        compareRecords
      );

      refreshProductActionUI();
      updateCompareTray();
      updateStudioStatus();

      track(
        'compare_toggle',
        {
          count:
            compareRecords.length
        }
      );
    };

    const parseProductId = (rawId) => {
      if (/^\d+$/.test(String(rawId))) {
        return Number(rawId);
      }

      return rawId;
    };

    const getProductButtons = () => {
      return [
        ...root.querySelectorAll('[data-product]')
      ];
    };

    const getProductButton = (id) => {
      return getProductButtons().find(
        (button) =>
          String(button.dataset.product) ===
          String(id)
      );
    };

    const detectCategory = (
      name = '',
      productType = ''
    ) => {
      const value =
        normalize(
          `${name} ${productType}`
        );

      if (
        value.includes('talher') ||
        value.includes('garfo') ||
        value.includes('faca') ||
        value.includes('colher') ||
        value.includes('cutelo')
      ) {
        return 'talheres';
      }

      if (value.includes('prato')) {
        return 'pratos';
      }

      if (value.includes('xicara')) {
        return 'xicaras';
      }

      if (value.includes('taca')) {
        return 'tacas';
      }

      if (value.includes('copo')) {
        return 'copos';
      }

      if (value.includes('travessa')) {
        return 'travessas';
      }

      if (
        value.includes('bowl') ||
        value.includes('tigela')
      ) {
        return 'bowls';
      }

      if (value.includes('caneca')) {
        return 'canecas';
      }

      return 'outros';
    };

    const categoryLabels = {
      all: 'Todos',
      pratos: 'Pratos',
      xicaras: 'Xícaras',
      tacas: 'Taças',
      copos: 'Copos',
      travessas: 'Travessas',
      bowls: 'Bowls',
      canecas: 'Canecas',
      talheres: 'Talheres',
      favoritos: 'Salvos'
    };

    const decorateCategoryButtons = () => {
      els.categoryButtons.forEach(
        (button) => {
          const category =
            button.dataset.category;

          if (!category) {
            return;
          }

          button.innerHTML = `
            <span class="agfx__category-label">
              ${escapeHTML(
                categoryLabels[
                  category
                ] ||
                button.textContent ||
                category
              )}
            </span>

            <span
              class="agfx__category-count"
              data-category-count
            >
              ${
                category ===
                'favoritos'
                  ? favoriteRecords.length
                  : '—'
              }
            </span>
          `;
        }
      );
    };

    decorateCategoryButtons();

    /*
     * Ícones profissionais dos cards.
     * Evita os caracteres ♡ e ⇄, que ficavam visualmente frágeis.
     */
    const getProductActionIcon = (
      type,
      active = false
    ) => {
      if (type === 'favorite') {
        return `
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path
              ${
                active
                  ? 'fill="currentColor"'
                  : 'fill="none"'
              }
              d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z"
            />
          </svg>
        `;
      }

      if (type === 'compare') {
        return `
          <svg
            viewBox="0 0 24 24"
            aria-hidden="true"
          >
            <path d="M7 7h11" />
            <path d="m14 4 4 3-4 3" />
            <path d="M17 17H6" />
            <path d="m10 14-4 3 4 3" />
          </svg>
        `;
      }

      return '';
    };

    /*
     * Status rápido do Studio:
     * salvos + itens em comparação.
     */
    const studioStatus =
      document.createElement(
        'div'
      );

    studioStatus.className =
      'agfx__studio-status';

    studioStatus.setAttribute(
      'data-studio-status',
      ''
    );

    studioStatus.innerHTML = `
      <div class="agfx__studio-status-item">
        <span class="agfx__studio-status-icon">
          ♥
        </span>

        <span class="agfx__studio-status-copy">
          <strong data-status-saved>
            0 salvos
          </strong>

          <span>
            no Studio
          </span>
        </span>
      </div>

      <div class="agfx__studio-status-item">
        <span class="agfx__studio-status-icon">
          ⇄
        </span>

        <span class="agfx__studio-status-copy">
          <strong data-status-compare>
            0 comparando
          </strong>

          <span>
            no Studio
          </span>
        </span>
      </div>
    `;

    const libraryDivider =
      root.querySelector(
        '.agfx__library-divider'
      );

    if (
      libraryDivider &&
      !root.querySelector(
        '[data-studio-status]'
      )
    ) {
      libraryDivider.insertAdjacentElement(
        'beforebegin',
        studioStatus
      );
    }

    const updateStudioStatus = () => {
      const saved =
        root.querySelector(
          '[data-status-saved]'
        );

      const comparing =
        root.querySelector(
          '[data-status-compare]'
        );

      if (saved) {
        saved.textContent =
          `${favoriteRecords.length} ${
            favoriteRecords.length === 1
              ? 'salvo'
              : 'salvos'
          }`;
      }

      if (comparing) {
        comparing.textContent =
          `${compareRecords.length} comparando`;
      }
    };

    updateStudioStatus();

    /*
     * Vidro / cristal.
     */
    const isGlassProduct = (
      product
    ) => {
      if (!product) {
        return false;
      }

      const value =
        normalize(
          `${
            product.name ||
            product.title ||
            ''
          } ${
            product.productType ||
            ''
          } ${
            product.meta ||
            ''
          }`
        );

      return (
        value.includes('vidro') ||
        value.includes('glass') ||
        value.includes('cristal') ||
        value.includes('crystal')
      );
    };

    /*
     * Produtos em que a gravação a laser faz sentido.
     * Por enquanto usamos nome/tipo do produto, sem exigir
     * alteração no cadastro da Shopify.
     */
    const isLaserProduct = (
      product
    ) => {
      if (!product) return false;

      const tags =
        Array.isArray(
          product.tags
        )
          ? product.tags.join(' ')
          : (
              product.tags ||
              ''
            );

      const value =
        normalize(
          `${product.name || ''} ${product.title || ''} ${product.productType || ''} ${product.meta || ''} ${product.category || ''} ${tags}`
        );

      /*
       * REGRA COMERCIAL A GOURMET:
       * qualquer produto classificado como Talheres
       * utiliza exclusivamente gravação a laser.
       */
      return (
        normalize(
          product.category ||
          ''
        ) === 'talheres' ||
        value.includes('talher') ||
        value.includes('garfo') ||
        value.includes('faca') ||
        value.includes('colher') ||
        value.includes('cutelo') ||
        value.includes('espatula') ||
        value.includes('pegador')
      );
    };

    /* ========================================================
       PERFIL DO PRODUTO + ANALYTICS
       ======================================================== */

    const track = (
      eventName,
      data = {}
    ) => {
      const payload = {
        event:
          `ag_studio_${eventName}`,

        product:
          active?.name || null,

        product_id:
          active?.shopifyId ||
          active?.id ||
          null,

        technique:
          laserEnabled
            ? 'laser'
            : 'print',

        ...data
      };

      if (
        Array.isArray(
          window.dataLayer
        )
      ) {
        window.dataLayer.push(
          payload
        );
      }

      window.dispatchEvent(
        new CustomEvent(
          'ag-studio:event',
          {
            detail:
              payload
          }
        )
      );
    };

    const parseBoolean = (
      value,
      fallback = false
    ) => {
      if (
        value === true ||
        value === 'true' ||
        value === '1'
      ) {
        return true;
      }

      if (
        value === false ||
        value === 'false' ||
        value === '0'
      ) {
        return false;
      }

      return fallback;
    };

    const parseNumber = (
      value,
      fallback = 0
    ) => {
      const number =
        Number(value);

      return Number.isFinite(number)
        ? number
        : fallback;
    };

    const getMetafieldMap = (
      metafields = []
    ) => {
      const map = {};

      metafields
        .filter(Boolean)
        .forEach(
          (field) => {
            map[
              `${field.namespace}.${field.key}`
            ] =
              field.value;
          }
        );

      return map;
    };

    const buildProductProfile = (
      product,
      metafields = []
    ) => {
      const mf =
        getMetafieldMap(
          metafields
        );

      const name =
        product?.title ||
        product?.name ||
        '';

      const type =
        product?.productType ||
        '';

      const fallbackLaser =
        (
          normalize(
            `${name} ${type}`
          ).match(
            /(talher|garfo|faca|colher|cutelo)/
          )
        ) !== null;

      const category =
        detectCategory(
          name,
          type
        );

      const defaultZone =
        fallbackLaser
          ? 'cabo'
          : (
              category === 'pratos'
                ? 'centro'
                : 'frente'
            );

      const technique =
        (
          mf[
            'personalization.technique'
          ] ||
          (
            fallbackLaser
              ? 'laser'
              : 'print'
          )
        )
          .toLowerCase();

      const profile = {
        enabled:
          parseBoolean(
            mf[
              'personalization.enabled'
            ],
            true
          ),

        technique,

        minimum:
          Math.max(
            1,
            parseNumber(
              mf[
                'personalization.minimum'
              ],
              50
            )
          ),

        zone:
          mf[
            'personalization.zone'
          ] ||
          defaultZone,

        defaultScale:
          parseNumber(
            mf[
              'personalization.default_scale'
            ],
            fallbackLaser
              ? .82
              : 1
          ),

        defaultRotation:
          parseNumber(
            mf[
              'personalization.default_rotation'
            ],
            fallbackLaser
              ? 318
              : 0
          ),

        defaultX:
          parseNumber(
            mf[
              'personalization.default_x'
            ],
            fallbackLaser
              ? -16
              : 0
          ),

        defaultY:
          parseNumber(
            mf[
              'personalization.default_y'
            ],
            fallbackLaser
              ? 20
              : 0
          ),

        allowCurve:
          parseBoolean(
            mf[
              'personalization.allow_curve'
            ],
            !fallbackLaser
          ),

        allowRealism:
          parseBoolean(
            mf[
              'personalization.allow_realism'
            ],
            !fallbackLaser
          ),

        personalizationPrice:
          parseNumber(
            mf[
              'personalization.price'
            ],
            0
          ),

        /*
         * Enquadramento visual da peça.
         * Pode ser refinado produto a produto no futuro usando
         * metafields, sem alterar o código do Studio.
         */
        displayScale:
          parseNumber(
            mf[
              'personalization.display_scale'
            ],
            0
          ),

        displayX:
          parseNumber(
            mf[
              'personalization.display_x'
            ],
            0
          ),

        displayY:
          parseNumber(
            mf[
              'personalization.display_y'
            ],
            0
          ),

        safeArea: {
          x:
            parseNumber(
              mf[
                'personalization.safe_x'
              ],
              50
            ),

          y:
            parseNumber(
              mf[
                'personalization.safe_y'
              ],
              50
            ),

          width:
            parseNumber(
              mf[
                'personalization.safe_width'
              ],
              fallbackLaser
                ? 38
                : 48
            ),

          height:
            parseNumber(
              mf[
                'personalization.safe_height'
              ],
              fallbackLaser
                ? 14
                : 48
            ),

          rotation:
            parseNumber(
              mf[
                'personalization.safe_rotation'
              ],
              fallbackLaser
                ? -42
                : 0
            )
        }
      };

      return profile;
    };

    const applySafeAreaProfile = (
      product
    ) => {
      const safe =
        els.capture
          ?.querySelector(
            '.agfx__safe'
          );

      if (
        !safe ||
        !product?.profile?.safeArea
      ) {
        return;
      }

      const area =
        product.profile.safeArea;

      safe.style.left =
        `${area.x}%`;

      safe.style.top =
        `${area.y}%`;

      safe.style.width =
        `${area.width}%`;

      safe.style.height =
        `${area.height}%`;

      safe.style.borderRadius =
        product.profile.zone === 'cabo'
          ? '12px'
          : '50%';

      safe.style.transform =
        `translate(-50%,-50%) rotate(${area.rotation}deg)`;
    };

    /* ========================================================
       ENQUADRAMENTO VISUAL INTELIGENTE DA PEÇA
       ======================================================== */

    const getCategoryDisplayScale = (
      product
    ) => {
      const category =
        product?.category ||
        detectCategory(
          product?.name ||
          product?.title ||
          '',
          product?.productType ||
          ''
        );

      const defaults = {
        pratos: 1.09,
        xicaras: 1.14,
        tacas: 1.16,
        copos: 1.15,
        travessas: 1.10,
        bowls: 1.12,
        canecas: 1.14,
        talheres: 1.08,
        outros: 1.10
      };

      return (
        defaults[
          category
        ] ||
        1.10
      );
    };

    const getProductDisplayProfile = (
      product
    ) => {
      const customScale =
        Number(
          product?.profile
            ?.displayScale
        );

      const customX =
        Number(
          product?.profile
            ?.displayX
        );

      const customY =
        Number(
          product?.profile
            ?.displayY
        );

      return {
        scale:
          Number.isFinite(
            customScale
          ) &&
          customScale > 0
            ? Math.max(
                .90,
                Math.min(
                  1.28,
                  customScale
                )
              )
            : getCategoryDisplayScale(
                product
              ),

        x:
          Number.isFinite(
            customX
          )
            ? Math.max(
                -12,
                Math.min(
                  12,
                  customX
                )
              )
            : 0,

        y:
          Number.isFinite(
            customY
          )
            ? Math.max(
                -12,
                Math.min(
                  12,
                  customY
                )
              )
            : 0
      };
    };

    let smartFitBadgeTimer =
      null;

    const smartFitBadge =
      document.createElement(
        'div'
      );

    smartFitBadge.className =
      'agfx__smart-fit-badge';

    smartFitBadge.textContent =
      'Enquadramento automático';

    els.capture
      ?.appendChild(
        smartFitBadge
      );

    const showSmartFitBadge = () => {
      if (!smartFitBadge) {
        return;
      }

      smartFitBadge.classList.add(
        'is-visible'
      );

      clearTimeout(
        smartFitBadgeTimer
      );

      smartFitBadgeTimer =
        setTimeout(
          () => {
            smartFitBadge
              .classList
              .remove(
                'is-visible'
              );
          },
          1100
        );
    };

    const applyProductDisplayProfile = (
      product,
      {
        notify = false
      } = {}
    ) => {
      if (
        !els.stage ||
        !product
      ) {
        return;
      }

      /*
       * Em mobile/tablet mantemos escala 1.
       * O ganho visual é destinado ao layout desktop full-width.
       */
      if (
        window.innerWidth <
        1100
      ) {
        els.stage.style.transform =
          '';

        return;
      }

      const profile =
        getProductDisplayProfile(
          product
        );

      els.stage.dataset.displayScale =
        String(
          profile.scale
        );

      els.stage.style.transform =
        `translate(${profile.x}%, ${profile.y}%) scale(${profile.scale})`;

      if (notify) {
        showSmartFitBadge();
      }
    };

    const resetProductDisplayProfile =
      () => {
        if (!els.stage) {
          return;
        }

        els.stage.style.transform =
          '';

        els.stage.removeAttribute(
          'data-display-scale'
        );
      };

    window.addEventListener(
      'resize',
      () => {
        if (
          window.innerWidth <
          1100
        ) {
          resetProductDisplayProfile();

        } else if (active) {
          applyProductDisplayProfile(
            active
          );
        }
      },
      {
        passive: true
      }
    );

    /* ========================================================
       RENDERIZAÇÃO DA LOGO — CURVATURA + REALISMO + LASER
       ======================================================== */

    let logoLoaded = false;
    let realismEnabled = false;
    let laserEnabled = false;
    let cleanedLogoCanvas = null;

    let blendButton = null;
    let laserButton = null;
    let techniqueCard = null;
    let presetBox = null;
    let adjustHandleButton = null;
    let safeButtonOriginalText = null;

    /*
     * Studio Pro V5
     */
    let removeBackgroundEnabled = true;
    let logoQuality = {
      level: 'empty',
      label: 'Nenhuma arte carregada',
      width: 0,
      height: 0
    };

    let logoDataUrl = null;
    let pendingProject = null;

    let textState = {
      value: '',
      x: 0,
      y: 0,
      size: 28,
      rotation: 0,
      color: '#16362f',
      bold: false,
      drag: false,
      dx: 0,
      dy: 0
    };

    const projectStorageKey =
      'agourmet-studio-project-v5';

    const history = [];
    let historyIndex = -1;
    let historyLocked = false;

    const logoCanvas =
      document.createElement('canvas');

    logoCanvas.className =
      'agfx__logo agfx__logo-render is-hidden';

    logoCanvas.setAttribute(
      'aria-hidden',
      'true'
    );

    logoCanvas.style.pointerEvents =
      'none';

    logoCanvas.style.willChange =
      'transform, filter, opacity';

    if (els.stage) {
      els.stage.appendChild(
        logoCanvas
      );
    }

    const logoContext =
      logoCanvas.getContext('2d');

    const textLayer =
      document.createElement(
        'div'
      );

    textLayer.className =
      'agfx__text-layer is-hidden';

    textLayer.setAttribute(
      'data-text-layer',
      ''
    );

    if (els.stage) {
      els.stage.appendChild(
        textLayer
      );
    }

    const updateTextLayer = () => {
      const value =
        String(
          textState.value || ''
        ).trim();

      textLayer.textContent =
        value;

      textLayer.classList.toggle(
        'is-hidden',
        !value
      );

      textLayer.style.fontSize =
        `${textState.size}px`;

      textLayer.style.fontWeight =
        textState.bold
          ? '800'
          : '600';

      textLayer.style.color =
        laserEnabled
          ? '#6b716e'
          : (
              printInkMode ===
                'white'
                ? '#ffffff'
                : (
                    printInkMode ===
                      'black'
                      ? '#171b19'
                      : textState.color
                  )
            );

      textLayer.style.mixBlendMode =
        laserEnabled
          ? 'multiply'
          : (
              realismEnabled
                ? 'multiply'
                : 'normal'
            );

      textLayer.style.opacity =
        laserEnabled
          ? '.84'
          : '1';

      textLayer.style.filter =
        laserEnabled
          ? 'grayscale(1) contrast(1.05)'
          : 'none';

      textLayer.style.transform =
        `translate(-50%,-50%) translate(${textState.x}px, ${textState.y}px) rotate(${textState.rotation}deg)`;
    };

    /*
     * A imagem original fica apenas como fonte.
     * O canvas é quem aparece sobre o produto.
     */
    if (els.logo) {
      els.logo.style.display =
        'none';
    }

    /*
     * Cria um canvas auxiliar.
     */
    const createCanvas = (
      width,
      height
    ) => {
      const canvas =
        document.createElement(
          'canvas'
        );

      canvas.width =
        Math.max(
          2,
          Math.round(width)
        );

      canvas.height =
        Math.max(
          2,
          Math.round(height)
        );

      return canvas;
    };

    /*
     * Fonte de logo com fundo claro removido.
     * Mantém transparência real para PNG/SVG e também
     * remove branco/cinza-claro de JPGs.
     */
    const getSourceSize = (source) => ({
      width:
        source?.width ||
        source?.naturalWidth ||
        0,

      height:
        source?.height ||
        source?.naturalHeight ||
        0
    });

    const getRenderableLogoSource = () => {
      return cleanedLogoCanvas || els.logo;
    };

    const buildTransparentLogoCanvas = () => {
      if (
        !els.logo ||
        !els.logo.naturalWidth ||
        !els.logo.naturalHeight
      ) {
        cleanedLogoCanvas = null;
        return null;
      }

      const sourceCanvas =
        createCanvas(
          els.logo.naturalWidth,
          els.logo.naturalHeight
        );

      const sourceContext =
        sourceCanvas.getContext(
          '2d',
          {
            willReadFrequently: true
          }
        );

      if (!sourceContext) {
        cleanedLogoCanvas = null;
        return null;
      }

      sourceContext.clearRect(
        0,
        0,
        sourceCanvas.width,
        sourceCanvas.height
      );

      sourceContext.drawImage(
        els.logo,
        0,
        0,
        sourceCanvas.width,
        sourceCanvas.height
      );

      /*
       * O usuário pode manter o fundo original da arte.
       */
      if (!removeBackgroundEnabled) {
        cleanedLogoCanvas =
          sourceCanvas;

        return cleanedLogoCanvas;
      }

      try {
        const imageData =
          sourceContext.getImageData(
            0,
            0,
            sourceCanvas.width,
            sourceCanvas.height
          );

        const data =
          imageData.data;

        for (
          let i = 0;
          i < data.length;
          i += 4
        ) {
          const r = data[i];
          const g = data[i + 1];
          const b = data[i + 2];
          const a = data[i + 3];

          if (a === 0) continue;

          const max =
            Math.max(r, g, b);

          const min =
            Math.min(r, g, b);

          const avg =
            (r + g + b) / 3;

          const saturation =
            max - min;

          /*
           * Remove somente tons muito claros e pouco saturados.
           * Assim não apaga amarelos claros ou outras cores da arte.
           */
          const isNearWhite =
            avg >= 244 &&
            saturation <= 18;

          const isSoftWhiteEdge =
            avg >= 228 &&
            saturation <= 16;

          if (isNearWhite) {
            data[i + 3] = 0;
            continue;
          }

          if (isSoftWhiteEdge) {
            const fade =
              Math.max(
                0,
                Math.min(
                  1,
                  (244 - avg) / 16
                )
              );

            data[i + 3] =
              Math.round(
                a * fade
              );
          }
        }

        sourceContext.putImageData(
          imageData,
          0,
          0
        );

      } catch (error) {
        /*
         * Se o navegador bloquear leitura de pixels,
         * mantém a logo original em vez de quebrar o Studio.
         */
        console.warn(
          'A Gourmet Studio — não foi possível remover o fundo claro da logo:',
          error
        );
      }

      cleanedLogoCanvas =
        sourceCanvas;

      return cleanedLogoCanvas;
    };

    /*
     * Curvatura vertical controlada pelo slider.
     *
     * -60 = arco para um sentido
     *   0 = logo reta
     * +60 = arco para o outro sentido
     */
    const drawVerticalCurve = (
      targetContext,
      width,
      height,
      ratio
    ) => {
      const source =
        getRenderableLogoSource();

      if (!source) return;

      const sourceSize =
        getSourceSize(source);

      const sourceWidth =
        sourceSize.width;

      const sourceHeight =
        sourceSize.height;

      if (
        !sourceWidth ||
        !sourceHeight
      ) {
        return;
      }

      const curve =
        Math.max(
          -60,
          Math.min(
            60,
            Number(state.c) || 0
          )
        );

      if (curve === 0) {
        targetContext.clearRect(
          0,
          0,
          width,
          height
        );

        targetContext.drawImage(
          source,
          0,
          0,
          width,
          height
        );

        return;
      }

      const direction =
        curve >= 0
          ? 1
          : -1;

      const strength =
        Math.abs(curve) / 60;

      const maxOffset =
        height *
        0.17 *
        strength;

      const verticalPadding =
        maxOffset;

      const drawHeight =
        Math.max(
          2,
          height -
          verticalPadding * 2
        );

      const slice =
        Math.max(
          1,
          Math.round(
            width / 520
          )
        );

      const sourceScaleX =
        sourceWidth / width;

      for (
        let x = 0;
        x < width;
        x += slice
      ) {
        const sliceWidth =
          Math.min(
            slice,
            width - x
          );

        const centerX =
          x +
          sliceWidth / 2;

        const normalized =
          (
            centerX /
            width
          ) * 2 - 1;

        const offset =
          direction *
          maxOffset *
          (
            normalized *
            normalized
          );

        const sourceX =
          Math.round(
            x *
            sourceScaleX
          );

        const sourceSliceWidth =
          Math.max(
            1,
            Math.round(
              sliceWidth *
              sourceScaleX
            )
          );

        targetContext.drawImage(
          source,

          sourceX,
          0,
          sourceSliceWidth,
          sourceHeight,

          x,
          verticalPadding +
          offset,

          sliceWidth,
          drawHeight
        );
      }
    };

    /*
     * Projeção cilíndrica.
     *
     * Essa é a principal melhoria do Realismo V3:
     * as laterais da arte ficam levemente comprimidas,
     * como aconteceria ao imprimir em uma caneca/copo.
     */
    const drawCylinderProjection = (
      sourceCanvas,
      targetContext,
      width,
      height
    ) => {
      const thetaMax =
        0.82;

      const sinMax =
        Math.sin(
          thetaMax
        );

      const slice =
        Math.max(
          1,
          Math.round(
            width / 560
          )
        );

      for (
        let x = 0;
        x < width;
        x += slice
      ) {
        const sliceWidth =
          Math.min(
            slice,
            width - x
          );

        const leftU =
          (
            x /
            width
          ) * 2 - 1;

        const rightU =
          (
            (
              x +
              sliceWidth
            ) /
            width
          ) * 2 - 1;

        const destLeft =
          (
            (
              Math.sin(
                leftU *
                thetaMax
              ) /
              sinMax
            ) + 1
          ) *
          0.5 *
          width;

        const destRight =
          (
            (
              Math.sin(
                rightU *
                thetaMax
              ) /
              sinMax
            ) + 1
          ) *
          0.5 *
          width;

        const destWidth =
          Math.max(
            .5,
            destRight -
            destLeft
          );

        const centerU =
          (
            leftU +
            rightU
          ) * .5;

        /*
         * Pequena redução vertical nas extremidades.
         * Ajuda a sensação de que a arte está contornando
         * a superfície em vez de estar plana.
         */
        const edgeAmount =
          Math.pow(
            Math.abs(
              centerU
            ),
            1.65
          );

        const heightLoss =
          height *
          0.035 *
          edgeAmount;

        targetContext.drawImage(
          sourceCanvas,

          x,
          0,
          sliceWidth,
          height,

          destLeft,
          heightLoss * .5,
          destWidth +
          .7,
          height -
          heightLoss
        );
      }
    };

    /*
     * Luz e sombra próprias de uma superfície cilíndrica.
     * O efeito fica restrito apenas aos pixels da logo.
     */
    const applyCylinderLighting = (
      context,
      width,
      height
    ) => {
      context.save();

      context.globalCompositeOperation =
        'source-atop';

      /*
       * Sombras discretas nas laterais.
       */
      const shade =
        context.createLinearGradient(
          0,
          0,
          width,
          0
        );

      shade.addColorStop(
        0,
        'rgba(14,34,29,.18)'
      );

      shade.addColorStop(
        .12,
        'rgba(14,34,29,.08)'
      );

      shade.addColorStop(
        .30,
        'rgba(14,34,29,0)'
      );

      shade.addColorStop(
        .70,
        'rgba(14,34,29,0)'
      );

      shade.addColorStop(
        .88,
        'rgba(14,34,29,.06)'
      );

      shade.addColorStop(
        1,
        'rgba(14,34,29,.16)'
      );

      context.fillStyle =
        shade;

      context.fillRect(
        0,
        0,
        width,
        height
      );

      /*
       * Reflexo principal do vidro/porcelana.
       */
      const highlight =
        context.createLinearGradient(
          0,
          0,
          width,
          0
        );

      highlight.addColorStop(
        0,
        'rgba(255,255,255,0)'
      );

      highlight.addColorStop(
        .37,
        'rgba(255,255,255,0)'
      );

      highlight.addColorStop(
        .50,
        'rgba(255,255,255,.07)'
      );

      highlight.addColorStop(
        .58,
        'rgba(255,255,255,.20)'
      );

      highlight.addColorStop(
        .64,
        'rgba(255,255,255,.07)'
      );

      highlight.addColorStop(
        .75,
        'rgba(255,255,255,0)'
      );

      highlight.addColorStop(
        1,
        'rgba(255,255,255,0)'
      );

      context.fillStyle =
        highlight;

      context.fillRect(
        0,
        0,
        width,
        height
      );

      /*
       * Pequeno brilho secundário.
       */
      const secondary =
        context.createLinearGradient(
          0,
          0,
          width,
          0
        );

      secondary.addColorStop(
        0,
        'rgba(255,255,255,0)'
      );

      secondary.addColorStop(
        .16,
        'rgba(255,255,255,.08)'
      );

      secondary.addColorStop(
        .25,
        'rgba(255,255,255,0)'
      );

      secondary.addColorStop(
        1,
        'rgba(255,255,255,0)'
      );

      context.fillStyle =
        secondary;

      context.fillRect(
        0,
        0,
        width,
        height
      );

      context.restore();

      /*
       * Nas extremidades a impressão fica discretamente
       * menos visível por causa do ângulo da superfície.
       */
      context.save();

      context.globalCompositeOperation =
        'destination-in';

      const alphaMask =
        context.createLinearGradient(
          0,
          0,
          width,
          0
        );

      alphaMask.addColorStop(
        0,
        'rgba(255,255,255,.78)'
      );

      alphaMask.addColorStop(
        .10,
        'rgba(255,255,255,.93)'
      );

      alphaMask.addColorStop(
        .30,
        'rgba(255,255,255,1)'
      );

      alphaMask.addColorStop(
        .70,
        'rgba(255,255,255,1)'
      );

      alphaMask.addColorStop(
        .90,
        'rgba(255,255,255,.93)'
      );

      alphaMask.addColorStop(
        1,
        'rgba(255,255,255,.78)'
      );

      context.fillStyle =
        alphaMask;

      context.fillRect(
        0,
        0,
        width,
        height
      );

      context.restore();
    };

    /*
     * Simulação de gravação a laser.
     *
     * A cor original da logo é convertida para um acabamento
     * grafite/metálico, mantendo somente os pixels da arte.
     * O fundo continua 100% transparente.
     */
    const applyLaserEngraving = (
      sourceCanvas,
      targetContext,
      width,
      height
    ) => {
      targetContext.clearRect(
        0,
        0,
        width,
        height
      );

      /*
       * Primeiro cria a máscara usando o alpha da logo.
       */
      targetContext.drawImage(
        sourceCanvas,
        0,
        0,
        width,
        height
      );

      targetContext.save();

      targetContext.globalCompositeOperation =
        'source-in';

      /*
       * Tom de gravação em inox:
       * mais escuro nas bordas e um pouco mais claro no centro.
       */
      const metal =
        targetContext.createLinearGradient(
          0,
          0,
          width,
          0
        );

      metal.addColorStop(
        0,
        'rgba(48,54,52,.95)'
      );

      metal.addColorStop(
        .18,
        'rgba(78,84,81,.94)'
      );

      metal.addColorStop(
        .48,
        'rgba(108,113,110,.92)'
      );

      metal.addColorStop(
        .62,
        'rgba(75,82,79,.94)'
      );

      metal.addColorStop(
        1,
        'rgba(45,51,49,.96)'
      );

      targetContext.fillStyle =
        metal;

      targetContext.fillRect(
        0,
        0,
        width,
        height
      );

      targetContext.restore();

      /*
       * Reflexo fino que ajuda a dar sensação de material gravado,
       * sem criar fundo ou caixa ao redor da logo.
       */
      targetContext.save();

      targetContext.globalCompositeOperation =
        'source-atop';

      const highlight =
        targetContext.createLinearGradient(
          0,
          0,
          width,
          0
        );

      highlight.addColorStop(
        0,
        'rgba(255,255,255,0)'
      );

      highlight.addColorStop(
        .40,
        'rgba(255,255,255,0)'
      );

      highlight.addColorStop(
        .52,
        'rgba(255,255,255,.13)'
      );

      highlight.addColorStop(
        .60,
        'rgba(255,255,255,.03)'
      );

      highlight.addColorStop(
        1,
        'rgba(255,255,255,0)'
      );

      targetContext.fillStyle =
        highlight;

      targetContext.fillRect(
        0,
        0,
        width,
        height
      );

      targetContext.restore();

      /*
       * Microtextura fosca de gravação.
       * Fica restrita aos pixels da arte e ajuda a tirar
       * a aparência de "impressão preta".
       */
      try {
        const imageData =
          targetContext.getImageData(
            0,
            0,
            width,
            height
          );

        const pixels =
          imageData.data;

        for (
          let y = 0;
          y < height;
          y++
        ) {
          for (
            let x = 0;
            x < width;
            x++
          ) {
            const index =
              (
                y * width +
                x
              ) * 4;

            if (
              pixels[index + 3] <
              8
            ) {
              continue;
            }

            /*
             * Ruído determinístico muito leve.
             * Não "pisca" quando o slider é movido.
             */
            const noise =
              (
                Math.sin(
                  x * 12.9898 +
                  y * 78.233
                ) *
                43758.5453
              );

            const grain =
              (
                noise -
                Math.floor(noise)
              ) * 10 - 5;

            pixels[index] =
              Math.max(
                0,
                Math.min(
                  255,
                  pixels[index] +
                  grain
                )
              );

            pixels[index + 1] =
              Math.max(
                0,
                Math.min(
                  255,
                  pixels[index + 1] +
                  grain
                )
              );

            pixels[index + 2] =
              Math.max(
                0,
                Math.min(
                  255,
                  pixels[index + 2] +
                  grain
                )
              );
          }
        }

        targetContext.putImageData(
          imageData,
          0,
          0
        );

      } catch (error) {
        /*
         * A textura é apenas acabamento.
         * Em caso de bloqueio do navegador,
         * mantém a gravação sem ruído.
         */
      }
    };

    const applyPrintInk = (
      sourceCanvas,
      targetContext,
      width,
      height,
      mode
    ) => {
      targetContext.clearRect(
        0,
        0,
        width,
        height
      );

      targetContext.drawImage(
        sourceCanvas,
        0,
        0,
        width,
        height
      );

      if (
        mode === 'color' ||
        !mode
      ) {
        return;
      }

      targetContext.save();

      targetContext.globalCompositeOperation =
        'source-in';

      targetContext.fillStyle =
        mode === 'white'
          ? '#ffffff'
          : '#171b19';

      targetContext.fillRect(
        0,
        0,
        width,
        height
      );

      targetContext.restore();

      if (mode === 'white') {
        targetContext.save();

        targetContext.globalCompositeOperation =
          'source-atop';

        const light =
          targetContext.createLinearGradient(
            0,
            0,
            width,
            height
          );

        light.addColorStop(
          0,
          'rgba(255,255,255,1)'
        );

        light.addColorStop(
          .56,
          'rgba(250,250,250,.99)'
        );

        light.addColorStop(
          1,
          'rgba(235,238,236,.97)'
        );

        targetContext.fillStyle =
          light;

        targetContext.fillRect(
          0,
          0,
          width,
          height
        );

        targetContext.restore();
      }
    };

    const renderCurvedLogo = () => {
      if (
        !logoLoaded ||
        !els.logo ||
        !logoContext ||
        !els.logo.naturalWidth ||
        !els.logo.naturalHeight
      ) {
        return;
      }

      const renderSource =
        getRenderableLogoSource();

      if (!renderSource) return;

      const renderSourceSize =
        getSourceSize(
          renderSource
        );

      const sourceWidth =
        renderSourceSize.width;

      const sourceHeight =
        renderSourceSize.height;

      if (
        !sourceWidth ||
        !sourceHeight
      ) {
        return;
      }

      /*
       * Limita a resolução de trabalho.
       * Mantém boa qualidade sem pesar o slider.
       */
      const maxWidth = 1500;
      const maxHeight = 1100;

      const ratio =
        Math.min(
          1,
          maxWidth / sourceWidth,
          maxHeight / sourceHeight
        );

      const width =
        Math.max(
          2,
          Math.round(
            sourceWidth *
            ratio
          )
        );

      const height =
        Math.max(
          2,
          Math.round(
            sourceHeight *
            ratio
          )
        );

      logoCanvas.width =
        width;

      logoCanvas.height =
        height;

      logoContext.clearRect(
        0,
        0,
        width,
        height
      );

      /*
       * Etapa 1:
       * aplica a curvatura vertical escolhida
       * pelo cliente.
       */
      const curvedCanvas =
        createCanvas(
          width,
          height
        );

      const curvedContext =
        curvedCanvas.getContext(
          '2d'
        );

      curvedContext.imageSmoothingEnabled =
        true;

      curvedContext.imageSmoothingQuality =
        'high';

      drawVerticalCurve(
        curvedContext,
        width,
        height,
        ratio
      );

      /*
       * LASER:
       * mantém a curvatura escolhida pelo usuário,
       * mas troca as cores da arte por uma gravação metálica.
       */
      if (laserEnabled) {
        applyLaserEngraving(
          curvedCanvas,
          logoContext,
          width,
          height
        );

        return;
      }

      /*
       * Impressão colorida / preta / branca.
       */
      let printCanvas =
        curvedCanvas;

      if (
        printInkMode !==
        'color'
      ) {
        printCanvas =
          createCanvas(
            width,
            height
          );

        const printContext =
          printCanvas.getContext(
            '2d'
          );

        printContext.imageSmoothingEnabled =
          true;

        printContext.imageSmoothingQuality =
          'high';

        applyPrintInk(
          curvedCanvas,
          printContext,
          width,
          height,
          printInkMode
        );
      }

      if (!realismEnabled) {
        logoContext.drawImage(
          printCanvas,
          0,
          0
        );

        return;
      }

      /*
       * Etapa 2:
       * projeção da arte em uma superfície cilíndrica.
       */
      const projectedCanvas =
        createCanvas(
          width,
          height
        );

      const projectedContext =
        projectedCanvas.getContext(
          '2d'
        );

      projectedContext.imageSmoothingEnabled =
        true;

      projectedContext.imageSmoothingQuality =
        'high';

      drawCylinderProjection(
        printCanvas,
        projectedContext,
        width,
        height
      );

      /*
       * Etapa 3:
       * iluminação e perda de intensidade nas bordas.
       */
      applyCylinderLighting(
        projectedContext,
        width,
        height
      );

      /*
       * Etapa final.
       */
      logoContext.imageSmoothingEnabled =
        true;

      logoContext.imageSmoothingQuality =
        'high';

      logoContext.drawImage(
        projectedCanvas,
        0,
        0
      );
    };

    /*
     * Ativa/desativa o Realismo.
     *
     * O canvas já recebe a deformação física.
     * O blend abaixo serve somente para integrar
     * a arte às sombras reais da fotografia.
     */
    const syncPersonalizationModeUI = () => {
      if (blendButton) {
        blendButton.classList.toggle(
          'is-active',
          realismEnabled
        );

        blendButton.setAttribute(
          'aria-pressed',
          String(realismEnabled)
        );
      }

      if (laserButton) {
        laserButton.classList.toggle(
          'is-active',
          laserEnabled
        );

        laserButton.setAttribute(
          'aria-pressed',
          String(laserEnabled)
        );
      }
    };

    const applyPersonalizationModeStyles = () => {
      /*
       * O canvas fica sempre transparente.
       */
      logoCanvas.style.background =
        'transparent';

      logoCanvas.style.backgroundColor =
        'transparent';

      if (laserEnabled) {
        logoCanvas.dataset.realism =
          'off';

        logoCanvas.dataset.laser =
          'on';

        logoCanvas.classList.remove(
          'is-blend'
        );

        /*
         * No laser o desenho já é convertido para grafite/metálico
         * no próprio canvas. O multiply apenas integra a gravação
         * às sombras do inox.
         */
        logoCanvas.style.mixBlendMode =
          'multiply';

        logoCanvas.style.opacity =
          '.82';

        logoCanvas.style.filter =
          'grayscale(1) contrast(1.08) brightness(.92)';

        return;
      }

      logoCanvas.dataset.laser =
        'off';

      logoCanvas.dataset.realism =
        realismEnabled
          ? 'on'
          : 'off';

      logoCanvas.classList.toggle(
        'is-blend',
        realismEnabled
      );

      logoCanvas.style.mixBlendMode =
        realismEnabled
          ? 'multiply'
          : 'normal';

      logoCanvas.style.opacity =
        '1';

      logoCanvas.style.filter =
        realismEnabled
          ? 'contrast(1.01) saturate(.98) brightness(.985)'
          : 'none';
    };

    const setRealism = (
      enabled
    ) => {
      /*
       * Talheres A Gourmet:
       * laser é obrigatório e não pode ser substituído
       * por impressão/realismo.
       */
      if (
        isLaserProduct(
          active
        )
      ) {
        realismEnabled = false;
        laserEnabled = true;

        applyPersonalizationModeStyles();
        syncPersonalizationModeUI();
        updateTextLayer();

        if (logoLoaded) {
          buildTransparentLogoCanvas();
          renderCurvedLogo();
        }

        return;
      }

      realismEnabled =
        Boolean(enabled);

      /*
       * Realismo e Laser são técnicas visuais diferentes.
       * Ativar uma desativa a outra.
       */
      if (realismEnabled) {
        laserEnabled = false;
      }

      applyPersonalizationModeStyles();
      syncPersonalizationModeUI();

      updateTextLayer();

      if (logoLoaded) {
        buildTransparentLogoCanvas();
        renderCurvedLogo();
      }
    };

    const setLaser = (
      enabled
    ) => {
      const forcedLaser =
        isLaserProduct(
          active
        );

      laserEnabled =
        forcedLaser
          ? true
          : Boolean(
              enabled
            );

      if (laserEnabled) {
        realismEnabled = false;
      }

      applyPersonalizationModeStyles();
      syncPersonalizationModeUI();

      updateTextLayer();

      if (logoLoaded) {
        buildTransparentLogoCanvas();
        renderCurvedLogo();
      }
    };

    const updateLaserAvailability = () => {
      const available =
        isLaserProduct(active);

      root.classList.toggle(
        'agfx--laser-product',
        available
      );

      root.classList.toggle(
        'agfx--laser-only',
        available
      );

      if (available) {
        root.dataset.technique =
          'laser';
      } else {
        delete root.dataset.technique;
      }

      if (laserButton) {
        laserButton.hidden =
          !available;

        laserButton.textContent =
          available
            ? 'LASER ATIVO'
            : 'LASER';

        laserButton.title =
          available
            ? 'Talheres são personalizados exclusivamente por gravação a laser'
            : 'Simula gravação a laser em peças compatíveis';

        laserButton.classList.toggle(
          'agfx__laser-button',
          available
        );

        laserButton.disabled =
          available;

        laserButton.setAttribute(
          'aria-disabled',
          String(available)
        );
      }

      if (blendButton) {
        blendButton.hidden =
          available;

        blendButton.title =
          available
            ? 'Este produto utiliza gravação a laser'
            : 'Simula impressão aplicada sobre a curvatura, luz e sombra do produto';
      }

      if (available) {
        /*
         * TALHER = SOMENTE LASER.
         * Remove da interface qualquer opção que sugira
         * impressão colorida ou outro acabamento.
         */
        const visualCard =
          root.querySelector(
            '[data-visual-card]'
          );

        if (visualCard) {
          visualCard.hidden = true;
          visualCard.setAttribute(
            'aria-hidden',
            'true'
          );
        }

        const textColorInput =
          root.querySelector(
            '[data-text-color]'
          );

        const textColorControl =
          textColorInput
            ?.closest(
              'label'
            );

        if (textColorControl) {
          textColorControl.hidden = true;
        }

        const textSection =
          root.querySelector(
            '[data-text-input]'
          )
            ?.closest(
              '.agfx__pro-section'
            );

        const textSectionLabel =
          textSection
            ?.querySelector(
              ':scope > .agfx__pro-label'
            );

        if (textSectionLabel) {
          textSectionLabel.textContent =
            'Texto para gravação';
        }

        const backgroundButton =
          root.querySelector(
            '[data-remove-background]'
          );

        if (backgroundButton) {
          backgroundButton.textContent =
            'Remover fundo da logo';

          backgroundButton.title =
            'Prepara a arte para a gravação a laser';
        }

        state.c = 0;

        if (els.curve) {
          els.curve.value = 0;
        }

        if (els.vcurve) {
          els.vcurve.textContent =
            '0';
        }

        if (presetBox) {
          presetBox.classList.add(
            'agfx__laser-preset-hidden'
          );
        }

        const safeButton =
          root.querySelector(
            '[data-safe]'
          );

        if (safeButton) {
          if (
            safeButtonOriginalText ===
            null
          ) {
            safeButtonOriginalText =
              safeButton.textContent;
          }

          safeButton.textContent =
            'ÁREA DE GRAVAÇÃO';
        }

        /*
         * Talher = laser obrigatório.
         */
        if (!laserEnabled) {
          setLaser(true);
        } else {
          applyPersonalizationModeStyles();
          syncPersonalizationModeUI();

          if (logoLoaded) {
            renderCurvedLogo();
          }
        }

        /*
         * A posição exibida passa a ser CABO.
         */
        if (els.position) {
          let caboOption =
            [
              ...els.position.options
            ].find(
              (option) =>
                option.value === 'Cabo'
            );

          if (!caboOption) {
            caboOption =
              document.createElement(
                'option'
              );

            caboOption.value =
              'Cabo';

            caboOption.textContent =
              'Cabo';

            els.position.appendChild(
              caboOption
            );
          }

          els.position.value =
            'Cabo';
        }

        /*
         * Ao abrir um talher, já entrega uma posição inicial
         * de gravação no cabo.
         */
        adjustToHandle();

        return;
      }

      const visualCard =
        root.querySelector(
          '[data-visual-card]'
        );

      if (visualCard) {
        visualCard.hidden = false;
        visualCard.removeAttribute(
          'aria-hidden'
        );
      }

      const textColorInput =
        root.querySelector(
          '[data-text-color]'
        );

      const textColorControl =
        textColorInput
          ?.closest(
            'label'
          );

      if (textColorControl) {
        textColorControl.hidden = false;
      }

      const textSection =
        root.querySelector(
          '[data-text-input]'
        )
          ?.closest(
            '.agfx__pro-section'
          );

      const textSectionLabel =
        textSection
          ?.querySelector(
            ':scope > .agfx__pro-label'
          );

      if (textSectionLabel) {
        textSectionLabel.textContent =
          'Texto personalizado';
      }

      const backgroundButton =
        root.querySelector(
          '[data-remove-background]'
        );

      if (backgroundButton) {
        backgroundButton.textContent =
          'Fundo branco: remover';

        backgroundButton.title =
          '';
      }

      if (laserButton) {
        laserButton.disabled = false;

        laserButton.removeAttribute(
          'aria-disabled'
        );
      }

      if (presetBox) {
        presetBox.classList.remove(
          'agfx__laser-preset-hidden'
        );
      }

      const safeButton =
        root.querySelector(
          '[data-safe]'
        );

      if (
        safeButton &&
        safeButtonOriginalText !==
        null
      ) {
        safeButton.textContent =
          safeButtonOriginalText;
      }

      if (
        els.position &&
        els.position.value === 'Cabo'
      ) {
        els.position.value =
          'Centro';
      }

      if (laserEnabled) {
        setLaser(false);
      }
    };

    /* ========================================================
       RESUMO
       ======================================================== */

    const ensureSummaryExtras = () => {
      const summary =
        els.sumProduct
          ?.closest(
            '.agfx__summary'
          );

      if (
        !summary ||
        summary.querySelector(
          '[data-summary-extra]'
        )
      ) {
        return;
      }

      const extra =
        document.createElement(
          'div'
        );

      extra.className =
        'agfx__summary-extra';

      extra.setAttribute(
        'data-summary-extra',
        ''
      );

      extra.innerHTML = `
        <div class="agfx__summary-row agfx__summary-commercial-row">
          <span>Projeto</span>
          <strong data-sum-project>—</strong>
        </div>

        <div class="agfx__summary-row agfx__summary-commercial-row">
          <span>Status</span>
          <strong data-sum-status>Em edição</strong>
        </div>

        <div class="agfx__summary-row">
          <span>Técnica</span>
          <strong data-sum-technique>—</strong>
        </div>

        <div class="agfx__summary-row">
          <span>Pedido mínimo</span>
          <strong data-sum-minimum>—</strong>
        </div>

        <div class="agfx__summary-row">
          <span>Qualidade da arte</span>
          <strong data-sum-quality>—</strong>
        </div>

        <div class="agfx__summary-row">
          <span>Texto</span>
          <strong data-sum-text>—</strong>
        </div>

        <div class="agfx__summary-row">
          <span>Personalização</span>
          <strong data-sum-price>Sob consulta</strong>
        </div>
      `;

      summary.appendChild(
        extra
      );
    };

    const updateSummary = () => {
      ensureSummaryExtras();

      if (!active) {
        if (els.sumProduct) {
          els.sumProduct.textContent = '-';
        }

        return;
      }

      if (els.sumProduct) {
        els.sumProduct.textContent =
          active.name;
      }

      if (els.sumQty) {
        els.sumQty.textContent =
          `${els.qty?.value || active.minimum || 1} un.`;
      }

      if (els.sumPosition) {
        els.sumPosition.textContent =
          els.position?.value || 'Centro';
      }

      const projectEl =
        root.querySelector(
          '[data-sum-project]'
        );

      const statusEl =
        root.querySelector(
          '[data-sum-status]'
        );

      const techniqueEl =
        root.querySelector(
          '[data-sum-technique]'
        );

      const minimumEl =
        root.querySelector(
          '[data-sum-minimum]'
        );

      const qualityEl =
        root.querySelector(
          '[data-sum-quality]'
        );

      const textEl =
        root.querySelector(
          '[data-sum-text]'
        );

      const priceEl =
        root.querySelector(
          '[data-sum-price]'
        );

      if (projectEl) {
        projectEl.textContent =
          projectId;
      }

      if (statusEl) {
        statusEl.textContent =
          quoteRequested
            ? 'Orçamento solicitado'
            : (
                logoLoaded &&
                commercialProjectTouched
                  ? 'Pronto para orçamento'
                  : (
                      logoLoaded
                        ? 'Em personalização'
                        : 'Aguardando arte'
                    )
              );
      }

      if (techniqueEl) {
        const inkLabel =
          printInkMode ===
            'white'
            ? 'branca'
            : (
                printInkMode ===
                  'black'
                  ? 'preta'
                  : 'colorida'
              );

        techniqueEl.textContent =
          laserEnabled
            ? 'Gravação a laser'
            : (
                isGlassProduct(
                  active
                )
                  ? `Impressão ${inkLabel}`
                  : 'Impressão / serigrafia'
              );
      }

      if (minimumEl) {
        minimumEl.textContent =
          `${active.minimum || 1} un.`;
      }

      if (qualityEl) {
        qualityEl.textContent =
          logoQuality.label;
      }

      if (textEl) {
        textEl.textContent =
          textState.value
            ? textState.value
            : 'Não adicionado';
      }

      if (priceEl) {
        const unit =
          active.profile
            ?.personalizationPrice ||
          0;

        priceEl.textContent =
          unit > 0
            ? `R$ ${(unit * Number(els.qty?.value || active.minimum || 1)).toFixed(2).replace('.', ',')}`
            : 'Sob consulta';
      }
    };

    /* ========================================================
       CANVAS
       ======================================================== */

    const apply = () => {
      if (!logoCanvas) return;

      logoCanvas.style.transform =
        `translate(${state.x}px, ${state.y}px) ` +
        `scale(${state.s}) rotate(${state.r}deg)`;

      if (els.vscale) {
        els.vscale.textContent =
          `${Math.round(state.s * 100)}%`;
      }

      if (els.vrot) {
        els.vrot.textContent =
          `${Math.round(state.r)}°`;
      }

      if (els.vcurve) {
        els.vcurve.textContent =
          `${Math.round(state.c)}`;
      }

      updateSummary();
    };

    const getSnapshot = () => ({
      state: {
        x: state.x,
        y: state.y,
        s: state.s,
        r: state.r,
        c: state.c
      },

      text: {
        value: textState.value,
        x: textState.x,
        y: textState.y,
        size: textState.size,
        rotation: textState.rotation,
        color: textState.color,
        bold: textState.bold
      },

      realism:
        realismEnabled,

      laser:
        laserEnabled,

      removeBackground:
        removeBackgroundEnabled,

      previewBackground:
        'light',

      printInk:
        printInkMode,

      commercialTouched:
        commercialProjectTouched,

      quoteRequested
    });

    const pushHistory = () => {
      if (historyLocked) return;

      const snapshot =
        getSnapshot();

      const serialized =
        JSON.stringify(
          snapshot
        );

      const current =
        history[
          historyIndex
        ];

      if (
        current &&
        JSON.stringify(current) ===
          serialized
      ) {
        return;
      }

      history.splice(
        historyIndex + 1
      );

      history.push(
        snapshot
      );

      if (history.length > 40) {
        history.shift();
      }

      historyIndex =
        history.length - 1;
    };

    const restoreSnapshot = (
      snapshot
    ) => {
      if (!snapshot) return;

      historyLocked = true;

      Object.assign(
        state,
        snapshot.state || {}
      );

      Object.assign(
        textState,
        snapshot.text || {}
      );

      removeBackgroundEnabled =
        snapshot.removeBackground !== false;

      previewBackgroundMode =
        'light';

      if (
        snapshot.printInk
      ) {
        printInkMode =
          snapshot.printInk;
      }

      commercialProjectTouched =
        Boolean(
          snapshot.commercialTouched
        );

      quoteRequested =
        Boolean(
          snapshot.quoteRequested
        );

      updateVisualizationUI();
      updateCommercialUI();

      if (els.scale) {
        els.scale.value =
          state.s;
      }

      if (els.rot) {
        els.rot.value =
          state.r;
      }

      if (els.curve) {
        els.curve.value =
          state.c;
      }

      setRealism(
        Boolean(
          snapshot.realism
        )
      );

      if (
        snapshot.laser &&
        isLaserProduct(active)
      ) {
        setLaser(true);
      }

      buildTransparentLogoCanvas();
      renderCurvedLogo();
      updateTextLayer();
      apply();

      historyLocked = false;
    };

    const undo = () => {
      if (historyIndex <= 0) {
        return;
      }

      historyIndex--;
      restoreSnapshot(
        history[
          historyIndex
        ]
      );

      track(
        'undo'
      );
    };

    const redo = () => {
      if (
        historyIndex >=
        history.length - 1
      ) {
        return;
      }

      historyIndex++;
      restoreSnapshot(
        history[
          historyIndex
        ]
      );

      track(
        'redo'
      );
    };

    /*
     * Preset inteligente para talheres.
     *
     * As fotos de talheres da biblioteca seguem majoritariamente
     * o eixo diagonal. Este preset dá um ponto de partida pronto,
     * mantendo liberdade para o cliente fazer o ajuste fino.
     */
    const adjustToHandle = () => {
      if (
        !els.stage ||
        !isLaserProduct(active)
      ) {
        return;
      }

      const rect =
        els.stage.getBoundingClientRect();

      state.c = 0;
      state.s = 0.82;
      state.r = 318;

      state.x =
        -rect.width * 0.16;

      state.y =
        rect.height * 0.20;

      if (els.curve) {
        els.curve.value = 0;
      }

      if (els.vcurve) {
        els.vcurve.textContent = '0';
      }

      if (els.scale) {
        els.scale.value =
          state.s;
      }

      if (els.rot) {
        els.rot.value =
          state.r;
      }

      if (els.position) {
        let caboOption =
          [
            ...els.position.options
          ].find(
            (option) =>
              option.value === 'Cabo'
          );

        if (!caboOption) {
          caboOption =
            document.createElement(
              'option'
            );

          caboOption.value =
            'Cabo';

          caboOption.textContent =
            'Cabo';

          els.position.appendChild(
            caboOption
          );
        }

        els.position.value =
          'Cabo';
      }

      root
        .querySelectorAll(
          '[data-preset]'
        )
        .forEach(
          (button) =>
            button.classList.remove(
              'is-active'
            )
        );

      if (logoLoaded) {
        renderCurvedLogo();
      }

      apply();
    };

    /* ========================================================
       SELEÇÃO DO PRODUTO
       ======================================================== */

    const selectProduct = (id) => {
      const previousProductId =
        active?.id || null;

      const next =
        products.find(
          (product) =>
            String(product.id) ===
            String(id)
        );

      if (!next) return;

      const productChanged =
        String(previousProductId || '') !==
        String(next.id || '');

      active = next;

      if (els.base) {
        /*
         * Entrada mais profissional da nova peça.
         */
        els.capture
          ?.classList
          .add(
            'is-product-switching'
          );

        /*
         * O auto-ajuste do palco e o enquadramento interno
         * rodam quando a nova imagem termina de carregar.
         */
        els.base.onload =
          () => {
            autoFitProductView(
              next
            );

            applyProductDisplayProfile(
              next,
              {
                notify:
                  productChanged
              }
            );

            els.capture
              ?.classList
              .remove(
                'is-product-switching'
              );
          };

        els.base.src =
          next.image || '';

        els.base.alt =
          next.name || '';

        requestAnimationFrame(
          () => {
            if (
              els.base.complete &&
              els.base.naturalWidth
            ) {
              autoFitProductView(
                next
              );

              applyProductDisplayProfile(
                next,
                {
                  notify:
                    productChanged
                }
              );

              els.capture
                ?.classList
                .remove(
                  'is-product-switching'
                );
            }
          }
        );
      }

      if (els.title) {
        els.title.textContent =
          next.name || '';
      }

      if (els.meta) {
        els.meta.textContent =
          next.meta || '';
      }

      if (!next.profile) {
        next.profile =
          buildProductProfile(
            next,
            next.metafields || []
          );

        next.minimum =
          next.profile.minimum;
      }

      applySafeAreaProfile(
        next
      );

      if (els.qty) {
        els.qty.min =
          next.minimum || 1;

        if (
          Number(els.qty.value) <
          Number(els.qty.min)
        ) {
          els.qty.value =
            els.qty.min;
        }
      }

      getProductButtons().forEach(
        (button) => {
          button.classList.toggle(
            'is-active',
            String(button.dataset.product) ===
              String(id)
          );
        }
      );

      updateLaserAvailability();
      updateGlassAvailability();

      /*
       * Quando a peça muda, aplica um ponto de partida coerente
       * para a arte. Talheres continuam usando o preset de cabo.
       */
      if (
        productChanged &&
        logoLoaded &&
        !isLaserProduct(
          next
        )
      ) {
        applyProductArtworkDefaults(
          next
        );
      }

      /*
       * Trocar o produto mantém a arte, mas exige nova revisão
       * do posicionamento.
       */
      if (logoLoaded) {
        commercialProjectTouched =
          false;
      }

      quoteRequested =
        false;

      updateCommercialUI();

      /*
       * Ao trocar de produto, a coluna direita recomeça no topo.
       * Alterar sliders/arte não interfere no scroll.
       */
      if (productChanged) {
        const panelScroll =
          root.querySelector(
            '[data-panel-scroll]'
          );

        if (panelScroll) {
          panelScroll.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
        }
      }

      track(
        'product_select',
        {
          category:
            next.category,

          minimum:
            next.minimum,

          zone:
            next.profile?.zone ||
            null
        }
      );
    };

    /* ========================================================
       CONTADORES REAIS POR CATEGORIA
       ======================================================== */

    const updateCategoryCountUI = () => {
      els.categoryButtons.forEach(
        (button) => {
          const category =
            button.dataset.category;

          const count =
            button.querySelector(
              '[data-category-count]'
            );

          if (
            !category ||
            !count
          ) {
            return;
          }

          if (
            category ===
            'favoritos'
          ) {
            count.textContent =
              String(
                favoriteRecords.length
              );

            return;
          }

          const value =
            categoryTotals[
              category
            ];

          count.textContent =
            Number.isFinite(
              value
            )
              ? String(value)
              : '—';
        }
      );
    };

    const buildCountQueryText = (
      category
    ) => {
      const terms = [
        'tag:Personalize'
      ];

      const categoryTerm =
        categoryQueries[
          category
        ] || '';

      if (
        category !== 'all' &&
        categoryTerm
      ) {
        terms.push(
          categoryTerm
        );
      }

      if (
        currentSearch.trim()
      ) {
        terms.push(
          currentSearch.trim()
        );
      }

      return terms
        .join(' ')
        .trim();
    };

    const fetchCategoryCounts =
      async ({
        force = false
      } = {}) => {
        if (!shopDomain) {
          return;
        }

        const searchKey =
          normalize(
            currentSearch
          );

        if (
          !force &&
          categoryCountsSearchKey ===
            searchKey &&
          Number.isFinite(
            categoryTotals.all
          )
        ) {
          updateCategoryCountUI();
          return;
        }

        categoryCountsSearchKey =
          searchKey;

        const graphQL = `
          query StudioCategoryCounts(
            $all: String!,
            $pratos: String!,
            $xicaras: String!,
            $tacas: String!,
            $copos: String!,
            $travessas: String!,
            $bowls: String!,
            $canecas: String!,
            $talheres: String!
          ) {
            all: search(
              query: $all,
              first: 1,
              types: [PRODUCT]
            ) {
              totalCount
            }

            pratos: search(
              query: $pratos,
              first: 1,
              types: [PRODUCT]
            ) {
              totalCount
            }

            xicaras: search(
              query: $xicaras,
              first: 1,
              types: [PRODUCT]
            ) {
              totalCount
            }

            tacas: search(
              query: $tacas,
              first: 1,
              types: [PRODUCT]
            ) {
              totalCount
            }

            copos: search(
              query: $copos,
              first: 1,
              types: [PRODUCT]
            ) {
              totalCount
            }

            travessas: search(
              query: $travessas,
              first: 1,
              types: [PRODUCT]
            ) {
              totalCount
            }

            bowls: search(
              query: $bowls,
              first: 1,
              types: [PRODUCT]
            ) {
              totalCount
            }

            canecas: search(
              query: $canecas,
              first: 1,
              types: [PRODUCT]
            ) {
              totalCount
            }

            talheres: search(
              query: $talheres,
              first: 1,
              types: [PRODUCT]
            ) {
              totalCount
            }
          }
        `;

        const variables = {
          all:
            buildCountQueryText(
              'all'
            ),

          pratos:
            buildCountQueryText(
              'pratos'
            ),

          xicaras:
            buildCountQueryText(
              'xicaras'
            ),

          tacas:
            buildCountQueryText(
              'tacas'
            ),

          copos:
            buildCountQueryText(
              'copos'
            ),

          travessas:
            buildCountQueryText(
              'travessas'
            ),

          bowls:
            buildCountQueryText(
              'bowls'
            ),

          canecas:
            buildCountQueryText(
              'canecas'
            ),

          talheres:
            buildCountQueryText(
              'talheres'
            )
        };

        const headers = {
          'Content-Type':
            'application/json'
        };

        if (storefrontToken) {
          headers[
            'X-Shopify-Storefront-Access-Token'
          ] =
            storefrontToken;
        }

        try {
          const response =
            await fetch(
              `https://${shopDomain}/api/2026-07/graphql.json`,
              {
                method: 'POST',
                headers,

                body:
                  JSON.stringify({
                    query:
                      graphQL,

                    variables
                  })
              }
            );

          if (!response.ok) {
            throw new Error(
              `Shopify HTTP ${response.status}`
            );
          }

          const payload =
            await response.json();

          if (
            payload.errors?.length
          ) {
            throw new Error(
              payload.errors
                .map(
                  (error) =>
                    error.message
                )
                .join(', ')
            );
          }

          [
            'all',
            'pratos',
            'xicaras',
            'tacas',
            'copos',
            'travessas',
            'bowls',
            'canecas',
            'talheres'
          ]
            .forEach(
              (category) => {
                const value =
                  payload
                    ?.data
                    ?.[category]
                    ?.totalCount;

                if (
                  Number.isFinite(
                    value
                  )
                ) {
                  categoryTotals[
                    category
                  ] =
                    value;
                }
              }
            );

          updateCategoryCountUI();

          if (els.count) {
            const current =
              currentCategory ===
                'favoritos'
                ? favoriteRecords.length
                : categoryTotals[
                    currentCategory
                  ];

            if (
              Number.isFinite(
                current
              )
            ) {
              els.count.textContent =
                `${current} ${
                  currentCategory ===
                    'favoritos'
                    ? (
                        current === 1
                          ? 'salvo'
                          : 'salvos'
                      )
                    : 'disponíveis'
                }`;
            }
          }

        } catch (error) {
          console.warn(
            'A Gourmet Studio — contadores de categorias:',
            error
          );

          /*
           * Mantém o contador local se a busca total não estiver disponível.
           */
          updateCategoryCountUI();
        }
      };

    updateCategoryCountUI();

    /* ========================================================
       FILTRO VISUAL
       ======================================================== */

    const applyProductFilters = () => {
      const search =
        normalize(currentSearch);

      let visibleCount = 0;

      const buttons =
        getProductButtons();

      buttons.forEach((button) => {
        const productName =
          normalize(
            button.dataset.productName || ''
          );

        const category =
          button.dataset.productCategory ||
          'outros';

        const matchesSearch =
          !search ||
          productName.includes(search);

        const matchesCategory =
          currentCategory === 'all' ||
          (
            currentCategory ===
              'favoritos'
              ? isFavoriteId(
                  button.dataset.product
                )
              : category ===
                  currentCategory
          );

        const visible =
          matchesSearch &&
          matchesCategory;

        button.hidden =
          !visible;

        if (visible) {
          visibleCount++;
        }
      });

      if (els.count) {
        const total =
          currentCategory ===
            'favoritos'
            ? favoriteRecords.length
            : categoryTotals[
                currentCategory
              ];

        const resolvedCount =
          Number.isFinite(
            total
          )
            ? total
            : visibleCount;

        els.count.textContent =
          `${resolvedCount} ${
            currentCategory ===
              'favoritos'
              ? (
                  resolvedCount === 1
                    ? 'salvo'
                    : 'salvos'
                )
              : 'disponíveis'
          }`;
      }

      if (els.empty) {
        els.empty.hidden =
          visibleCount > 0;

        if (
          visibleCount === 0 &&
          currentCategory ===
            'favoritos'
        ) {
          const strong =
            els.empty.querySelector(
              'strong'
            );

          const span =
            els.empty.querySelector(
              'span'
            );

          if (strong) {
            strong.textContent =
              'Nenhum produto salvo';
          }

          if (span) {
            span.textContent =
              'Use o coração nos produtos para guardar suas opções no Studio.';
          }

        } else {
          const strong =
            els.empty.querySelector(
              'strong'
            );

          const span =
            els.empty.querySelector(
              'span'
            );

          if (strong) {
            strong.textContent =
              'Nenhum produto encontrado';
          }

          if (span) {
            span.textContent =
              'Tente outra busca ou categoria.';
          }
        }
      }

      /*
       * Se o produto atualmente selecionado
       * foi escondido pelo filtro, seleciona
       * automaticamente o primeiro visível.
       */
      if (visibleCount > 0) {
        const activeButton =
          active
            ? getProductButton(active.id)
            : null;

        if (
          !activeButton ||
          activeButton.hidden
        ) {
          const firstVisible =
            buttons.find(
              (button) => !button.hidden
            );

          if (firstVisible) {
            selectProduct(
              parseProductId(
                firstVisible.dataset.product
              )
            );
          }
        }
      }

      return visibleCount;
    };

    const ensureFavoriteProductsRendered = () => {
      favoriteRecords.forEach(
        (favorite) => {
          const exists =
            products.some(
              (product) =>
                getProductKey(
                  product
                ) ===
                getProductKey(
                  favorite
                )
            );

          if (exists) {
            return;
          }

          const item = {
            ...favorite,
            source:
              'favorite-cache'
          };

          products.push(
            item
          );

          renderShopifyProduct(
            item
          );
        }
      );

      refreshProductActionUI();
    };

    /* ========================================================
       INTERFACE DA BIBLIOTECA
       ======================================================== */

    const updateLibraryUI = () => {
      const visibleCount =
        applyProductFilters();

      const remoteProducts =
        products.filter(
          (product) =>
            product.source === 'shopify'
        );

      if (els.empty) {
        els.empty.hidden =
          visibleCount > 0;
      }

      if (!els.loadMore) return;

      if (shopifyLibrary.loading) {
        els.loadMore.disabled = true;
        return;
      }

      els.loadMore.disabled = false;

      if (shopifyLibrary.hasNextPage) {
        els.loadMore.hidden = false;

        els.loadMore.innerHTML = `
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
          >
            <path
              d="M20 12a8 8 0 1 1-2.34-5.66"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
            />

            <path
              d="M20 4v6h-6"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          Carregar mais produtos
        `;
      } else {
        /*
         * Se houve produtos Shopify,
         * mostra que chegamos ao final.
         *
         * Caso a API tenha falhado e só
         * existam os produtos manuais,
         * o tratamento do catch controla
         * o texto.
         */
        if (remoteProducts.length > 0) {
          els.loadMore.hidden = false;
          els.loadMore.textContent =
            'Todos os produtos carregados';
        }
      }
    };

    /* ========================================================
       RENDERIZAR PRODUTO SHOPIFY
       ======================================================== */

    const renderShopifyProduct = (
      product
    ) => {
      if (!els.productList) return;

      const button =
        document.createElement('button');

      button.type =
        'button';

      button.className =
        'agfx__product';

      button.dataset.product =
        product.id;

      button.dataset.productName =
        normalize(product.name);

      button.dataset.productCategory =
        product.category ||
        detectCategory(
          product.name,
          product.productType
        );

      button.dataset.shopifyProduct =
        'true';

      button.innerHTML = `
        <span
          class="agfx__product-selected-rail"
          aria-hidden="true"
        ></span>

        <span class="agfx__thumb">

          <img
            src="${escapeHTML(product.image)}"
            alt="${escapeHTML(product.name)}"
            loading="lazy"
          >

        </span>

        <span class="agfx__product-info">

          <strong>
            ${escapeHTML(product.name)}
          </strong>

          <span class="agfx__product-meta">
            ${escapeHTML(product.meta)}
          </span>

          <small class="agfx__personalizable">
            Personalizável
          </small>

        </span>

        <span
          class="agfx__product-actions"
          aria-hidden="true"
        >
          <span
            class="agfx__product-action ${
              isFavoriteId(
                product.id
              )
                ? 'is-active'
                : ''
            }"
            data-favorite-toggle
            title="${
              isFavoriteId(
                product.id
              )
                ? 'Remover dos favoritos'
                : 'Adicionar aos favoritos'
            }"
          >
            ${getProductActionIcon(
              'favorite',
              isFavoriteId(
                product.id
              )
            )}
          </span>

          <span
            class="agfx__product-action ${
              isComparedId(
                product.id
              )
                ? 'is-active'
                : ''
            }"
            data-compare-toggle
            title="${
              isComparedId(
                product.id
              )
                ? 'Remover da comparação'
                : 'Comparar produto'
            }"
          >
            ${getProductActionIcon(
              'compare',
              isComparedId(
                product.id
              )
            )}
          </span>
        </span>

      `;

      button.addEventListener(
        'click',
        (event) => {
          if (
            event.target.closest(
              '[data-favorite-toggle]'
            )
          ) {
            event.preventDefault();
            event.stopPropagation();

            toggleFavorite(
              product
            );

            return;
          }

          if (
            event.target.closest(
              '[data-compare-toggle]'
            )
          ) {
            event.preventDefault();
            event.stopPropagation();

            toggleCompare(
              product
            );

            return;
          }

          selectProduct(
            product.id
          );
        }
      );

      els.productList.appendChild(
        button
      );

      refreshProductActionUI();
    };

    /* ========================================================
       BUSCAR PRODUTOS SHOPIFY
       ======================================================== */

    async function fetchShopifyProducts({
      reset = false
    } = {}) {
      if (!shopDomain) {
        console.warn(
          'A Gourmet Studio: domínio Shopify não encontrado.'
        );

        return;
      }

      if (shopifyLibrary.loading) {
        return;
      }

      if (
        !reset &&
        !shopifyLibrary.hasNextPage
      ) {
        return;
      }

      shopifyLibrary.loading = true;

      if (els.loading) {
        els.loading.hidden = false;
      }

      if (els.loadMore) {
        els.loadMore.disabled = true;
      }

      if (reset) {
        fetchCategoryCounts();

        shopifyLibrary.cursor = null;
        shopifyLibrary.hasNextPage = true;

        /*
         * Remove produtos Shopify antigos
         * do array.
         */
        products =
          products.filter(
            (product) =>
              product.source !== 'shopify' &&
              product.source !== 'favorite-cache'
          );

        active = null;

        if (els.title) {
          els.title.textContent =
            'Carregando produtos...';
        }

        if (els.meta) {
          els.meta.textContent =
            'Produtos personalizáveis A Gourmet';
        }

        if (els.sumProduct) {
          els.sumProduct.textContent =
            '—';
        }

        if (els.sumQty) {
          els.sumQty.textContent =
            '—';
        }

        if (els.base) {
          els.base.removeAttribute('src');
          els.base.alt = '';
        }

        /*
         * Remove os cards Shopify antigos.
         */
        root
          .querySelectorAll(
            '[data-shopify-product="true"]'
          )
          .forEach(
            (element) =>
              element.remove()
          );

        /*
         * Atualiza imediatamente os
         * produtos manuais enquanto
         * aguardamos a API.
         */
        applyProductFilters();
      }

      const categoryTerm =
        categoryQueries[
          currentCategory
        ] || '';

      const searchTerm =
        currentSearch.trim();

      const terms = [
  'tag:Personalize'
];

/*
 * Se uma categoria estiver selecionada,
 * acrescentamos o termo da categoria.
 */
if (
  currentCategory !== 'all' &&
  currentCategory !== 'outros' &&
  categoryTerm
) {
  terms.push(
    categoryTerm
  );
}

/*
 * Se o cliente digitou algo na busca,
 * acrescentamos ao filtro.
 */
if (searchTerm) {
  terms.push(
    searchTerm
  );
}

/*
 * Exemplos finais:
 *
 * Todos:
 * tag:Personalize
 *
 * Pratos:
 * tag:Personalize Prato
 *
 * Busca "raso":
 * tag:Personalize raso
 *
 * Categoria Pratos + busca "raso":
 * tag:Personalize Prato raso
 *
 * Talheres:
 * tag:Personalize (title:Garfo OR title:Faca OR title:Colher OR title:Talher OR title:Cutelo ...)
 */
const queryText =
  terms.join(' ').trim();

      const metafieldSelection =
        storefrontToken
          ? `
                metafields(
                  identifiers: [
                    { namespace: "personalization", key: "enabled" }
                    { namespace: "personalization", key: "technique" }
                    { namespace: "personalization", key: "minimum" }
                    { namespace: "personalization", key: "zone" }
                    { namespace: "personalization", key: "default_scale" }
                    { namespace: "personalization", key: "default_rotation" }
                    { namespace: "personalization", key: "default_x" }
                    { namespace: "personalization", key: "default_y" }
                    { namespace: "personalization", key: "allow_curve" }
                    { namespace: "personalization", key: "allow_realism" }
                    { namespace: "personalization", key: "price" }
                    { namespace: "personalization", key: "display_scale" }
                    { namespace: "personalization", key: "display_x" }
                    { namespace: "personalization", key: "display_y" }
                    { namespace: "personalization", key: "safe_x" }
                    { namespace: "personalization", key: "safe_y" }
                    { namespace: "personalization", key: "safe_width" }
                    { namespace: "personalization", key: "safe_height" }
                    { namespace: "personalization", key: "safe_rotation" }
                  ]
                ) {
                  namespace
                  key
                  value
                  type
                }
            `
          : '';

      const graphQL = `
        query StudioProducts(
          $first: Int!,
          $after: String,
          $query: String
        ) {
          products(
            first: $first,
            after: $after,
            query: $query,
            sortKey: TITLE
          ) {
            edges {
              cursor

              node {
                id
                handle
                title
                productType

                priceRange {
                  minVariantPrice {
                    amount
                    currencyCode
                  }
                }

                ${metafieldSelection}

                featuredImage {
                  url
                  altText
                  width
                  height
                }
              }
            }

            pageInfo {
              hasNextPage
              endCursor
            }
          }
        }
      `;

      const variables = {
        first:
          shopifyLibrary.pageSize,

        after:
          shopifyLibrary.cursor,

        query:
          queryText.length
            ? queryText
            : null
      };

      const headers = {
        'Content-Type':
          'application/json'
      };

      /*
       * Se existir token configurado,
       * envia automaticamente.
       */
      if (storefrontToken) {
        headers[
          'X-Shopify-Storefront-Access-Token'
        ] = storefrontToken;
      }

      try {
        const response =
          await fetch(
            `https://${shopDomain}/api/2026-07/graphql.json`,
            {
              method: 'POST',

              headers,

              body:
                JSON.stringify({
                  query:
                    graphQL,

                  variables
                })
            }
          );

        if (!response.ok) {
          throw new Error(
            `Shopify HTTP ${response.status}`
          );
        }

        const payload =
          await response.json();

        if (
          payload.errors?.length
        ) {
          throw new Error(
            payload.errors
              .map(
                (error) =>
                  error.message
              )
              .join(', ')
          );
        }

        const connection =
          payload?.data?.products;

        if (!connection) {
          throw new Error(
            'Resposta de produtos inválida.'
          );
        }

        connection.edges.forEach(
          (edge) => {
            const product =
              edge.node;

            /*
             * Nesta primeira versão
             * ignoramos produto sem imagem.
             */
            if (
              !product.featuredImage?.url
            ) {
              return;
            }

            /*
             * Evita duplicação.
             */
            if (
              products.some(
                (item) =>
                  item.shopifyId ===
                  product.id
              )
            ) {
              return;
            }

            const localId =
              `shopify-${product.id}`;

            const category =
              detectCategory(
                product.title,
                product.productType
              );

            const profile =
              buildProductProfile(
                product,
                product.metafields || []
              );

            const item = {
              id:
                localId,

              shopifyId:
                product.id,

              source:
                'shopify',

              handle:
                product.handle,

              name:
                product.title,

              productType:
                product.productType ||
                '',

              category,

              meta:
                product.productType ||
                'Produto A Gourmet',

              profile,

              metafields:
                product.metafields ||
                [],

              minimum:
                profile.minimum,

              basePrice:
                parseNumber(
                  product.priceRange
                    ?.minVariantPrice
                    ?.amount,
                  0
                ),

              currency:
                product.priceRange
                  ?.minVariantPrice
                  ?.currencyCode ||
                'BRL',

              image:
                product.featuredImage.url
            };

            products.push(
              item
            );

            renderShopifyProduct(
              item
            );
          }
        );

        shopifyLibrary.cursor =
  connection.pageInfo.endCursor;

shopifyLibrary.hasNextPage =
  connection.pageInfo.hasNextPage;

shopifyLibrary.initialized =
  true;

const firstShopifyProduct =
  products.find(
    (product) =>
      product.source === 'shopify'
  );

if (
  !active &&
  firstShopifyProduct
) {
  selectProduct(
    firstShopifyProduct.id
  );
}

if (
  active &&
  !products.some(
    (product) =>
      String(product.id) ===
      String(active.id)
  )
) {
  active = null;

  if (firstShopifyProduct) {
    selectProduct(
      firstShopifyProduct.id
    );
  }
}

updateLibraryUI();

if (pendingProject) {
  applyProjectData(
    pendingProject
  );
}

      } catch (error) {
        console.error(
          'A Gourmet Studio — catálogo Shopify:',
          error
        );

        if (els.loadMore) {
          els.loadMore.hidden = false;

          els.loadMore.textContent =
            'Não foi possível carregar mais produtos';
        }

        /*
         * Mantém o Studio funcionando
         * com os produtos manuais.
         */
        applyProductFilters();

      } finally {
        shopifyLibrary.loading =
          false;

        if (els.loading) {
          els.loading.hidden =
            true;
        }

        if (els.loadMore) {
          els.loadMore.disabled =
            false;
        }
      }
    }

    /* ========================================================
       CATEGORIA
       ======================================================== */

    const setCategory = (
      category,
      {
        fetchRemote = true
      } = {}
    ) => {
      currentCategory =
        category || 'all';

      els.categoryButtons.forEach(
        (button) => {
          button.classList.toggle(
            'is-active',
            button.dataset.category ===
              currentCategory
          );
        }
      );

      /*
       * Favoritos são recuperados do armazenamento local,
       * sem depender de uma nova consulta à Shopify.
       */
      if (
        currentCategory ===
        'favoritos'
      ) {
        ensureFavoriteProductsRendered();
        updateFavoritesCount();
        updateStudioStatus();
        applyProductFilters();

        if (els.loadMore) {
          els.loadMore.hidden =
            true;
        }

        return;
      }

      /*
       * Primeiro atualiza o que já está
       * na tela.
       */
      applyProductFilters();

      /*
       * Depois consulta o catálogo completo.
       */
      if (fetchRemote) {
        fetchShopifyProducts({
          reset: true
        });
      }
    };

    /* ========================================================
       BUSCA
       ======================================================== */

    if (els.search) {
      els.search.addEventListener(
        'input',
        (event) => {
          currentSearch =
            event.target.value;

          clearTimeout(
            searchTimer
          );

          /*
           * Mostra imediatamente o filtro
           * dos produtos já carregados.
           */
          applyProductFilters();

          /*
           * E depois de 400ms consulta
           * o catálogo completo.
           */
          searchTimer =
            setTimeout(
              () => {
                categoryCountsSearchKey =
                  null;

                fetchCategoryCounts({
                  force: true
                });

                fetchShopifyProducts({
                  reset: true
                });
              },
              400
            );
        }
      );
    }

    /* ========================================================
       BOTÕES DE CATEGORIA
       ======================================================== */

    els.categoryButtons.forEach(
      (button) => {
        button.addEventListener(
          'click',
          () => {
            setCategory(
              button.dataset.category ||
              'all'
            );
          }
        );
      }
    );

    /* ========================================================
       CARREGAR MAIS
       ======================================================== */

    if (els.loadMore) {
      els.loadMore.addEventListener(
        'click',
        () => {
          fetchShopifyProducts({
            reset: false
          });
        }
      );
    }

    /* ========================================================
       PRESETS
       ======================================================== */

    const setPreset = (
      preset
    ) => {
      if (!els.stage) return;

      const rect =
        els.stage
          .getBoundingClientRect();

      if (preset === 'center') {
        state.x = 0;
        state.y = 0;

        if (els.position) {
          els.position.value =
            'Centro';
        }
      }

      if (preset === 'top') {
        state.x = 0;

        state.y =
          -rect.height * 0.28;

        if (els.position) {
          els.position.value =
            'Aba superior';
        }
      }

      if (preset === 'bottom') {
        state.x = 0;

        state.y =
          rect.height * 0.28;

        if (els.position) {
          els.position.value =
            'Aba inferior';
        }
      }

      root
        .querySelectorAll(
          '[data-preset]'
        )
        .forEach(
          (button) => {
            button.classList.toggle(
              'is-active',
              button.dataset.preset ===
                preset
            );
          }
        );

      apply();
    };

    /*
     * Ponto de partida da arte ao trocar de produto.
     *
     * Se houver metafield específico ele é respeitado.
     * Sem metafield, a arte inicia centralizada.
     */
    applyProductArtworkDefaults =
      (product) => {
        if (
          !product ||
          !logoLoaded ||
          isLaserProduct(
            product
          ) ||
          !els.stage
        ) {
          return;
        }

        const rect =
          els.stage
            .getBoundingClientRect();

        const profile =
          product.profile ||
          {};

        const scale =
          Number(
            profile.defaultScale
          );

        const rotation =
          Number(
            profile.defaultRotation
          );

        const percentX =
          Number(
            profile.defaultX
          );

        const percentY =
          Number(
            profile.defaultY
          );

        state.s =
          Number.isFinite(scale) &&
          scale > 0
            ? scale
            : 1;

        state.r =
          Number.isFinite(rotation)
            ? rotation
            : 0;

        state.c = 0;

        state.x =
          Number.isFinite(percentX)
            ? rect.width *
              (
                percentX /
                100
              )
            : 0;

        state.y =
          Number.isFinite(percentY)
            ? rect.height *
              (
                percentY /
                100
              )
            : 0;

        if (els.scale) {
          els.scale.value =
            state.s;
        }

        if (els.rot) {
          els.rot.value =
            state.r;
        }

        if (els.curve) {
          els.curve.value =
            0;
        }

        if (els.position) {
          const zone =
            normalize(
              profile.zone ||
              ''
            );

          if (
            zone.includes(
              'aba'
            ) &&
            zone.includes(
              'super'
            )
          ) {
            state.y =
              -rect.height *
              .28;

            els.position.value =
              'Aba superior';

          } else if (
            zone.includes(
              'aba'
            ) &&
            zone.includes(
              'infer'
            )
          ) {
            state.y =
              rect.height *
              .28;

            els.position.value =
              'Aba inferior';

          } else {
            els.position.value =
              'Centro';
          }
        }

        root
          .querySelectorAll(
            '[data-preset]'
          )
          .forEach(
            (button) => {
              const position =
                els.position
                  ?.value ||
                'Centro';

              const expected =
                position ===
                  'Aba superior'
                  ? 'top'
                  : (
                      position ===
                        'Aba inferior'
                        ? 'bottom'
                        : 'center'
                    );

              button.classList.toggle(
                'is-active',
                button.dataset.preset ===
                  expected
              );
            }
          );

        renderCurvedLogo();
        apply();
      };

    /* ========================================================
       RESET DA LOGO
       ======================================================== */

    const reset = () => {
      state = {
        x: 0,
        y: 0,
        s: 1,
        r: 0,
        c: 0,

        drag: false,
        dx: 0,
        dy: 0
      };

      if (els.scale) {
        els.scale.value = 1;
      }

      if (els.rot) {
        els.rot.value = 0;
      }

      if (els.curve) {
        els.curve.value = 0;
      }

      renderCurvedLogo();

      if (els.position) {
        if (
          isLaserProduct(active)
        ) {
          let caboOption =
            [
              ...els.position.options
            ].find(
              (option) =>
                option.value === 'Cabo'
            );

          if (!caboOption) {
            caboOption =
              document.createElement(
                'option'
              );

            caboOption.value =
              'Cabo';

            caboOption.textContent =
              'Cabo';

            els.position.appendChild(
              caboOption
            );
          }

          els.position.value =
            'Cabo';

        } else {
          els.position.value =
            'Centro';
        }
      }

      root
        .querySelectorAll(
          '[data-preset]'
        )
        .forEach(
          (button) => {
            button.classList.toggle(
              'is-active',
              button.dataset.preset ===
                'center'
            );
          }
        );

      apply();
    };

    /* ========================================================
       CLIQUE NOS PRODUTOS MANUAIS
       ======================================================== */

    root
      .querySelectorAll(
        '[data-product]:not([data-shopify-product="true"])'
      )
      .forEach(
        (button) => {
          button.addEventListener(
            'click',
            () => {
              selectProduct(
                parseProductId(
                  button.dataset.product
                )
              );
            }
          );
        }
      );

    /* ========================================================
       UPLOAD DA LOGO
       ======================================================== */

    if (els.file) {
      els.file.addEventListener(
        'change',
        (event) => {
          const file =
            event.target.files?.[0];

          if (!file) return;

          if (
            !file.type.startsWith(
              'image/'
            )
          ) {
            alert(
              'Envie uma imagem PNG, JPG, WEBP ou SVG.'
            );

            return;
          }

          if (
            file.size >
            8 * 1024 * 1024
          ) {
            alert(
              'A imagem deve ter no máximo 8 MB.'
            );

            return;
          }

          if (logoUrl) {
            URL.revokeObjectURL(
              logoUrl
            );
          }

          logoDataUrl = null;

          if (
            file.size <=
            2 * 1024 * 1024
          ) {
            const reader =
              new FileReader();

            reader.onload =
              () => {
                logoDataUrl =
                  typeof reader.result ===
                  'string'
                    ? reader.result
                    : null;
              };

            reader.readAsDataURL(
              file
            );
          }

          cleanedLogoCanvas = null;

          logoUrl =
            URL.createObjectURL(
              file
            );

          els.logo.onload =
            () => {
              logoLoaded = true;

              const width =
                els.logo.naturalWidth ||
                0;

              const height =
                els.logo.naturalHeight ||
                0;

              const shortest =
                Math.min(
                  width,
                  height
                );

              if (shortest >= 1200) {
                logoQuality = {
                  level: 'good',
                  label: 'Alta',
                  width,
                  height
                };

              } else if (
                shortest >= 700
              ) {
                logoQuality = {
                  level: 'medium',
                  label: 'Média',
                  width,
                  height
                };

              } else {
                logoQuality = {
                  level: 'low',
                  label: 'Baixa',
                  width,
                  height
                };
              }

              const qualityBox =
                root.querySelector(
                  '[data-quality]'
                );

              if (qualityBox) {
                qualityBox.dataset.level =
                  logoQuality.level;

                qualityBox.innerHTML = `
                  <span>
                    Qualidade da arte
                  </span>

                  <strong>
                    ${logoQuality.label}
                    ·
                    ${width}×${height}px
                  </strong>
                `;
              }

              buildTransparentLogoCanvas();

              logoCanvas
                .classList
                .remove(
                  'is-hidden'
                );

              if (els.placeholder) {
                els.placeholder.style.display =
                  'none';
              }

              renderCurvedLogo();
              reset();

              commercialProjectTouched =
                false;

              quoteRequested =
                false;

              updateCommercialUI();
              pushHistory();

              track(
                'logo_upload',
                {
                  width,
                  height,
                  quality:
                    logoQuality.level
                }
              );

              if (els.ready) {
                els.ready
                  .classList
                  .add(
                    'is-visible'
                  );

                setTimeout(
                  () => {
                    els.ready
                      .classList
                      .remove(
                        'is-visible'
                      );
                  },
                  2600
                );
              }
            };

          els.logo.src =
            logoUrl;
        }
      );
    }

    /* ========================================================
       ZOOM DE VISUALIZAÇÃO DO PRODUTO
       ======================================================== */

    const stageWrap =
      els.capture
        ?.closest(
          '.agfx__stage-wrap'
        );

    const zoomUI =
      document.createElement(
        'div'
      );

    zoomUI.className =
      'agfx__zoom';

    zoomUI.setAttribute(
      'data-zoom-ui',
      ''
    );

    zoomUI.innerHTML = `
      <button
        type="button"
        class="agfx__zoom-button"
        data-zoom-out
        aria-label="Diminuir zoom"
      >
        −
      </button>

      <span
        class="agfx__zoom-value"
        data-zoom-value
      >
        100%
      </span>

      <button
        type="button"
        class="agfx__zoom-button"
        data-zoom-in
        aria-label="Aumentar zoom"
      >
        +
      </button>

      <button
        type="button"
        class="agfx__zoom-button"
        data-zoom-reset
        aria-label="Restaurar zoom"
        title="Restaurar zoom"
      >
        ↺
      </button>

      <button
        type="button"
        class="agfx__zoom-fit"
        data-zoom-fit
        aria-label="Ajustar produto à tela"
      >
        Ajustar
      </button>
    `;

    if (stageWrap) {
      stageWrap.appendChild(
        zoomUI
      );
    }

    const updateViewZoom = (
      next
    ) => {
      viewZoom =
        Math.max(
          .72,
          Math.min(
            1.7,
            next
          )
        );

      if (els.capture) {
        els.capture.style.transform =
          `scale(${viewZoom})`;

        els.capture.style.transformOrigin =
          'center center';
      }

      const value =
        zoomUI.querySelector(
          '[data-zoom-value]'
        );

      if (value) {
        value.textContent =
          `${Math.round(
            viewZoom * 100
          )}%`;
      }

      track(
        'view_zoom',
        {
          zoom:
            Math.round(
              viewZoom * 100
            )
        }
      );
    };

    zoomUI
      .querySelector(
        '[data-zoom-out]'
      )
      ?.addEventListener(
        'click',
        () => {
          updateViewZoom(
            viewZoom - .1
          );
        }
      );

    zoomUI
      .querySelector(
        '[data-zoom-in]'
      )
      ?.addEventListener(
        'click',
        () => {
          updateViewZoom(
            viewZoom + .1
          );
        }
      );

    zoomUI
      .querySelector(
        '[data-zoom-reset]'
      )
      ?.addEventListener(
        'click',
        () => {
          updateViewZoom(
            1
          );
        }
      );

    const getProductFitCap = (
      product = active
    ) => {
      const category =
        product?.category ||
        detectCategory(
          product?.name ||
          '',
          product?.productType ||
          ''
        );

      /*
       * Peças largas recebem mais respiro.
       */
      if (
        category === 'pratos'
      ) {
        return .86;
      }

      if (
        category === 'travessas'
      ) {
        return .90;
      }

      if (
        category === 'bowls'
      ) {
        return .92;
      }

      if (
        category === 'talheres'
      ) {
        return .96;
      }

      if (
        category === 'xicaras' ||
        category === 'canecas' ||
        category === 'copos' ||
        category === 'tacas'
      ) {
        return .96;
      }

      return .94;
    };

    const calculateFitZoom = (
      product = active
    ) => {
      const categoryCap =
        getProductFitCap(
          product
        );

      if (
        !stageWrap ||
        !els.capture
      ) {
        return categoryCap;
      }

      const wrapRect =
        stageWrap
          .getBoundingClientRect();

      const captureWidth =
        els.capture.offsetWidth ||
        wrapRect.width ||
        1;

      const captureHeight =
        els.capture.offsetHeight ||
        wrapRect.height ||
        1;

      /*
       * Reserva aproximadamente 8% do palco para respiro.
       */
      const availableWidth =
        Math.max(
          1,
          wrapRect.width *
          .92
        );

      const availableHeight =
        Math.max(
          1,
          wrapRect.height *
          .92
        );

      const geometricFit =
        Math.min(
          availableWidth /
            captureWidth,
          availableHeight /
            captureHeight
        );

      return Math.max(
        .72,
        Math.min(
          categoryCap,
          geometricFit
        )
      );
    };

    const fitViewToStage = () => {
      updateViewZoom(
        calculateFitZoom(
          active
        )
      );
    };

    let fitHintTimer =
      null;

    const fitHint =
      document.createElement(
        'div'
      );

    fitHint.className =
      'agfx__fit-hint';

    fitHint.textContent =
      'Peça ajustada à tela';

    if (stageWrap) {
      stageWrap.appendChild(
        fitHint
      );
    }

    const showFitHint = () => {
      fitHint.classList.add(
        'is-visible'
      );

      clearTimeout(
        fitHintTimer
      );

      fitHintTimer =
        setTimeout(
          () => {
            fitHint.classList.remove(
              'is-visible'
            );
          },
          1200
        );
    };

    autoFitProductView =
      (product = active) => {
        requestAnimationFrame(
          () => {
            const nextZoom =
              calculateFitZoom(
                product
              );

            updateViewZoom(
              nextZoom
            );

            const category =
              product?.category ||
              '';

            root.classList.toggle(
              'agfx--fit-wide',
              (
                category ===
                  'pratos' ||
                category ===
                  'travessas' ||
                category ===
                  'bowls'
              )
            );

            showFitHint();
          }
        );
      };

    zoomUI
      .querySelector(
        '[data-zoom-fit]'
      )
      ?.addEventListener(
        'click',
        () => {
          fitViewToStage();

          if (active) {
            applyProductDisplayProfile(
              active,
              {
                notify: true
              }
            );
          }

          showFitHint();

          track(
            'view_fit'
          );
        }
      );


    /* ========================================================
       DRAG
       ======================================================== */

    textLayer.addEventListener(
      'pointerdown',
      (event) => {
        if (
          textLayer.classList.contains(
            'is-hidden'
          )
        ) {
          return;
        }

        const rect =
          els.stage
            .getBoundingClientRect();

        const x =
          event.clientX -
          rect.left;

        const y =
          event.clientY -
          rect.top;

        textState.drag =
          true;

        textState.dx =
          x -
          textState.x;

        textState.dy =
          y -
          textState.y;

        textLayer.classList.add(
          'is-dragging'
        );

        event.stopPropagation();
        event.preventDefault();
      }
    );

    window.addEventListener(
      'pointermove',
      (event) => {
        if (!textState.drag) {
          return;
        }

        const rect =
          els.stage
            .getBoundingClientRect();

        textState.x =
          (
            event.clientX -
            rect.left
          ) -
          textState.dx;

        textState.y =
          (
            event.clientY -
            rect.top
          ) -
          textState.dy;

        updateTextLayer();

        event.preventDefault();
      },
      {
        passive: false
      }
    );

    window.addEventListener(
      'pointerup',
      () => {
        if (textState.drag) {
          textState.drag = false;

          textLayer.classList.remove(
            'is-dragging'
          );

          pushHistory();
        }
      }
    );

    const point = (event) => {
      const rect =
        els.stage
          .getBoundingClientRect();

      const logicalWidth =
        els.stage.offsetWidth ||
        rect.width;

      const logicalHeight =
        els.stage.offsetHeight ||
        rect.height;

      const scaleX =
        rect.width
          ? logicalWidth /
            rect.width
          : 1;

      const scaleY =
        rect.height
          ? logicalHeight /
            rect.height
          : 1;

      return {
        x:
          (
            event.clientX -
            rect.left
          ) * scaleX,

        y:
          (
            event.clientY -
            rect.top
          ) * scaleY
      };
    };

    if (
      els.stage &&
      els.logo
    ) {
      els.stage.addEventListener(
        'pointerdown',
        (event) => {
          if (
            !logoLoaded ||
            logoCanvas
              .classList
              .contains(
                'is-hidden'
              )
          ) {
            return;
          }

          const p =
            point(event);

          state.drag =
            true;

          state.dx =
            p.x - state.x;

          state.dy =
            p.y - state.y;

          els.stage
            .classList
            .add(
              'is-dragging'
            );

          if (els.position) {
            if (
              isLaserProduct(active)
            ) {
              let caboOption =
                [
                  ...els.position.options
                ].find(
                  (option) =>
                    option.value === 'Cabo'
                );

              if (!caboOption) {
                caboOption =
                  document.createElement(
                    'option'
                  );

                caboOption.value =
                  'Cabo';

                caboOption.textContent =
                  'Cabo';

                els.position.appendChild(
                  caboOption
                );
              }

              els.position.value =
                'Cabo';

            } else {
              els.position.value =
                'Personalizada';
            }
          }

          root
            .querySelectorAll(
              '[data-preset]'
            )
            .forEach(
              (button) =>
                button
                  .classList
                  .remove(
                    'is-active'
                  )
            );

          event.preventDefault();
        }
      );
    }

    window.addEventListener(
      'pointermove',
      (event) => {
        if (!state.drag) return;

        const p =
          point(event);

        state.x =
          p.x - state.dx;

        state.y =
          p.y - state.dy;

        apply();

        event.preventDefault();
      },
      {
        passive: false
      }
    );

    window.addEventListener(
      'pointerup',
      () => {
        const wasDragging =
          state.drag;

        state.drag = false;

        els.stage
          ?.classList
          .remove(
            'is-dragging'
          );

        if (wasDragging) {
          pushHistory();
        }
      }
    );

    /* ========================================================
       SCROLL PARA ESCALA
       ======================================================== */

    if (
      els.stage &&
      els.logo
    ) {
      els.stage.addEventListener(
        'wheel',
        (event) => {
          if (
            !logoLoaded ||
            logoCanvas
              .classList
              .contains(
                'is-hidden'
              )
          ) {
            return;
          }

          event.preventDefault();

          state.s =
            Math.max(
              0.1,
              Math.min(
                4,
                state.s +
                  (
                    event.deltaY > 0
                      ? -0.06
                      : 0.06
                  )
              )
            );

          if (els.scale) {
            els.scale.value =
              state.s;
          }

          apply();
        },
        {
          passive: false
        }
      );
    }

    /* ========================================================
       CONTROLES
       ======================================================== */

    if (els.scale) {
      els.scale.oninput =
        (event) => {
          state.s =
            Number(
              event.target.value
            );

          apply();
        };
    }

    if (els.rot) {
      els.rot.min = 0;
      els.rot.max = 360;
      els.rot.step = 1;
      els.rot.value = 0;

      els.rot.oninput =
        (event) => {
          state.r =
            Number(
              event.target.value
            );

          apply();
        };
    }

    if (els.curve) {
      els.curve.min = -60;
      els.curve.max = 60;
      els.curve.step = 1;
      els.curve.value = 0;

      els.curve.oninput =
        (event) => {
          state.c =
            Number(
              event.target.value
            );

          renderCurvedLogo();
          apply();
        };
    }

    [
      els.scale,
      els.rot,
      els.curve
    ]
      .filter(Boolean)
      .forEach(
        (control) => {
          control.addEventListener(
            'change',
            () => {
              pushHistory();
            }
          );
        }
      );

    if (els.qty) {
      els.qty.oninput =
        updateSummary;

      els.qty.addEventListener(
        'change',
        () => {
          updateSummary();
          pushHistory();
        }
      );
    }

    if (els.position) {
      els.position.onchange =
        () => {
          updateSummary();
          markCommercialTouched();
        };
    }

    /*
     * Qualquer ajuste relevante depois do upload conclui
     * a etapa "Personalize".
     */
    root.addEventListener(
      'change',
      (event) => {
        if (
          event.target.matches(
            '[data-scale], [data-rot], [data-curve], [data-text-input], [data-text-size], [data-text-color]'
          )
        ) {
          markCommercialTouched();
        }
      }
    );

    root.addEventListener(
      'click',
      (event) => {
        if (
          event.target.closest(
            '[data-preset], [data-blend], [data-adjust-handle], [data-print-ink], [data-text-bold], [data-remove-background]'
          )
        ) {
          markCommercialTouched();
        }
      }
    );

    root.addEventListener(
      'pointerdown',
      (event) => {
        if (
          logoLoaded &&
          (
            event.target ===
              logoCanvas ||
            event.target ===
              textLayer
          )
        ) {
          markCommercialTouched();
        }
      }
    );

    root
      .querySelectorAll(
        '[data-preset]'
      )
      .forEach(
        (button) => {
          button.onclick =
            () => {
              setPreset(
                button.dataset.preset
              );
            };
        }
      );

    const guidesButton =
      root.querySelector(
        '[data-guides]'
      );

    if (guidesButton) {
      guidesButton.onclick =
        (event) => {
          els.capture
            ?.classList
            .toggle(
              'has-guides'
            );

          event.currentTarget
            .classList
            .toggle(
              'is-active'
            );
        };
    }

    const safeButton =
      root.querySelector(
        '[data-safe]'
      );

    if (safeButton) {
      safeButtonOriginalText =
        'ÁREA DE APLICAÇÃO';

      safeButton.textContent =
        safeButtonOriginalText;

      safeButton.onclick =
        (event) => {
          els.capture
            ?.classList
            .toggle(
              'has-safe'
            );

          event.currentTarget
            .classList
            .toggle(
              'is-active'
            );
        };
    }

    blendButton =
      root.querySelector(
        '[data-blend]'
      );

    /*
     * Adiciona automaticamente o botão LASER.
     * Não precisa alterar Liquid nem HTML.
     */
    const quickControls =
      blendButton
        ?.closest(
          '.agfx__quick'
        );

    if (
      quickControls &&
      !root.querySelector(
        '[data-laser]'
      )
    ) {
      laserButton =
        document.createElement(
          'button'
        );

      laserButton.type =
        'button';

      laserButton.className =
        'agfx__mini';

      laserButton.setAttribute(
        'data-laser',
        ''
      );

      laserButton.setAttribute(
        'aria-pressed',
        'false'
      );

      laserButton.textContent =
        'LASER';

      laserButton.title =
        'Simula gravação a laser em talheres e peças metálicas';

      quickControls.appendChild(
        laserButton
      );

      /*
       * Com quatro controles, organiza em 2x2 para não apertar
       * Guias / Área Segura / Realismo / Laser.
       */
      quickControls.style.gridTemplateColumns =
        'repeat(2, minmax(0, 1fr))';
    } else {
      laserButton =
        root.querySelector(
          '[data-laser]'
        );
    }

    /*
     * Cabeçalho comercial com ID e progresso do projeto.
     */
    const editorPanel =
      els.title
        ?.closest(
          '.agfx__panel'
        ) ||
      root.querySelector(
        '.agfx__panel'
      );

    const commercialCard =
      document.createElement(
        'div'
      );

    commercialCard.className =
      'agfx__commercial';

    commercialCard.setAttribute(
      'data-commercial-card',
      ''
    );

    commercialCard.innerHTML = `
      <div class="agfx__commercial-top">
        <div class="agfx__commercial-project">
          <span class="agfx__commercial-eyebrow">
            Seu projeto
          </span>

          <strong
            class="agfx__commercial-id"
            data-commercial-id
          >
            ${escapeHTML(projectId)}
          </strong>
        </div>

        <span
          class="agfx__commercial-status"
          data-commercial-status
          data-status="editing"
        >
          Em edição
        </span>
      </div>

      <div
        class="agfx__progress"
        data-commercial-progress
      >
        <div
          class="agfx__progress-step"
          data-progress-step="1"
        >
          <span class="agfx__progress-number">
            1
          </span>

          <span>Peça</span>
        </div>

        <div
          class="agfx__progress-step"
          data-progress-step="2"
        >
          <span class="agfx__progress-number">
            2
          </span>

          <span>Logo</span>
        </div>

        <div
          class="agfx__progress-step"
          data-progress-step="3"
        >
          <span class="agfx__progress-number">
            3
          </span>

          <span>Personalize</span>
        </div>

        <div
          class="agfx__progress-step"
          data-progress-step="4"
        >
          <span class="agfx__progress-number">
            4
          </span>

          <span>Orçamento</span>
        </div>
      </div>

      <p
        class="agfx__commercial-hint"
        data-commercial-hint
      >
        Escolha uma peça para começar.
      </p>
    `;

    if (
      editorPanel &&
      !root.querySelector(
        '[data-commercial-card]'
      )
    ) {
      editorPanel.insertBefore(
        commercialCard,
        editorPanel.firstChild
      );
    }

    const updateCommercialUI = () => {
      const status =
        root.querySelector(
          '[data-commercial-status]'
        );

      const hint =
        root.querySelector(
          '[data-commercial-hint]'
        );

      const project =
        root.querySelector(
          '[data-commercial-id]'
        );

      if (project) {
        project.textContent =
          projectId;
      }

      let statusText =
        'Em edição';

      let statusCode =
        'editing';

      let hintText =
        'Escolha uma peça para começar.';

      if (active) {
        hintText =
          'Agora envie sua logo para criar a prévia.';
      }

      if (logoLoaded) {
        hintText =
          'Ajuste a arte, posição e acabamento.';
      }

      if (
        logoLoaded &&
        commercialProjectTouched
      ) {
        statusText =
          'Projeto pronto';

        statusCode =
          'ready';

        hintText =
          'Projeto pronto. Você já pode solicitar o orçamento.';
      }

      if (quoteRequested) {
        statusText =
          'Orçamento solicitado';

        statusCode =
          'sent';

        hintText =
          'Solicitação preparada para atendimento comercial.';
      }

      if (status) {
        status.textContent =
          statusText;

        status.dataset.status =
          statusCode;
      }

      if (hint) {
        hint.textContent =
          hintText;
      }

      const steps =
        root.querySelectorAll(
          '[data-progress-step]'
        );

      const completed = {
        1:
          Boolean(active),

        2:
          Boolean(
            logoLoaded
          ),

        3:
          Boolean(
            logoLoaded &&
            commercialProjectTouched
          ),

        4:
          Boolean(
            quoteRequested
          )
      };

      let currentStep = 1;

      if (completed[1]) {
        currentStep = 2;
      }

      if (completed[2]) {
        currentStep = 3;
      }

      if (completed[3]) {
        currentStep = 4;
      }

      if (completed[4]) {
        currentStep = 4;
      }

      steps.forEach(
        (step) => {
          const number =
            Number(
              step.dataset.progressStep
            );

          step.classList.toggle(
            'is-done',
            Boolean(
              completed[
                number
              ]
            )
          );

          step.classList.toggle(
            'is-current',
            !completed[number] &&
            number ===
              currentStep
          );
        }
      );

      updateSummary();
    };

    const markCommercialTouched =
      () => {
        if (!logoLoaded) {
          return;
        }

        commercialProjectTouched =
          true;

        quoteRequested =
          false;

        updateCommercialUI();
      };

    updateCommercialUI();

    /*
     * Fundo da prévia + Modo Vidro.
     */
    const visualizationCard =
      document.createElement(
        'div'
      );

    visualizationCard.className =
      'agfx__visual-card';

    visualizationCard.setAttribute(
      'data-visual-card',
      ''
    );

    visualizationCard.innerHTML = `
      <div class="agfx__visual-head">
        <span
          class="agfx__visual-title"
          data-visual-title
        >
          Visualização
        </span>

        <span class="agfx__glass-badge">
          Modo vidro
        </span>
      </div>


      <div class="agfx__visual-group agfx__glass-print">
        <span class="agfx__visual-label">
          Cor da impressão
        </span>

        <div class="agfx__segmented">
          <button
            type="button"
            class="agfx__segmented-button"
            data-print-ink="color"
          >
            Colorida
          </button>

          <button
            type="button"
            class="agfx__segmented-button"
            data-print-ink="black"
          >
            Preta
          </button>

          <button
            type="button"
            class="agfx__segmented-button"
            data-print-ink="white"
          >
            Branca
          </button>
        </div>

        <p class="agfx__visual-note">
          Simulação visual para peças transparentes.
        </p>
      </div>
    `;

    if (
      quickControls &&
      !root.querySelector(
        '[data-visual-card]'
      )
    ) {
      quickControls.insertAdjacentElement(
        'afterend',
        visualizationCard
      );
    }

    const updateVisualizationUI = () => {
      const glass =
        isGlassProduct(
          active
        );

      root.classList.toggle(
        'agfx--glass-product',
        glass
      );

      root.dataset.printInk =
        printInkMode;

      const visualTitle =
        root.querySelector(
          '[data-visual-title]'
        );

      if (visualTitle) {
        visualTitle.textContent =
          glass
            ? 'Impressão no vidro'
            : 'Visualização';
      }

      previewBackgroundMode =
        'light';

      if (els.capture) {
        els.capture.dataset.previewBackground =
          'light';
      }

      root
        .querySelectorAll(
          '[data-preview-bg]'
        )
        .forEach(
          (button) => {
            button.classList.toggle(
              'is-active',
              button.dataset.previewBg ===
                previewBackgroundMode
            );
          }
        );

      root
        .querySelectorAll(
          '[data-print-ink]'
        )
        .forEach(
          (button) => {
            button.classList.toggle(
              'is-active',
              button.dataset.printInk ===
                printInkMode
            );
          }
        );

      updateTextLayer();

      if (logoLoaded) {
        renderCurvedLogo();
      }
    };


    root
      .querySelectorAll(
        '[data-print-ink]'
      )
      .forEach(
        (button) => {
          button.addEventListener(
            'click',
            () => {
              printInkMode =
                button.dataset.printInk ||
                'color';

              updateVisualizationUI();
              pushHistory();
              updateSummary();

              track(
                'print_ink',
                {
                  ink:
                    printInkMode
                }
              );
            }
          );
        }
      );

    const updateGlassAvailability = () => {
      const glass =
        isGlassProduct(
          active
        );

      /*
       * V5.6:
       * fundo da prévia removido.
       * Mantemos somente o comportamento de cor da impressão.
       */
      previewBackgroundMode =
        'light';

      previewBackgroundUserChanged =
        false;

      previewBackgroundAutoGlass =
        false;

      if (
        !glass &&
        printInkMode !==
          'color'
      ) {
        printInkMode =
          'color';
      }

      updateVisualizationUI();
    };

    updateVisualizationUI();


    /*
     * Bloco informativo exclusivo para talheres.
     * Aparece automaticamente abaixo dos controles rápidos.
     */
    if (
      quickControls &&
      !root.querySelector(
        '[data-technique-card]'
      )
    ) {
      techniqueCard =
        document.createElement(
          'div'
        );

      techniqueCard.className =
        'agfx__technique-card';

      techniqueCard.setAttribute(
        'data-technique-card',
        ''
      );

      techniqueCard.innerHTML = `
        <div class="agfx__technique-top">
          <span class="agfx__technique-label">
            <span class="agfx__technique-dot"></span>
            Técnica de personalização
          </span>

          <span class="agfx__technique-badge">
            Laser
          </span>
        </div>

        <div class="agfx__technique-title">
          Gravação a laser obrigatória
        </div>

        <p class="agfx__technique-copy">
          Talheres A Gourmet recebem exclusivamente gravação a laser. A arte é convertida para acabamento monocromático, simulando o resultado no aço inox.
        </p>

        <div class="agfx__technique-benefits">
          <span class="agfx__technique-benefit">
            Permanente
          </span>

          <span class="agfx__technique-benefit">
            Sem tinta
          </span>

          <span class="agfx__technique-benefit">
            Alta durabilidade
          </span>
        </div>

        <button
          type="button"
          class="agfx__adjust-handle"
          data-adjust-handle
        >
          ↗ Ajustar ao cabo
        </button>

        <div class="agfx__technique-hint">
          <span>ℹ</span>
          <span>
            <strong>Ajuste fino:</strong>
            depois do posicionamento automático, arraste ou gire a arte se necessário.
          </span>
        </div>
      `;

      quickControls.insertAdjacentElement(
        'afterend',
        techniqueCard
      );
    } else {
      techniqueCard =
        root.querySelector(
          '[data-technique-card]'
        );
    }

    adjustHandleButton =
      root.querySelector(
        '[data-adjust-handle]'
      );

    if (adjustHandleButton) {
      adjustHandleButton.onclick =
        () => {
          adjustToHandle();
        };
    }

    /*
     * Ferramentas avançadas — texto, fundo, histórico e projeto.
     */
    const proTools =
      document.createElement(
        'details'
      );

    proTools.className =
      'agfx__pro-tools';

    proTools.setAttribute(
      'data-pro-tools',
      ''
    );

    proTools.innerHTML = `
      <summary>
        Ferramentas avançadas
      </summary>

      <div class="agfx__pro-tools-body">

        <div class="agfx__pro-section">
          <label class="agfx__pro-label">
            Texto personalizado
          </label>

          <input
            type="text"
            class="agfx__pro-input"
            data-text-input
            maxlength="60"
            placeholder="Ex.: Hotel Aurora"
          >

          <div class="agfx__pro-grid">
            <label>
              <span class="agfx__pro-label">
                Tamanho
              </span>

              <input
                type="range"
                class="agfx__pro-range"
                data-text-size
                min="12"
                max="90"
                step="1"
                value="28"
              >
            </label>

            <label>
              <span class="agfx__pro-label">
                Cor
              </span>

              <input
                type="color"
                class="agfx__pro-input"
                data-text-color
                value="#16362f"
              >
            </label>
          </div>

          <div class="agfx__pro-grid">
            <button
              type="button"
              class="agfx__pro-button"
              data-text-bold
            >
              B Negrito
            </button>

            <button
              type="button"
              class="agfx__pro-button is-active"
              data-remove-background
            >
              Fundo branco: remover
            </button>
          </div>

          <div
            class="agfx__quality"
            data-quality
            data-level="empty"
          >
            <span>
              Qualidade da arte
            </span>

            <strong>
              Nenhuma arte
            </strong>
          </div>
        </div>

        <div class="agfx__pro-section">
          <span class="agfx__pro-label">
            Histórico
          </span>

          <div class="agfx__pro-grid">
            <button
              type="button"
              class="agfx__pro-button"
              data-undo
            >
              ↶ Desfazer
            </button>

            <button
              type="button"
              class="agfx__pro-button"
              data-redo
            >
              ↷ Refazer
            </button>
          </div>
        </div>

        <div class="agfx__pro-section">
          <span class="agfx__pro-label">
            Projeto
          </span>

          <div class="agfx__pro-grid">
            <button
              type="button"
              class="agfx__pro-button"
              data-save-project
            >
              Salvar
            </button>

            <button
              type="button"
              class="agfx__pro-button"
              data-load-project
            >
              Restaurar
            </button>

            <button
              type="button"
              class="agfx__pro-button"
              data-share-project
            >
              Copiar link
            </button>

            <button
              type="button"
              class="agfx__pro-button"
              data-print-project
            >
              Ficha / PDF
            </button>
          </div>
        </div>

      </div>
    `;

    if (
      !root.querySelector(
        '[data-pro-tools]'
      )
    ) {
      (
        techniqueCard ||
        quickControls
      )
        ?.insertAdjacentElement(
          'afterend',
          proTools
        );
    }

    const toast =
      document.createElement(
        'div'
      );

    toast.className =
      'agfx__project-toast';

    document.body.appendChild(
      toast
    );

    let toastTimer = null;

    const showToast = (
      message
    ) => {
      toast.textContent =
        message;

      toast.classList.add(
        'is-visible'
      );

      clearTimeout(
        toastTimer
      );

      toastTimer =
        setTimeout(
          () => {
            toast.classList.remove(
              'is-visible'
            );
          },
          2200
        );
    };

    const textInput =
      root.querySelector(
        '[data-text-input]'
      );

    const textSize =
      root.querySelector(
        '[data-text-size]'
      );

    const textColor =
      root.querySelector(
        '[data-text-color]'
      );

    const textBold =
      root.querySelector(
        '[data-text-bold]'
      );

    const backgroundButton =
      root.querySelector(
        '[data-remove-background]'
      );

    const undoButton =
      root.querySelector(
        '[data-undo]'
      );

    const redoButton =
      root.querySelector(
        '[data-redo]'
      );

    const saveProjectButton =
      root.querySelector(
        '[data-save-project]'
      );

    const loadProjectButton =
      root.querySelector(
        '[data-load-project]'
      );

    const shareProjectButton =
      root.querySelector(
        '[data-share-project]'
      );

    const printProjectButton =
      root.querySelector(
        '[data-print-project]'
      );

    const serializeProject = () => ({
      version: 5.4,

      projectId,

      commercialTouched:
        commercialProjectTouched,

      quoteRequested,

      productId:
        active?.id || null,

      shopifyId:
        active?.shopifyId || null,

      productName:
        active?.name || '',

      handle:
        active?.handle || '',

      state: {
        x: state.x,
        y: state.y,
        s: state.s,
        r: state.r,
        c: state.c
      },

      text:
        {
          ...textState,
          drag: false,
          dx: 0,
          dy: 0
        },

      quantity:
        els.qty?.value ||
        active?.minimum ||
        1,

      position:
        els.position?.value ||
        'Centro',

      realism:
        realismEnabled,

      laser:
        laserEnabled,

      removeBackground:
        removeBackgroundEnabled,

      previewBackground:
        'light',

      printInk:
        printInkMode,

      logoDataUrl:
        logoDataUrl &&
        logoDataUrl.length <
          2500000
          ? logoDataUrl
          : null
    });

    const applyProjectData = (
      project
    ) => {
      if (!project) return false;

      if (project.projectId) {
        projectId =
          project.projectId;

        sessionStorage.setItem(
          projectIdStorageKey,
          projectId
        );
      }

      commercialProjectTouched =
        Boolean(
          project.commercialTouched
        );

      quoteRequested =
        Boolean(
          project.quoteRequested
        );

      updateCommercialUI();

      const target =
        products.find(
          (product) =>
            (
              project.handle &&
              product.handle ===
                project.handle
            ) ||
            (
              project.shopifyId &&
              product.shopifyId ===
                project.shopifyId
            ) ||
            (
              project.productName &&
              product.name ===
                project.productName
            )
        );

      if (!target) {
        pendingProject =
          project;

        if (
          els.search &&
          project.productName
        ) {
          currentSearch =
            project.productName;

          els.search.value =
            project.productName;
        }

        fetchShopifyProducts({
          reset: true
        });

        return false;
      }

      selectProduct(
        target.id
      );

      if (project.state) {
        Object.assign(
          state,
          project.state
        );
      }

      if (project.text) {
        Object.assign(
          textState,
          project.text
        );
      }

      removeBackgroundEnabled =
        project.removeBackground !==
        false;

      previewBackgroundMode =
        'light';

      printInkMode =
        project.printInk ||
        'color';

      previewBackgroundUserChanged =
        false;

      updateVisualizationUI();

      if (backgroundButton) {
        backgroundButton.classList.toggle(
          'is-active',
          removeBackgroundEnabled
        );

        backgroundButton.textContent =
          removeBackgroundEnabled
            ? 'Fundo branco: remover'
            : 'Fundo branco: original';
      }

      if (els.scale) {
        els.scale.value =
          state.s;
      }

      if (els.rot) {
        els.rot.value =
          state.r;
      }

      if (els.curve) {
        els.curve.value =
          state.c;
      }

      if (els.qty) {
        els.qty.value =
          Math.max(
            Number(
              project.quantity
            ) ||
            target.minimum ||
            1,

            target.minimum ||
            1
          );
      }

      if (
        els.position &&
        project.position
      ) {
        const exists =
          [
            ...els.position.options
          ].some(
            (option) =>
              option.value ===
                project.position
          );

        if (!exists) {
          const option =
            document.createElement(
              'option'
            );

          option.value =
            project.position;

          option.textContent =
            project.position;

          els.position.appendChild(
            option
          );
        }

        els.position.value =
          project.position;
      }

      if (
        project.logoDataUrl &&
        els.logo
      ) {
        logoDataUrl =
          project.logoDataUrl;

        els.logo.onload =
          () => {
            logoLoaded = true;
            buildTransparentLogoCanvas();

            logoCanvas.classList.remove(
              'is-hidden'
            );

            if (els.placeholder) {
              els.placeholder.style.display =
                'none';
            }

            renderCurvedLogo();
            apply();
            updateTextLayer();
          };

        els.logo.src =
          project.logoDataUrl;
      }

      if (
        project.laser &&
        isLaserProduct(
          target
        )
      ) {
        setLaser(true);

      } else {
        setLaser(false);
        setRealism(
          Boolean(
            project.realism
          )
        );
      }

      if (textInput) {
        textInput.value =
          textState.value ||
          '';
      }

      if (textSize) {
        textSize.value =
          textState.size;
      }

      if (textColor) {
        textColor.value =
          textState.color;
      }

      if (textBold) {
        textBold.classList.toggle(
          'is-active',
          textState.bold
        );
      }

      updateTextLayer();
      buildTransparentLogoCanvas();
      renderCurvedLogo();
      apply();
      updateSummary();

      autoFitProductView(
        active
      );

      applyProductDisplayProfile(
        active
      );

      pushHistory();

      pendingProject = null;

      return true;
    };

    if (textInput) {
      textInput.addEventListener(
        'input',
        (event) => {
          textState.value =
            event.target.value;

          updateTextLayer();
          updateSummary();

          track(
            'text_change',
            {
              has_text:
                Boolean(
                  textState.value
                )
            }
          );
        }
      );

      textInput.addEventListener(
        'change',
        () => {
          pushHistory();
        }
      );
    }

    if (textSize) {
      textSize.addEventListener(
        'input',
        (event) => {
          textState.size =
            Number(
              event.target.value
            );

          updateTextLayer();
        }
      );

      textSize.addEventListener(
        'change',
        pushHistory
      );
    }

    if (textColor) {
      textColor.addEventListener(
        'input',
        (event) => {
          textState.color =
            event.target.value;

          updateTextLayer();
        }
      );

      textColor.addEventListener(
        'change',
        pushHistory
      );
    }

    if (textBold) {
      textBold.onclick =
        () => {
          textState.bold =
            !textState.bold;

          textBold.classList.toggle(
            'is-active',
            textState.bold
          );

          updateTextLayer();
          pushHistory();
        };
    }

    if (backgroundButton) {
      backgroundButton.onclick =
        () => {
          removeBackgroundEnabled =
            !removeBackgroundEnabled;

          backgroundButton.classList.toggle(
            'is-active',
            removeBackgroundEnabled
          );

          backgroundButton.textContent =
            removeBackgroundEnabled
              ? 'Fundo branco: remover'
              : 'Fundo branco: original';

          buildTransparentLogoCanvas();
          renderCurvedLogo();
          pushHistory();

          track(
            'background_toggle',
            {
              remove:
                removeBackgroundEnabled
            }
          );
        };
    }

    if (undoButton) {
      undoButton.onclick =
        undo;
    }

    if (redoButton) {
      redoButton.onclick =
        redo;
    }

    if (saveProjectButton) {
      saveProjectButton.onclick =
        () => {
          try {
            localStorage.setItem(
              projectStorageKey,
              JSON.stringify(
                serializeProject()
              )
            );

            showToast(
              'Projeto salvo neste navegador'
            );

            track(
              'project_save'
            );

          } catch (error) {
            console.error(
              error
            );

            alert(
              'Não foi possível salvar este projeto no navegador.'
            );
          }
        };
    }

    if (loadProjectButton) {
      loadProjectButton.onclick =
        () => {
          try {
            const saved =
              localStorage.getItem(
                projectStorageKey
              );

            if (!saved) {
              showToast(
                'Nenhum projeto salvo'
              );

              return;
            }

            applyProjectData(
              JSON.parse(
                saved
              )
            );

            showToast(
              'Projeto restaurado'
            );

            track(
              'project_restore'
            );

          } catch (error) {
            console.error(
              error
            );

            alert(
              'Não foi possível restaurar o projeto.'
            );
          }
        };
    }

    const encodeShareProject = (
      project
    ) => {
      const clean = {
        ...project,
        logoDataUrl: null
      };

      const json =
        JSON.stringify(
          clean
        );

      return btoa(
        unescape(
          encodeURIComponent(
            json
          )
        )
      )
        .replaceAll('+', '-')
        .replaceAll('/', '_')
        .replaceAll('=', '');
    };

    const decodeShareProject = (
      value
    ) => {
      try {
        let base64 =
          value
            .replaceAll('-', '+')
            .replaceAll('_', '/');

        while (
          base64.length % 4
        ) {
          base64 += '=';
        }

        const json =
          decodeURIComponent(
            escape(
              atob(
                base64
              )
            )
          );

        return JSON.parse(
          json
        );

      } catch (error) {
        return null;
      }
    };

    if (shareProjectButton) {
      shareProjectButton.onclick =
        async () => {
          const url =
            new URL(
              window.location.href
            );

          url.hash =
            `agstudio=${encodeShareProject(serializeProject())}`;

          try {
            await navigator.clipboard.writeText(
              url.toString()
            );

            showToast(
              'Link copiado — a logo deve ser enviada novamente'
            );

          } catch (error) {
            window.prompt(
              'Copie o link do projeto:',
              url.toString()
            );
          }

          track(
            'project_share'
          );
        };
    }

    const hashMatch =
      window.location.hash.match(
        /agstudio=([^&]+)/
      );

    if (hashMatch) {
      pendingProject =
        decodeShareProject(
          hashMatch[1]
        );
    }

    /*
     * Descobre o bloco "Posição recomendada".
     * No modo talher ele será ocultado.
     */
    const firstPreset =
      root.querySelector(
        '[data-preset]'
      );

    presetBox =
      firstPreset
        ?.closest(
          '.agfx__box'
        ) ||
      null;

    /*
     * Organização visual do painel:
     * PERSONALIZAÇÃO / AJUSTE DA ARTE / PEDIDO
     */
    const addPanelSectionHeading = (
      beforeElement,
      label,
      key
    ) => {
      if (
        !beforeElement ||
        root.querySelector(
          `[data-section-heading="${key}"]`
        )
      ) {
        return;
      }

      const heading =
        document.createElement(
          'div'
        );

      heading.className =
        'agfx__section-heading';

      heading.setAttribute(
        'data-section-heading',
        key
      );

      heading.textContent =
        label;

      beforeElement.insertAdjacentElement(
        'beforebegin',
        heading
      );
    };

    const quantityBox =
      els.qty
        ?.closest(
          '.agfx__box'
        ) ||
      els.qty
        ?.parentElement ||
      null;

    addPanelSectionHeading(
      quickControls,
      'Personalização',
      'personalization'
    );

    addPanelSectionHeading(
      presetBox ||
      els.scale
        ?.closest(
          '.agfx__box'
        ),
      'Ajuste da arte',
      'artwork'
    );

    addPanelSectionHeading(
      quantityBox,
      'Pedido',
      'order'
    );

    /*
     * V5.16:
     * Ferramentas avançadas deixa de interromper
     * Personalização / Impressão no vidro.
     *
     * Ordem final:
     * Personalização
     * Impressão no vidro
     * Ajuste da arte
     * Ferramentas avançadas
     * Pedido
     */
    const orderHeading =
      root.querySelector(
        '[data-section-heading="order"]'
      );

    if (
      proTools &&
      orderHeading
    ) {
      orderHeading.insertAdjacentElement(
        'beforebegin',
        proTools
      );
    }

    if (blendButton) {
      const initialRealism =
        blendButton.classList.contains(
          'is-active'
        );

      blendButton.title =
        'Simula impressão aplicada sobre a curvatura, luz e sombra do produto';

      blendButton.onclick =
        () => {
          setRealism(
            !realismEnabled
          );
        };

      setRealism(
        initialRealism
      );
    } else {
      setRealism(false);
    }

    if (laserButton) {
      /*
       * Nos talheres o Laser não é uma opção:
       * é a técnica obrigatória e automática.
       */
      laserButton.onclick =
        null;

      updateLaserAvailability();
    }

    syncPersonalizationModeUI();

    /* ========================================================
       COMPARAÇÃO DE PRODUTOS
       ======================================================== */

    const compareTray =
      document.createElement(
        'div'
      );

    compareTray.className =
      'agfx__compare-tray';

    compareTray.innerHTML = `
      <div class="agfx__compare-tray-info">
        <strong data-compare-title>
          Comparar no Studio
        </strong>

        <span data-compare-subtitle>
          0 produtos selecionados
        </span>
      </div>

      <div class="agfx__compare-tray-actions">
        <button
          type="button"
          data-clear-compare
        >
          Limpar
        </button>

        <button
          type="button"
          data-open-compare
        >
          Comparar no Studio
        </button>
      </div>
    `;

    document.body.appendChild(
      compareTray
    );

    const compareModal =
      document.createElement(
        'div'
      );

    compareModal.className =
      'agfx__compare-modal';

    compareModal.innerHTML = `
      <div
        class="agfx__compare-dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Comparação de produtos"
      >
        <div class="agfx__compare-head">
          <div>
            <h3>
              Comparar peças no Studio
            </h3>
          </div>

          <button
            type="button"
            class="agfx__compare-close"
            data-close-compare
            aria-label="Fechar comparação"
          >
            ×
          </button>
        </div>

        <div
          class="agfx__compare-grid"
          data-compare-grid
        ></div>
      </div>
    `;

    document.body.appendChild(
      compareModal
    );

    const money = (
      value,
      currency = 'BRL'
    ) => {
      if (
        !Number.isFinite(
          Number(value)
        ) ||
        Number(value) <= 0
      ) {
        return '—';
      }

      try {
        return new Intl.NumberFormat(
          'pt-BR',
          {
            style: 'currency',
            currency
          }
        )
          .format(
            Number(value)
          );

      } catch (error) {
        return `R$ ${Number(value)
          .toFixed(2)
          .replace('.', ',')}`;
      }
    };

    const renderCompareModal = () => {
      const grid =
        compareModal.querySelector(
          '[data-compare-grid]'
        );

      if (!grid) {
        return;
      }

      grid.innerHTML =
        compareRecords
          .map(
            (product) => {
              const laser =
                isLaserProduct(
                  product
                ) ||
                product.profile
                  ?.technique ===
                  'laser';

              return `
                <article
                  class="agfx__compare-card"
                  data-compare-card="${escapeHTML(product.id)}"
                >
                  <div class="agfx__compare-image">
                    <img
                      src="${escapeHTML(product.image)}"
                      alt="${escapeHTML(product.name)}"
                    >
                  </div>

                  <h4>
                    ${escapeHTML(product.name)}
                  </h4>

                  <div class="agfx__compare-meta">
                    ${escapeHTML(product.meta || product.productType || '')}
                  </div>

                  <div class="agfx__compare-table">
                    <div class="agfx__compare-row">
                      <span>Técnica</span>
                      <strong>
                        ${laser ? 'Laser' : 'Impressão'}
                      </strong>
                    </div>

                    <div class="agfx__compare-row">
                      <span>Pedido mínimo</span>
                      <strong>
                        ${Number(product.minimum || 1)} un.
                      </strong>
                    </div>

                    <div class="agfx__compare-row">
                      <span>Área</span>
                      <strong>
                        ${escapeHTML(product.profile?.zone || 'Frente')}
                      </strong>
                    </div>

                    <div class="agfx__compare-row">
                      <span>Produto</span>
                      <strong>
                        ${money(product.basePrice, product.currency)}
                      </strong>
                    </div>

                    <div class="agfx__compare-row">
                      <span>Personalização</span>
                      <strong>
                        ${
                          product.profile?.personalizationPrice
                            ? money(
                                product.profile.personalizationPrice,
                                product.currency
                              )
                            : 'Sob consulta'
                        }
                      </strong>
                    </div>
                  </div>

                  <button
                    type="button"
                    class="agfx__compare-use"
                    data-use-compare="${escapeHTML(product.id)}"
                  >
                    Personalizar este
                  </button>
                </article>
              `;
            }
          )
          .join('');

      grid
        .querySelectorAll(
          '[data-use-compare]'
        )
        .forEach(
          (button) => {
            button.addEventListener(
              'click',
              () => {
                const id =
                  button.getAttribute(
                    'data-use-compare'
                  );

                let target =
                  products.find(
                    (product) =>
                      String(
                        product.id
                      ) ===
                      String(id)
                  );

                if (!target) {
                  const snapshot =
                    compareRecords.find(
                      (product) =>
                        String(
                          product.id
                        ) ===
                        String(id)
                    );

                  if (snapshot) {
                    target = {
                      ...snapshot,
                      source:
                        'favorite-cache'
                    };

                    products.push(
                      target
                    );

                    renderShopifyProduct(
                      target
                    );
                  }
                }

                if (target) {
                  selectProduct(
                    target.id
                  );

                  compareModal.classList.remove(
                    'is-visible'
                  );

                  const targetButton =
                    getProductButton(
                      target.id
                    );

                  targetButton
                    ?.scrollIntoView({
                      behavior: 'smooth',
                      block: 'nearest'
                    });

                  track(
                    'compare_choose'
                  );
                }
              }
            );
          }
        );
    };

    const updateCompareTray = () => {
      const count =
        compareRecords.length;

      compareTray.classList.toggle(
        'is-visible',
        count > 0
      );

      const subtitle =
        compareTray.querySelector(
          '[data-compare-subtitle]'
        );

      if (subtitle) {
        subtitle.textContent =
          `${count} ${
            count === 1
              ? 'produto selecionado'
              : 'produtos selecionados'
          }`;
      }
    };

    compareTray
      .querySelector(
        '[data-clear-compare]'
      )
      ?.addEventListener(
        'click',
        () => {
          compareRecords = [];

          saveJSONStorage(
            compareStorageKey,
            compareRecords
          );

          refreshProductActionUI();
          updateCompareTray();
          updateStudioStatus();

          track(
            'compare_clear'
          );
        }
      );

    compareTray
      .querySelector(
        '[data-open-compare]'
      )
      ?.addEventListener(
        'click',
        () => {
          if (
            compareRecords.length <
            2
          ) {
            showToast(
              'Selecione pelo menos 2 produtos'
            );

            return;
          }

          renderCompareModal();

          compareModal.classList.add(
            'is-visible'
          );

          track(
            'compare_open',
            {
              count:
                compareRecords.length
            }
          );
        }
      );

    compareModal
      .querySelector(
        '[data-close-compare]'
      )
      ?.addEventListener(
        'click',
        () => {
          compareModal.classList.remove(
            'is-visible'
          );
        }
      );

    compareModal.addEventListener(
      'click',
      (event) => {
        if (
          event.target ===
          compareModal
        ) {
          compareModal.classList.remove(
            'is-visible'
          );
        }
      }
    );

    updateCompareTray();
    updateStudioStatus();

    /* ========================================================
       GERAR PRÉVIA
       ======================================================== */

    async function generate(
      download = true
    ) {
      if (
        !logoLoaded ||
        logoCanvas
          .classList
          .contains(
            'is-hidden'
          )
      ) {
        alert(
          'Carregue sua logo primeiro.'
        );

        return null;
      }

      if (
        typeof html2canvas !==
        'function'
      ) {
        alert(
          'Atualize a página e tente novamente.'
        );

        return null;
      }

      const hadGuides =
        els.capture
          ?.classList
          .contains(
            'has-guides'
          );

      const hadSafe =
        els.capture
          ?.classList
          .contains(
            'has-safe'
          );

      const captureTransform =
        els.capture?.style.transform ||
        '';

      if (els.capture) {
        els.capture.style.transform =
          'none';
      }

      els.capture
        ?.classList
        .remove(
          'has-guides',
          'has-safe'
        );

      try {
        const canvas =
          await html2canvas(
            els.capture,
            {
              useCORS: true,
              allowTaint: false,
              backgroundColor: null,
              scale: 2,
              logging: false
            }
          );

        previewGenerated =
          true;

        updateCommercialUI();

        if (
          download &&
          active
        ) {
          const link =
            document.createElement(
              'a'
            );

          link.download =
            `${projectId.toLowerCase()}-previa-${active.name
              .toLowerCase()
              .replace(
                /[^a-z0-9]+/gi,
                '-'
              )}.png`;

          link.href =
            canvas.toDataURL(
              'image/png'
            );

          link.click();
        }

        return canvas;

      } catch (error) {
        console.error(
          error
        );

        alert(
          'Não foi possível gerar a prévia.'
        );

        return null;

      } finally {
        if (els.capture) {
          els.capture.style.transform =
            captureTransform;
        }

        if (hadGuides) {
          els.capture
            ?.classList
            .add(
              'has-guides'
            );
        }

        if (hadSafe) {
          els.capture
            ?.classList
            .add(
              'has-safe'
            );
        }
      }
    }

    if (printProjectButton) {
      printProjectButton.onclick =
        async () => {
          const canvas =
            await generate(
              false
            );

          if (!canvas) return;

          const preview =
            canvas.toDataURL(
              'image/png'
            );

          const sheet =
            window.open(
              '',
              '_blank'
            );

          if (!sheet) {
            alert(
              'Permita pop-ups para gerar a ficha do projeto.'
            );

            return;
          }

          const technique =
            laserEnabled
              ? 'Gravação a laser'
              : (
                  isGlassProduct(active)
                    ? `Impressão ${
                        printInkMode === 'white'
                          ? 'branca'
                          : (
                              printInkMode === 'black'
                                ? 'preta'
                                : 'colorida'
                            )
                      }`
                    : 'Impressão / serigrafia'
                );

          sheet.document.write(`
            <!doctype html>
            <html lang="pt-BR">
              <head>
                <meta charset="utf-8">
                <title>Ficha do Projeto - A Gourmet</title>

                <style>
                  body{
                    margin:0;
                    padding:32px;
                    color:#1e2c27;
                    font-family:Arial,sans-serif;
                    background:#fff;
                  }

                  .wrap{
                    max-width:900px;
                    margin:auto;
                  }

                  h1{
                    margin:0;
                    font-size:28px;
                  }

                  .muted{
                    color:#6d746f;
                  }

                  .grid{
                    margin-top:24px;
                    display:grid;
                    grid-template-columns:1.15fr .85fr;
                    gap:28px;
                  }

                  img{
                    width:100%;
                    border:1px solid #ddd;
                    border-radius:14px;
                  }

                  .box{
                    padding:18px;
                    border:1px solid #ddd;
                    border-radius:14px;
                  }

                  .row{
                    padding:9px 0;
                    display:flex;
                    justify-content:space-between;
                    gap:18px;
                    border-bottom:1px solid #eee;
                  }

                  .row:last-child{
                    border-bottom:0;
                  }

                  strong{
                    text-align:right;
                  }

                  @media print{
                    body{
                      padding:0;
                    }
                  }
                </style>
              </head>

              <body>
                <div class="wrap">
                  <h1>
                    A Gourmet Studio
                  </h1>

                  <p class="muted">
                    Projeto ${projectId} · Ficha de referência para personalização
                  </p>

                  <div class="grid">
                    <div>
                      <img
                        src="${preview}"
                        alt="Prévia do projeto"
                      >
                    </div>

                    <div class="box">
                      <div class="row">
                        <span>Projeto</span>
                        <strong>
                          ${projectId}
                        </strong>
                      </div>

                      <div class="row">
                        <span>Produto</span>
                        <strong>
                          ${escapeHTML(active?.name || '—')}
                        </strong>
                      </div>

                      <div class="row">
                        <span>Técnica</span>
                        <strong>
                          ${technique}
                        </strong>
                      </div>

                      <div class="row">
                        <span>Quantidade</span>
                        <strong>
                          ${escapeHTML(String(els.qty?.value || '—'))} un.
                        </strong>
                      </div>

                      <div class="row">
                        <span>Posição</span>
                        <strong>
                          ${escapeHTML(els.position?.value || '—')}
                        </strong>
                      </div>

                      <div class="row">
                        <span>Qualidade da arte</span>
                        <strong>
                          ${escapeHTML(logoQuality.label)}
                        </strong>
                      </div>

                      <div class="row">
                        <span>Texto</span>
                        <strong>
                          ${escapeHTML(textState.value || 'Não adicionado')}
                        </strong>
                      </div>
                    </div>
                  </div>

                  <p class="muted">
                    Esta ficha é uma simulação visual. A arte final será validada pela equipe A Gourmet antes da produção.
                  </p>
                </div>

                <script>
                  window.onload = () => {
                    window.print();
                  };
                <\/script>
              </body>
            </html>
          `);

          sheet.document.close();

          track(
            'project_print'
          );
        };
    }

    /* ========================================================
       DOWNLOAD
       ======================================================== */

    const exportButton =
      root.querySelector(
        '[data-export]'
      );

    if (exportButton) {
      exportButton.onclick =
        async (event) => {
          const button =
            event.currentTarget;

          const original =
            button.textContent;

          button.disabled =
            true;

          button.textContent =
            'Gerando...';

          await generate(true);

          track(
            'preview_download'
          );

          button.disabled =
            false;

          button.textContent =
            original;
        };
    }

    /* ========================================================
       WHATSAPP
       ======================================================== */

    const whatsappButton =
      root.querySelector(
        '[data-whatsapp]'
      );

    if (whatsappButton) {
      whatsappButton.textContent =
        'Solicitar orçamento';

      whatsappButton.onclick =
        () => {
          if (!whatsapp) {
            alert(
              'Configure o WhatsApp na seção.'
            );

            return;
          }

          if (!active) {
            alert(
              'Selecione um produto.'
            );

            return;
          }

          if (
            !logoLoaded ||
            logoCanvas
              .classList
              .contains(
                'is-hidden'
              )
          ) {
            alert(
              'Carregue sua logo primeiro.'
            );

            return;
          }

          const quantity =
            Math.max(
              Number(
                els.qty?.value
              ) || 0,

              active.minimum || 1
            );

          if (els.qty) {
            els.qty.value =
              quantity;
          }

          updateSummary();

          const message = [
            'Olá! Criei um projeto no A Gourmet Studio.',
            '',
            `Projeto: ${projectId}`,
            `Produto: ${active.name}`,
            `Informações: ${active.meta || '-'}`,
            `Quantidade: ${quantity} unidades`,
            `Posição: ${els.position?.value || '-'}`,
            `Escala: ${Math.round(state.s * 100)}%`,
            `Rotação: ${Math.round(state.r)}°`,
            `Curvatura: ${Math.round(state.c)}`,
            `Técnica: ${
              laserEnabled
                ? 'Gravação a laser em aço inox'
                : (
                    isGlassProduct(active)
                      ? `Impressão ${
                          printInkMode === 'white'
                            ? 'branca'
                            : (
                                printInkMode === 'black'
                                  ? 'preta'
                                  : 'colorida'
                              )
                        }`
                      : 'Impressão / serigrafia'
                  )
            }`,
            `Realismo: ${realismEnabled ? 'Ativado' : 'Desativado'}`,
            `Prévia baixada: ${previewGenerated ? 'Sim' : 'Não'}`,
            '',
            'Gostaria de receber um orçamento.'
          ].join('\n');

          quoteRequested =
            true;

          commercialProjectTouched =
            true;

          updateCommercialUI();

          track(
            'quote_click',
            {
              project_id:
                projectId,

              quantity,
              position:
                els.position?.value ||
                null
            }
          );

          window.open(
            `https://wa.me/${whatsapp}?text=${encodeURIComponent(message)}`,
            '_blank',
            'noopener'
          );
        };
    }

    /* ========================================================
       V5.15 — ESTRUTURA FINAL DO PAINEL DIREITO
       ======================================================== */

    const setupRightPanelV515 = () => {
      const footer =
        root.querySelector(
          '.agfx__footer'
        );

      const panel =
        footer
          ?.closest(
            '.agfx__panel'
          ) ||
        els.title
          ?.closest(
            '.agfx__panel'
          ) ||
        root.querySelector(
          '.agfx__panel'
        );

      if (
        !panel ||
        !footer ||
        panel.querySelector(
          ':scope > .agfx__panel-scroll'
        )
      ) {
        return;
      }

      const scrollArea =
        document.createElement(
          'div'
        );

      scrollArea.className =
        'agfx__panel-scroll';

      scrollArea.setAttribute(
        'data-panel-scroll',
        ''
      );

      /*
       * Move tudo que já existe no painel para a área rolável,
       * com exceção do rodapé de CTAs.
       */
      Array.from(
        panel.children
      )
        .filter(
          (child) =>
            child !== footer
        )
        .forEach(
          (child) => {
            scrollArea.appendChild(
              child
            );
          }
        );

      panel.insertBefore(
        scrollArea,
        footer
      );

      panel.classList.add(
        'agfx__panel--v515'
      );

      /*
       * Ao trocar de produto, volta o painel ao topo.
       * Mantém a experiência previsível sem afetar o scroll da página.
       */
      const observer =
        new MutationObserver(
          (mutations) => {
            const changedTitle =
              mutations.some(
                (mutation) =>
                  mutation.target ===
                    els.title ||
                  mutation.target.parentElement ===
                    els.title
              );

            if (changedTitle) {
              scrollArea.scrollTo({
                top: 0,
                behavior: 'smooth'
              });
            }
          }
        );

      if (els.title) {
        observer.observe(
          els.title,
          {
            childList: true,
            subtree: true,
            characterData: true
          }
        );
      }
    };

    setupRightPanelV515();

    /* ========================================================
       INICIALIZAÇÃO
       ======================================================== */

    active = null;
    currentCategory = 'all';

    if (
      pendingProject?.productName &&
      els.search
    ) {
      currentSearch =
        pendingProject.productName;

      els.search.value =
        pendingProject.productName;
    }

    els.categoryButtons.forEach(
      (button) => {
        button.classList.toggle(
          'is-active',
          button.dataset.category === 'all'
        );
      }
    );

    if (els.title) {
      els.title.textContent =
        'Carregando produtos...';
    }

    if (els.meta) {
      els.meta.textContent =
        'Produtos personalizáveis A Gourmet';
    }

    if (els.sumProduct) {
      els.sumProduct.textContent =
        '—';
    }

    if (els.sumQty) {
      els.sumQty.textContent =
        '—';
    }

    if (els.sumPosition) {
      els.sumPosition.textContent =
        'Centro';
    }

    if (els.base) {
      els.base.removeAttribute('src');
      els.base.alt = '';
    }

    updateCommercialUI();
    pushHistory();

    track(
      'open',
      {
        project_id:
          projectId
      }
    );

    fetchCategoryCounts({
      force: true
    });

    fetchShopifyProducts({
      reset: true
    });
  });
})();
(() => {
  const STYLE_ID = 'agfx-v518-premium-styles';

  const injectStyles = () => {
    if (document.getElementById(STYLE_ID)) return;
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__stage-wrap {
        padding: 18px 18px 76px !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__capture {
        border-radius: 28px !important;
        box-shadow: 0 20px 52px rgba(22,54,47,.10) !important;
        background: linear-gradient(180deg,#ffffff 0%,#fbfcfb 100%) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium [data-placeholder] {
        width: 98px !important;
        height: 98px !important;
        border: 1px dashed rgba(22,54,47,.16) !important;
        background: rgba(255,255,255,.74) !important;
        box-shadow: 0 10px 24px rgba(22,54,47,.08) !important;
        backdrop-filter: blur(2px);
        -webkit-backdrop-filter: blur(2px);
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium [data-placeholder] * {
        font-size: 8px !important;
        letter-spacing: .03em !important;
        color: rgba(22,54,47,.55) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__zoom {
        padding: 6px !important;
        border-color: rgba(22,54,47,.08) !important;
        box-shadow: 0 14px 32px rgba(22,54,47,.12) !important;
        background: rgba(255,255,255,.94) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__zoom-fit {
        padding: 0 14px !important;
        min-height: 34px !important;
        border-radius: 999px !important;
        background: linear-gradient(180deg,#ffffff 0%,#f4f7f5 100%) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__panel,
      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__panel.agfx__panel--v515 {
        padding: 12px !important;
        background: linear-gradient(180deg,#ffffff 0%,#fbfcfb 100%) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__panel-scroll {
        padding-right: 2px !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__commercial {
        margin-bottom: 14px !important;
        padding: 12px !important;
        border: 1px solid rgba(22,54,47,.08) !important;
        border-radius: 16px !important;
        background: linear-gradient(135deg,#fbfcfb 0%,#f4f8f5 100%) !important;
        box-shadow: 0 10px 24px rgba(22,54,47,.06) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__commercial-id {
        font-size: 11px !important;
        letter-spacing: .02em !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__commercial-status {
        padding: 6px 10px !important;
        font-size: 6.8px !important;
        border: 1px solid rgba(22,54,47,.06) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__progress {
        gap: 6px !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__progress-step {
        min-height: 34px !important;
        padding: 7px 6px !important;
        border-radius: 10px !important;
        font-size: 6.8px !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__progress-number {
        width: 18px !important;
        height: 18px !important;
        flex-basis: 18px !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__section-heading {
        margin-top: 14px !important;
        margin-bottom: 8px !important;
        color: #51605a !important;
        letter-spacing: .08em !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__box,
      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__pro-tools,
      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__summary,
      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__technique-card,
      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__visual-group {
        border-radius: 14px !important;
        border-color: rgba(22,54,47,.08) !important;
        box-shadow: 0 8px 18px rgba(22,54,47,.04) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium [data-upload] {
        min-height: 48px !important;
        border-radius: 14px !important;
        box-shadow: 0 14px 30px rgba(22,54,47,.18) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium [data-download],
      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium [data-whatsapp] {
        min-height: 46px !important;
        border-radius: 14px !important;
        font-size: 11px !important;
        font-weight: 900 !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium [data-download] {
        box-shadow: 0 10px 24px rgba(200,155,89,.16) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium [data-whatsapp] {
        box-shadow: 0 16px 30px rgba(42,139,97,.18) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__product {
        transition: transform .18s ease, box-shadow .18s ease, border-color .18s ease, background .18s ease !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__product:hover {
        transform: translateY(-1px);
        box-shadow: 0 12px 24px rgba(22,54,47,.07) !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__product-action {
        width: 32px !important;
        height: 32px !important;
        border-radius: 10px !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__product-info strong {
        font-size: 11px !important;
        line-height: 1.28 !important;
      }

      body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium [data-title] {
        letter-spacing: -.02em;
      }

      @media (min-width: 1500px) {
        body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__app {
          grid-template-columns: 295px minmax(0,1fr) 380px !important;
        }
      }

      @media (max-width: 650px) {
        body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium .agfx__stage-wrap {
          padding: 14px 10px 84px !important;
        }

        body.agfx-wokiee-studio-page [data-agfx].agfx--v518-premium [data-placeholder] {
          width: 82px !important;
          height: 82px !important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const textIf = (el, text) => {
    if (el && el.textContent && el.textContent.trim() !== text) {
      el.textContent = text;
    }
  };

  const parseZoom = (root) => {
    const label = root.querySelector('[data-zoom-value]');
    if (!label) return null;
    const num = parseInt((label.textContent || '').replace(/[^0-9]/g, ''), 10);
    return Number.isFinite(num) ? num : null;
  };

  const boostZoom = (root) => {
    if (!root || root.dataset.v518Boosting === '1') return;
    const current = parseZoom(root);
    if (current !== null && current >= 104) return;
    const zoomIn = root.querySelector('[data-zoom-in]');
    if (!zoomIn) return;
    root.dataset.v518Boosting = '1';
    zoomIn.click();
    setTimeout(() => {
      root.dataset.v518Boosting = '0';
    }, 250);
  };

  const enhance = (root) => {
    if (!root || root.dataset.v518Ready === '1') return;
    root.dataset.v518Ready = '1';
    root.classList.add('agfx--v518-premium');

    const download = root.querySelector('[data-download]');
    const whatsapp = root.querySelector('[data-whatsapp]');
    const upload = root.querySelector('[data-upload]');

    textIf(download, 'Baixar prévia');
    textIf(whatsapp, 'Solicitar orçamento deste projeto');
    textIf(upload, 'Carregar minha logo');

    setTimeout(() => boostZoom(root), 450);

    root.addEventListener('click', (event) => {
      const product = event.target.closest('.agfx__product');
      if (product) {
        setTimeout(() => boostZoom(root), 260);
      }
    });

    const title = root.querySelector('[data-title]');
    if (title) {
      const obs = new MutationObserver(() => {
        setTimeout(() => boostZoom(root), 260);
      });
      obs.observe(title, {
        characterData: true,
        childList: true,
        subtree: true
      });
    }
  };

  const boot = () => {
    injectStyles();
    document.querySelectorAll('[data-agfx]').forEach(enhance);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  const observer = new MutationObserver(() => boot());
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
